/* eslint-disable @typescript-eslint/no-namespace,@typescript-eslint/ban-types,@typescript-eslint/no-unnecessary-type-constraint,prettier/prettier */
// noinspection JSUnusedGlobalSymbols,GrazieInspection,SpellCheckingInspection

import { FileValue } from '@/shared/api/utils/toFormData'
import { HttpClient, ContentType, RequestParams } from '@/shared/api/utils/HttpClient'

/** AddAgentCommentDto */
export interface AddAgentCommentDto {
  /** Unit Id */
  unit_id: number
  /** Collection Id */
  collection_id: number
  /** User Id */
  user_id: number
  /** Agent Comment */
  agent_comment: string
}

/** AddClientAction */
export interface AddClientAction {
  /** Contact Id */
  contact_id: number
  /** Comment */
  comment: string
}

/** Address */
export interface Address {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Formatted
   * @maxLength 255
   */
  formatted: string
  /**
   * Gid
   * @maxLength 63
   */
  gid: string
  /** Loc */
  loc?: any[] | null
  /** Lat */
  lat?: number | null
  /** Lng */
  lng?: number | null
  /** Street Number */
  street_number?: string | null
  /** Route */
  route?: string | null
  /** Locality */
  locality?: string | null
  /** Administrative Area Level 2 */
  administrative_area_level_2?: string | null
  /**
   * Administrative Area Level 1
   * @maxLength 63
   */
  administrative_area_level_1: string
  /**
   * Country
   * @maxLength 63
   */
  country: string
  /**
   * Postal Code
   * @maxLength 31
   */
  postal_code: string
  /**
   * Plus Code
   * @maxLength 31
   */
  plus_code: string
  /** Emlak Id */
  emlak_id: number | null
  /** City Slug */
  city_slug?: string | null
  /** District Slug */
  district_slug?: string | null
  /** Residential */
  residential: TortoiseContribPydanticCreatorModelsResidentialLeaf[]
}

/** AddressIn */
export interface AddressIn {
  /**
   * Formatted
   * @maxLength 255
   */
  formatted: string
  /**
   * Gid
   * @maxLength 63
   */
  gid: string
  /** Loc */
  loc?: any[] | null
  /** Lat */
  lat?: number | null
  /** Lng */
  lng?: number | null
  /** Street Number */
  street_number?: string | null
  /** Route */
  route?: string | null
  /** Locality */
  locality?: string | null
  /** Administrative Area Level 2 */
  administrative_area_level_2?: string | null
  /**
   * Administrative Area Level 1
   * @maxLength 63
   */
  administrative_area_level_1: string
  /**
   * Country
   * @maxLength 63
   */
  country: string
  /**
   * Postal Code
   * @maxLength 31
   */
  postal_code: string
  /**
   * Plus Code
   * @maxLength 31
   */
  plus_code: string
  /** Emlak Id */
  emlak_id?: number | null
  /** City Slug */
  city_slug?: string | null
  /** District Slug */
  district_slug?: string | null
}

/** AddressList */
export interface AddressList {
  /**
   * Data
   * @default []
   */
  data?: AddressListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** AddressListItem */
export interface AddressListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Formatted
   * @maxLength 255
   */
  formatted: string
  /**
   * Gid
   * @maxLength 63
   */
  gid: string
  /** Loc */
  loc?: any[] | null
  /** Lat */
  lat?: number | null
  /** Lng */
  lng?: number | null
  /** Street Number */
  street_number?: string | null
  /** Route */
  route?: string | null
  /** Locality */
  locality?: string | null
  /** Administrative Area Level 2 */
  administrative_area_level_2?: string | null
  /**
   * Administrative Area Level 1
   * @maxLength 63
   */
  administrative_area_level_1: string
  /**
   * Country
   * @maxLength 63
   */
  country: string
  /**
   * Postal Code
   * @maxLength 31
   */
  postal_code: string
  /**
   * Plus Code
   * @maxLength 31
   */
  plus_code: string
  /** Emlak Id */
  emlak_id: number | null
  /** City Slug */
  city_slug?: string | null
  /** District Slug */
  district_slug?: string | null
  /** Residential */
  residential: TortoiseContribPydanticCreatorModelsResidentialLeaf[]
}

/** AddressSuggest */
export interface AddressSuggest {
  /** Id */
  id: string
  /** Text */
  text: string
}

/** AddressSuggestions */
export interface AddressSuggestions {
  /** Results */
  results: AddressSuggest[]
}

/** AmenityType */
export enum AmenityType {
  Unit = 'unit',
  Residential = 'residential',
}

/** AppointmentType */
export enum AppointmentType {
  Online = 1,
  Offline = 2,
}

/** AuthGoogle */
export interface AuthGoogle {
  /** Credential */
  credential: string
  /** Offer Id */
  offer_id: number | null
  /** Lang */
  lang: string | null
  /** @default 2 */
  role?: AuthUserRole1 | null
  /** Utm Data */
  utm_data?: object | null
  /** Third Party */
  third_party?: object | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
}

/** Body_add_amenity_photo_photo_Amenity__oid__post */
export interface BodyAddAmenityPhotoPhotoAmenityOidPost {
  /**
   * File
   * @format binary
   */
  file: FileValue
  type: AmenityType
}

/** Body_order_file_upload_photo_Order__oid__photo_upload_post */
export interface BodyOrderFileUploadPhotoOrderOidPhotoUploadPost {
  /**
   * File
   * @format binary
   */
  file: FileValue
}

/** Body_photos_upload_photo_post */
export interface BodyPhotosUploadPhotoPost {
  /**
   * File
   * @format binary
   */
  file: FileValue
}

/** Body_promotion_photo_update_photo_Promotion__id__post */
export interface BodyPromotionPhotoUpdatePhotoPromotionIdPost {
  /**
   * File
   * @format binary
   */
  file: FileValue
}

/** Body_update_user_photos_User_photo_upload__type___uid__post */
export interface BodyUpdateUserPhotosUserPhotoUploadTypeUidPost {
  /**
   * File
   * @format binary
   */
  file: FileValue
}

/** Body_webinar_photo_update_photo_Webinar__id__post */
export interface BodyWebinarPhotoUpdatePhotoWebinarIdPost {
  /**
   * File
   * @format binary
   */
  file: FileValue
}

/** Building */
export interface Building {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  residential: ResidentialPfrrzy
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsBuildingTranslationLeaf[]
  /** Units */
  units: UnitRledil[]
  /** Photos */
  photos?: Record<string, number>[] | null
}

/** BuildingIn */
export interface BuildingIn {
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year?: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id?: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** BuildingList */
export interface BuildingList {
  /**
   * Data
   * @default []
   */
  data?: BuildingListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** BuildingListItem */
export interface BuildingListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  residential: ResidentialMp6K5P
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsBuildingTranslationLeaf[]
  /** Units */
  units: UnitRledil[]
  /** Photos */
  photos?: Record<string, number>[] | null
}

/** BuildingTranslation */
export interface BuildingTranslation {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  building: TortoiseContribPydanticCreatorModelsBuildingLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** BuildingTranslationIn */
export interface BuildingTranslationIn {
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Building Id
   * @min -2147483648
   * @max 2147483647
   */
  building_id: number
}

/** BuildingTranslationList */
export interface BuildingTranslationList {
  /**
   * Data
   * @default []
   */
  data?: BuildingTranslationListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** BuildingTranslationListItem */
export interface BuildingTranslationListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  building: TortoiseContribPydanticCreatorModelsBuildingLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Building Id
   * @min -2147483648
   * @max 2147483647
   */
  building_id: number
}

/** Building */
export interface Building4Zv2Va {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsBuildingTranslationLeaf[]
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
}

/** Building */
export interface Building53Dmcg {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsBuildingTranslationLeaf[]
  /** Units */
  units: Unit6Z5Wak[]
}

/** Building */
export interface BuildingJlld4T {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  residential: ResidentialFyglon
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsBuildingTranslationLeaf[]
}

/** Building */
export interface BuildingKzqyqb {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsBuildingTranslationLeaf[]
  /** Units */
  units: UnitIdj4Ef[]
}

/** Building */
export interface BuildingL2Eyox {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  residential: TortoiseContribPydanticCreatorModelsResidentialLeaf
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsBuildingTranslationLeaf[]
}

/** Building */
export interface BuildingSqejo3 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  residential: ResidentialXrjntg
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsBuildingTranslationLeaf[]
}

/** Building */
export interface BuildingTkqcfw {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  residential: TortoiseContribPydanticCreatorModelsResidentialLeaf
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsBuildingTranslationLeaf[]
}

/** Building */
export interface BuildingUwewtm {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsBuildingTranslationLeaf[]
  /** Units */
  units: UnitS237Cf[]
}

/** ChangePersonalManagerDto */
export interface ChangePersonalManagerDto {
  /** User Id */
  user_id: number
}

/** ChangePwdBody */
export interface ChangePwdBody {
  /** Password */
  password: string
}

/** Class */
export enum Class {
  Normal = 1,
  Business = 2,
  Luxury = 3,
}

/**
 * ClientType
 * @default 1
 */
export enum ClientType {
  Local = 1,
  International = 2,
}

/** Collection */
export interface Collection {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
}

/** CollectionIn */
export interface CollectionIn {
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Units */
  units?: number[] | null
}

/** CollectionList */
export interface CollectionList {
  /**
   * Data
   * @default []
   */
  data?: CollectionListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** CollectionListItem */
export interface CollectionListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  user: UserPwefns
  /** Units */
  units: UnitIfqg6W[]
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Collection */
export interface Collection2Xszo4 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** Collection */
export interface Collection4Eaqo6 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** Collection */
export interface CollectionB3P2D3 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** Collection */
export interface CollectionFjpviy {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** Collection */
export interface CollectionOlzb7T {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** Collection */
export interface CollectionPgcpju {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
}

/** Collection */
export interface CollectionRycztj {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Units */
  units: UnitGddxzh[]
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Quiz */
  quiz: Quiz2Zo6Z6[]
}

/** Collection */
export interface CollectionTndb2J {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Collection */
export interface CollectionUmu7Bq {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** Collection */
export interface CollectionV34Mu3 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Units */
  units: UnitAnb3Zo[]
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Quiz */
  quiz: QuizNsmyk2[]
}

/** Collection */
export interface CollectionYydmvv {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** Collection */
export interface CollectionZf5Gts {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** Collection */
export interface CollectionZutzcj {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Company */
export interface Company {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /** Responsible */
  responsible: TortoiseContribPydanticCreatorAuthUserLeaf
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
  /** Residentials */
  residentials: TortoiseContribPydanticCreatorModelsResidentialLeaf[]
}

/** CompanyIn */
export interface CompanyIn {
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
}

/** CompanyList */
export interface CompanyList {
  /**
   * Data
   * @default []
   */
  data?: CompanyListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** CompanyListItem */
export interface CompanyListItem {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /** Responsible */
  responsible: TortoiseContribPydanticCreatorAuthUserLeaf
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
  /** Residentials */
  residentials: ResidentialG2P3Th[]
  /** Photo */
  photo?: string | null
}

/** CompanyTranslation */
export interface CompanyTranslation {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  company: TortoiseContribPydanticCreatorModelsCompanyLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** CompanyTranslationIn */
export interface CompanyTranslationIn {
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
}

/** CompanyTranslationList */
export interface CompanyTranslationList {
  /**
   * Data
   * @default []
   */
  data?: CompanyTranslationListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** CompanyTranslationListItem */
export interface CompanyTranslationListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  company: TortoiseContribPydanticCreatorModelsCompanyLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
}

/** CompanyType */
export enum CompanyType {
  Agency = 1,
  Developer = 2,
}

/** Company */
export interface Company4Bkzii {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /** Responsible */
  responsible: TortoiseContribPydanticCreatorAuthUserLeaf
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
}

/** Company */
export interface CompanyEhrt3R {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
}

/** Company */
export interface CompanyGwtedv {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
}

/** Company */
export interface CompanyHjogan {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
}

/** Company */
export interface CompanyKlr2Sr {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
}

/** Company */
export interface CompanyMrwhgx {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
}

/** Company */
export interface CompanyRhznc5 {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
}

/** Company */
export interface CompanyXsestn {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /** Responsible */
  responsible: UserNqjhhu
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
}

/** Company */
export interface CompanyXsklya {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
}

/** Company */
export interface CompanyZpnp7L {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Responsible Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  responsible_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf[]
}

/** Condition */
export enum Condition {
  Furnished = 1,
  Finished = 2,
}

/** Contact */
export interface Contact {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User */
  user: TortoiseContribPydanticCreatorAuthUserLeaf | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** ContactIn */
export interface ContactIn {
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
}

/** ContactList */
export interface ContactList {
  /**
   * Data
   * @default []
   */
  data?: ContactListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** ContactListItem */
export interface ContactListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User */
  user: TortoiseContribPydanticCreatorAuthUserLeaf | null
  /** User Id */
  user_id?: number | null
}

/** ContactTitle */
export enum ContactTitle {
  Mr = 1,
  Ms = 2,
  Mis = 3,
  Dr = 4,
}

/** Contact */
export interface Contact3Vqily {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** Contact */
export interface ContactDzpw6W {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** Contact */
export interface ContactHl2Bmu {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** Contact */
export interface ContactLufwyf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** Contact */
export interface ContactNwydiw {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** Contact */
export interface ContactOwwawm {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: Quiz7E2Xvn[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** Contact */
export interface ContactOyjnkb {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: QuizFzu7Ch[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** Contact */
export interface ContactP4F6Wp {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** Contact */
export interface ContactPdm4Ty {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** Contact */
export interface ContactPt4Dm2 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** Contact */
export interface ContactRflxc7 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** Contact */
export interface ContactRo5Skv {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User */
  user: UserYddl3U | null
  /** User Id */
  user_id?: number | null
  /** Quiz */
  quiz: QuizByvzja[]
  /** User Actions Log */
  user_actions_log: UserActionsLogCmyntr[]
}

/** Contact */
export interface ContactW3Cne2 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** Contact */
export interface ContactWo67Xp {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** Contact */
export interface ContactZ3Og4L {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
  /** User Id */
  user_id?: number | null
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
}

/** CreateQuizAction */
export interface CreateQuizAction {
  /** Quiz Id */
  quiz_id: number
}

/** Currency */
export enum Currency {
  USD = 1,
  EUR = 2,
  TRY = 3,
}

/** DeletePhotosDto */
export interface DeletePhotosDto {
  /** Id */
  id: number
  /** Owner Id */
  owner_id: number
}

/** DeletePriceBody */
export interface DeletePriceBody {
  /** Price Id */
  price_id: number
}

/** EmailsLog */
export interface EmailsLog {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Mail Id
   * @maxLength 255
   */
  mail_id: string
  /**
   * Email
   * @maxLength 255
   */
  email: string
  /**
   * Status
   * @maxLength 255
   */
  status: string
  /**
   * Template
   * @maxLength 255
   */
  template: string
  /** User */
  user: TortoiseContribPydanticCreatorAuthUserLeaf | null
}

/** EmailsLogIn */
export interface EmailsLogIn {
  /**
   * Mail Id
   * @maxLength 255
   */
  mail_id: string
  /**
   * Email
   * @maxLength 255
   */
  email: string
  /**
   * Status
   * @maxLength 255
   */
  status: string
  /**
   * Template
   * @maxLength 255
   */
  template: string
  /** User Id */
  user_id?: number | null
}

/** EmailsLogList */
export interface EmailsLogList {
  /**
   * Data
   * @default []
   */
  data?: EmailsLogListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** EmailsLogListItem */
export interface EmailsLogListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Mail Id
   * @maxLength 255
   */
  mail_id: string
  /**
   * Email
   * @maxLength 255
   */
  email: string
  /**
   * Status
   * @maxLength 255
   */
  status: string
  /**
   * Template
   * @maxLength 255
   */
  template: string
  /** User */
  user: TortoiseContribPydanticCreatorAuthUserLeaf | null
  /** User Id */
  user_id?: number | null
}

/** ErrorResponse */
export interface ErrorResponse {
  /** Error */
  error: string
}

/** EventTypes */
export enum EventTypes {
  Liked = 1,
  Scheduled = 2,
  Viewed = 3,
  LandingFormFeedback = 4,
  LandingFormInfo = 5,
  LandingViewed = 6,
}

/** FeeResponse */
export interface FeeResponse {
  /** Fee */
  fee: number
}

/** FeedbackForm */
export interface FeedbackForm {
  /** Name */
  name: string
  /** Email */
  email: string
  /** Subject */
  subject: string
  /** Message */
  message: string
}

/** GetLocationBody */
export interface GetLocationBody {
  /** Search */
  search: string
  /** Language */
  language: string
  /** Is Local */
  is_local: boolean
  /** Checked Manual */
  checked_manual?: boolean | null
}

/** GetResBody */
export interface GetResBody {
  /** Residential Hash */
  residential_hash: string
  /**
   * Required Currency
   * @default 1
   */
  required_currency?: number | null
  /**
   * Is Local
   * @default false
   */
  is_local?: boolean | null
  /** Language */
  language?: string | null
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[]
}

/** HeatingType */
export enum HeatingType {
  Central = 1,
  Gas = 2,
  Electric = 3,
}

/** InviteToTeam */
export interface InviteToTeam {
  /** Hash */
  hash: string
  /** Email */
  email: string
}

/** LandingData */
export interface LandingData {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Email */
  email?: string | null
  /** Residential Projects */
  residential_projects: any
  /** Avatar Url */
  avatar_url?: string | null
  /** Fullname */
  fullname?: string | null
  /** Description */
  description: string | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /** Socials */
  socials: any
  /**
   * Slug
   * @maxLength 255
   */
  slug: string
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /**
   * Is Published
   * @default true
   */
  is_published?: boolean | null
  /**
   * Ai Auto Project Selection
   * @default true
   */
  ai_auto_project_selection?: boolean | null
}

/** LandingDataIn */
export interface LandingDataIn {
  /** Email */
  email?: string | null
  /** Residential Projects */
  residential_projects?: any
  /** Avatar Url */
  avatar_url?: string | null
  /** Fullname */
  fullname?: string | null
  /** Description */
  description?: string | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /** Socials */
  socials?: any
  /**
   * Slug
   * @maxLength 255
   */
  slug: string
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /**
   * Is Published
   * @default true
   */
  is_published?: boolean | null
  /**
   * Ai Auto Project Selection
   * @default true
   */
  ai_auto_project_selection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** LandingDataList */
export interface LandingDataList {
  /**
   * Data
   * @default []
   */
  data?: LandingDataListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** LandingDataListItem */
export interface LandingDataListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Email */
  email?: string | null
  /** Residential Projects */
  residential_projects: any
  /** Avatar Url */
  avatar_url?: string | null
  /** Fullname */
  fullname?: string | null
  /** Description */
  description: string | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /** Socials */
  socials: any
  /**
   * Slug
   * @maxLength 255
   */
  slug: string
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /**
   * Is Published
   * @default true
   */
  is_published?: boolean | null
  /**
   * Ai Auto Project Selection
   * @default true
   */
  ai_auto_project_selection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** LandingForms */
export interface LandingForms {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Bedrooms */
  bedrooms?: string | null
  /** Client Name */
  client_name?: string | null
  /** Currency */
  currency?: string | null
  /** District */
  district?: string | null
  /** Phone */
  phone: number | null
  /** Price From */
  price_from: number | null
  /** Price To */
  price_to: number | null
  /**
   * Is Read
   * @default false
   */
  is_read?: boolean | null
  /** Residential Id */
  residential_id?: number | null
  /** Residential Name */
  residential_name?: string | null
  /**
   * Form Type
   * Feedback: 1<br/>Info: 2
   */
  form_type: 1 | 2
}

/** LandingFormsDto */
export interface LandingFormsDto {
  /** Client Name */
  client_name: string
  /** Phone */
  phone: number
  /** Email */
  email: string
  /** User Id */
  user_id: number
  /**
   * Price From
   * @default 0
   */
  price_from?: number | null
  /**
   * Price To
   * @default 0
   */
  price_to?: number | null
  /**
   * Currency
   * @default ""
   */
  currency?: string | null
  /**
   * Bedrooms
   * @default ""
   */
  bedrooms?: string | null
  /**
   * District
   * @default ""
   */
  district?: string | null
  form_type: ModelsLandingFormType2
  /** Residential Name */
  residential_name?: string | null
  /** Residential Id */
  residential_id?: number | null
}

/** LandingFormsIn */
export interface LandingFormsIn {
  /** Bedrooms */
  bedrooms?: string | null
  /** Client Name */
  client_name?: string | null
  /** Currency */
  currency?: string | null
  /** District */
  district?: string | null
  /** Phone */
  phone: number | null
  /** Price From */
  price_from: number | null
  /** Price To */
  price_to: number | null
  /**
   * Is Read
   * @default false
   */
  is_read?: boolean | null
  /** Residential Id */
  residential_id?: number | null
  /** Residential Name */
  residential_name?: string | null
  /**
   * Form Type
   * Feedback: 1<br/>Info: 2
   */
  form_type: 1 | 2
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** LandingFormsList */
export interface LandingFormsList {
  /**
   * Data
   * @default []
   */
  data?: LandingFormsListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** LandingFormsListItem */
export interface LandingFormsListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Bedrooms */
  bedrooms?: string | null
  /** Client Name */
  client_name?: string | null
  /** Currency */
  currency?: string | null
  /** District */
  district?: string | null
  /** Phone */
  phone: number | null
  /** Price From */
  price_from: number | null
  /** Price To */
  price_to: number | null
  /**
   * Is Read
   * @default false
   */
  is_read?: boolean | null
  /** Residential Id */
  residential_id?: number | null
  /** Residential Name */
  residential_name?: string | null
  /**
   * Form Type
   * Feedback: 1<br/>Info: 2
   */
  form_type: 1 | 2
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** LikeDto */
export interface LikeDto {
  /** Unit Id */
  unit_id: number
  /** Collection Id */
  collection_id: number
  /** User Id */
  user_id: number
  /** Liked */
  liked: boolean
}

/** ListArgs */
export interface ListArgs {
  /**
   * Limit
   * @default 100
   */
  limit?: number
  /**
   * Offset
   * @default 0
   */
  offset?: number
  /**
   * Sort
   * @default "-id"
   */
  sort?: string | null
  /** Q */
  q?: string | null
  [key: string]: any
}

/** LocationDict */
export interface LocationDict {
  /** Id */
  id: number
  /** Name */
  name: string
  /** Type */
  type: string
}

/** LocationsResult */
export interface LocationsResult {
  /** City */
  city: LocationDict[]
  /** District */
  district: LocationDict[]
  /** Residential */
  residential: ResidentialDict[]
}

/** LoginFormData */
export interface LoginFormData {
  /** Username */
  username: string
  /** Password */
  password?: string | null
  /** Google Id */
  google_id?: string | null
}

/** Macrozone */
export interface Macrozone {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Macrozone
   * @maxLength 100
   */
  macrozone: string
  /**
   * Side
   * @maxLength 50
   */
  side: string
  /** Districts */
  districts: string[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** MacrozoneIn */
export interface MacrozoneIn {
  /**
   * Macrozone
   * @maxLength 100
   */
  macrozone: string
  /**
   * Side
   * @maxLength 50
   */
  side: string
  /** Districts */
  districts: string[]
  /** Quiz */
  quiz?: number[] | null
}

/** MacrozoneList */
export interface MacrozoneList {
  /**
   * Data
   * @default []
   */
  data?: MacrozoneListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** MacrozoneListItem */
export interface MacrozoneListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Macrozone
   * @maxLength 100
   */
  macrozone: string
  /**
   * Side
   * @maxLength 50
   */
  side: string
  /** Districts */
  districts: string[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
}

/** MetricData */
export interface MetricData {
  /** Total */
  total: number
  /** Diff */
  diff: number | null
}

/** MetricsResponse */
export interface MetricsResponse {
  user_activities: UserActivities
  /** Sessions History */
  sessions_history: UsersSessionsHistory[]
}

/** ModelTypes */
export enum ModelTypes {
  Unit = 'unit',
  Residential = 'residential',
  Building = 'building',
  Company = 'company',
  ResidentialAmenity = 'residential_amenity',
  UnitAmenity = 'unit_amenity',
  Webinar = 'webinar',
}

/** Name */
export interface Name {
  /** Id */
  id: number
  /** Text */
  text: string
  /** Logo */
  logo?: string | null
  /** Selected */
  selected?: boolean | null
}

/** Names */
export interface Names {
  /** Results */
  results: Name[]
  pagination: Pagination
}

/** NotificationLog */
export interface NotificationLog {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Event Type
   * liked: 1<br/>scheduled: 2<br/>viewed: 3<br/>landing_form_feedback: 4<br/>landing_form_info: 5<br/>landing_viewed: 6
   */
  event_type: 1 | 2 | 3 | 4 | 5 | 6
  /**
   * Is Read
   * @default false
   */
  is_read?: boolean
  /** Object Link */
  object_link?: string | null
  /**
   * User Id
   * @min -2147483648
   * @max 2147483647
   */
  user_id: number
  /** Appointment Date */
  appointment_date?: string | null
  /**
   * Appointment Type
   * online: 1<br/>offline: 2
   */
  appointment_type?: 1 | 2 | null
  /** Landing Id */
  landing_id: number | null
}

/** NotificationLogIn */
export interface NotificationLogIn {
  /** Client Name */
  client_name?: string | null
  /**
   * Event Type
   * liked: 1<br/>scheduled: 2<br/>viewed: 3<br/>landing_form_feedback: 4<br/>landing_form_info: 5<br/>landing_viewed: 6
   */
  event_type: 1 | 2 | 3 | 4 | 5 | 6
  /**
   * Is Read
   * @default false
   */
  is_read?: boolean
  /** Object Link */
  object_link?: string | null
  /**
   * User Id
   * @min -2147483648
   * @max 2147483647
   */
  user_id: number
  /** Appointment Date */
  appointment_date?: string | null
  /**
   * Appointment Type
   * online: 1<br/>offline: 2
   */
  appointment_type?: 1 | 2 | null
  /** Landing Id */
  landing_id?: number | null
}

/** NotificationLogList */
export interface NotificationLogList {
  /**
   * Data
   * @default []
   */
  data?: NotificationLogListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** NotificationLogListItem */
export interface NotificationLogListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Event Type
   * liked: 1<br/>scheduled: 2<br/>viewed: 3<br/>landing_form_feedback: 4<br/>landing_form_info: 5<br/>landing_viewed: 6
   */
  event_type: 1 | 2 | 3 | 4 | 5 | 6
  /**
   * Is Read
   * @default false
   */
  is_read?: boolean
  /** Object Link */
  object_link?: string | null
  /**
   * User Id
   * @min -2147483648
   * @max 2147483647
   */
  user_id: number
  /** Appointment Date */
  appointment_date?: string | null
  /**
   * Appointment Type
   * online: 1<br/>offline: 2
   */
  appointment_type?: 1 | 2 | null
  /** Landing Id */
  landing_id: number | null
}

/** Offer */
export interface Offer {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Content */
  content: string
  /** Users */
  users: TortoiseContribPydanticCreatorAuthUserLeaf[]
}

/** OfferIn */
export interface OfferIn {
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Content */
  content: string
}

/** OfferList */
export interface OfferList {
  /**
   * Data
   * @default []
   */
  data?: OfferListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** OfferListItem */
export interface OfferListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Content */
  content: string
}

/** Order */
export interface Order {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  residential: TortoiseContribPydanticCreatorModelsResidentialLeaf
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Created By */
  created_by: TortoiseContribPydanticCreatorAuthUserLeaf
}

/** OrderIn */
export interface OrderIn {
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** OrderList */
export interface OrderList {
  /**
   * Data
   * @default []
   */
  data?: OrderListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** OrderListItem */
export interface OrderListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  residential: Residential7R2Eqm
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Created By */
  created_by: TortoiseContribPydanticCreatorAuthUserLeaf
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** OrderStatus */
export enum OrderStatus {
  ReservationPending = 1,
  ContractSigned = 2,
  PaymentMade = 3,
  CommissionDelivery = 4,
  DeclinedByDeveloper = 5,
  DeclinedByPlatform = 6,
  AppointmentSet = 7,
  ReservationConfirmed = 8,
  CommissionReceived = 9,
}

/** Order */
export interface OrderFj6Tlq {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  contact: Contact3Vqily
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Order */
export interface OrderGekht7 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Order */
export interface OrderMili7P {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  contact: ContactHl2Bmu
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Order */
export interface OrderPkgvkb {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  contact: ContactRo5Skv
  /** Created By */
  created_by: UserDrywye
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Order */
export interface OrderQmk3Fh {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Order */
export interface OrderSogas3 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Order */
export interface OrderVskt4A {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Order */
export interface OrderVymtbg {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Created By */
  created_by: TortoiseContribPydanticCreatorAuthUserLeaf
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Order */
export interface OrderZipmpl {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Pagination */
export interface Pagination {
  /** More */
  more: boolean
}

/** ParkingType */
export enum ParkingType {
  Underground = 1,
  Street = 2,
  No = 3,
}

/** PersonalOffer */
export interface PersonalOffer {
  /** Agent Name */
  agent_name: string
  /** Phone */
  phone: string
  /** Email */
  email: string
  /** Message */
  message: string
  /** Object Link */
  object_link: string
}

/** PresentationAction */
export enum PresentationAction {
  Add = 'add',
  Remove = 'remove',
}

/** Price */
export interface Price {
  /** Id */
  id?: number | null
  /** Is Local */
  is_local: boolean
  /** Currency */
  currency: number
  /** Price */
  price: number
  /** Unit Id */
  unit_id: number
  /** Main */
  main: boolean
}

/** PriceRequest */
export interface PriceRequest {
  /** Client Name */
  client_name: string
  /** Phone */
  phone: string
  /** Email */
  email: string
  /**
   * Comment
   * @default "Нет комментария"
   */
  comment?: string | null
  /** Object Name */
  object_name: string
  /** Object Link */
  object_link: string
}

/** Prices */
export interface Prices {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Is Local
   * Price for locals only
   * @default false
   */
  is_local?: boolean
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /**
   * Price
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price: number
  unit: TortoiseContribPydanticCreatorModelsUnitLeaf
  /**
   * Main
   * Main price
   * @default false
   */
  main?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /**
   * Parent Price Id
   * ID of the parent main price
   */
  parent_price_id: number | null
}

/** PricesBody */
export interface PricesBody {
  /** Prices */
  prices: Price[]
}

/** PricesIn */
export interface PricesIn {
  /**
   * Is Local
   * Price for locals only
   * @default false
   */
  is_local?: boolean
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /**
   * Price
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price: number
  /**
   * Main
   * Main price
   * @default false
   */
  main?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /**
   * Parent Price Id
   * ID of the parent main price
   */
  parent_price_id?: number | null
  /**
   * Unit Id
   * @min -2147483648
   * @max 2147483647
   */
  unit_id: number
}

/** PricesList */
export interface PricesList {
  /**
   * Data
   * @default []
   */
  data?: PricesListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** PricesListItem */
export interface PricesListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Is Local
   * Price for locals only
   * @default false
   */
  is_local?: boolean
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /**
   * Price
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price: number
  unit: TortoiseContribPydanticCreatorModelsUnitLeaf
  /**
   * Main
   * Main price
   * @default false
   */
  main?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /**
   * Parent Price Id
   * ID of the parent main price
   */
  parent_price_id: number | null
  /**
   * Unit Id
   * @min -2147483648
   * @max 2147483647
   */
  unit_id: number
}

/** ProjectsGrade */
export enum ProjectsGrade {
  Bronze = 1,
  Gold = 2,
}

/** Promotion */
export interface Promotion {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Description */
  description: string
  /** Residential Projects */
  residential_projects: ResidentialC3Oava[]
  /**
   * Start Date
   * @format date
   */
  start_date: string
  /** End Date */
  end_date?: string | null
  /** Thumbnail */
  thumbnail?: string | null
  /**
   * Is Permanent
   * @default false
   */
  is_permanent?: boolean | null
}

/** PromotionIn */
export interface PromotionIn {
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Description */
  description: string
  /**
   * Start Date
   * @format date
   */
  start_date: string
  /** End Date */
  end_date?: string | null
  /** Thumbnail */
  thumbnail?: string | null
  /**
   * Is Permanent
   * @default false
   */
  is_permanent?: boolean | null
  /** Residential Projects */
  residential_projects?: number[] | null
}

/** PromotionList */
export interface PromotionList {
  /**
   * Data
   * @default []
   */
  data?: PromotionListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** PromotionListItem */
export interface PromotionListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Description */
  description: string
  /** Residential Projects */
  residential_projects: ResidentialC3Oava[]
  /**
   * Start Date
   * @format date
   */
  start_date: string
  /** End Date */
  end_date?: string | null
  /** Thumbnail */
  thumbnail?: string | null
  /**
   * Is Permanent
   * @default false
   */
  is_permanent?: boolean | null
}

/** PubColBody */
export interface PubColBody {
  /** Language */
  language: string
}

/** PurchaseTiming */
export enum PurchaseTiming {
  Immediately = 1,
  OneToThreeMonths = 2,
  ThreeToSixMonths = 3,
  NotSure = 4,
}

/** Purpose */
export enum Purpose {
  ToLiving = 1,
  ToInvesting = 2,
  ToBecameLandlord = 3,
  ToGetResidentialPermission = 4,
}

/** Quiz */
export interface Quiz {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: TortoiseContribPydanticCreatorModelsCollectionLeaf | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
}

/** QuizIn */
export interface QuizIn {
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection Id */
  collection_id?: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
  /** Macrozones */
  macrozones?: number[] | null
}

/** QuizList */
export interface QuizList {
  /**
   * Data
   * @default []
   */
  data?: QuizListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** QuizListItem */
export interface QuizListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: TortoiseContribPydanticCreatorModelsCollectionLeaf | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface Quiz2Zo6Z6 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface Quiz3Dhdsw {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: TortoiseContribPydanticCreatorModelsCollectionLeaf | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface Quiz3Pq6Oy {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: TortoiseContribPydanticCreatorModelsCollectionLeaf | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface Quiz4Uldnh {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  contact: ContactPdm4Ty
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: CollectionTndb2J | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface Quiz7E2Xvn {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: TortoiseContribPydanticCreatorModelsCollectionLeaf | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface QuizByvzja {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: TortoiseContribPydanticCreatorModelsCollectionLeaf | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface QuizD7Wd45 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: TortoiseContribPydanticCreatorModelsCollectionLeaf | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface QuizFzu7Ch {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: TortoiseContribPydanticCreatorModelsCollectionLeaf | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface QuizH6Oocn {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  contact: ContactNwydiw
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: CollectionZutzcj | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface QuizL2W2M7 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: TortoiseContribPydanticCreatorModelsCollectionLeaf | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface QuizL3Qyb5 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: TortoiseContribPydanticCreatorModelsCollectionLeaf | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface QuizNsmyk2 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Quiz */
export interface QuizSou3We {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  contact: TortoiseContribPydanticCreatorModelsContactLeaf
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
  /** Collection */
  collection: TortoiseContribPydanticCreatorModelsCollectionLeaf | null
  /** Macrozones */
  macrozones: TortoiseContribPydanticCreatorModelsMacrozoneLeaf[]
  /** Collection Id */
  collection_id: number | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** ReadNotificationsDto */
export interface ReadNotificationsDto {
  /** Notifications */
  notifications: number[]
}

/** RecoveryPwdBody */
export interface RecoveryPwdBody {
  /** Email */
  email: string
  /** Code */
  code: string
  /** Password */
  password: string
}

/** RecoveryPwdSendEmailBody */
export interface RecoveryPwdSendEmailBody {
  /** Email */
  email: string
}

/** RegisterClientAction */
export interface RegisterClientAction {
  /** Contact Id */
  contact_id: number
  /**
   * Project Ids
   * @default []
   */
  project_ids?: number[]
  /** Comment */
  comment: string
}

/** ResAmenityTranslation */
export interface ResAmenityTranslation {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Amenity */
  amenity: TortoiseContribPydanticCreatorModelsResidentialAmenityLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** ResAmenityTranslationIn */
export interface ResAmenityTranslationIn {
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Amenity Id
   * @min -2147483648
   * @max 2147483647
   */
  amenity_id: number
}

/** ResAmenityTranslationList */
export interface ResAmenityTranslationList {
  /**
   * Data
   * @default []
   */
  data?: ResAmenityTranslationListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** ResAmenityTranslationListItem */
export interface ResAmenityTranslationListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Amenity */
  amenity: TortoiseContribPydanticCreatorModelsResidentialAmenityLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Amenity Id
   * @min -2147483648
   * @max 2147483647
   */
  amenity_id: number
}

/** ResPresentBody */
export interface ResPresentBody {
  /** User Id */
  user_id: string
  /** Residential Id */
  residential_id: string
  /**
   * Required Currency
   * @default 1
   */
  required_currency?: number | null
  /**
   * Is Local
   * @default false
   */
  is_local?: boolean | null
  /** Language */
  language?: string | null
}

/** ResidenceType */
export enum ResidenceType {
  Apartments = 1,
  Villa = 2,
  Mix = 3,
}

/** Residential */
export interface Residential {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /** Content Manager */
  content_manager: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Manager */
  manager: TortoiseContribPydanticCreatorAuthUserLeaf | null
  company: CompanyMrwhgx
  address: TortoiseContribPydanticCreatorModelsAddressLeaf
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /** Amenities */
  amenities: ResidentialAmenityJwakec[]
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Residential Positions */
  residential_positions: any
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
  /** Buildings */
  buildings: BuildingKzqyqb[]
  /** Promotions */
  promotions: TortoiseContribPydanticCreatorModelsPromotionLeaf[]
  /**
   * Address Id
   * @min -2147483648
   * @max 2147483647
   */
  address_id: number
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
  /**
   * Content Manager Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  content_manager_id: number
  /** Manager Id */
  manager_id?: number | null
  /** Presentations */
  presentations: TortoiseContribPydanticCreatorModelsResidentialPresentationLeaf[]
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResidentialTranslationLeaf[]
  /** Photos */
  photos?: Record<string, number>[] | null
  /** Social Photos */
  social_photos?: Record<string, number>[] | null
  /** Min Price */
  min_price?: number | null
  /** Max Price */
  max_price?: number | null
}

/** ResidentialAmenity */
export interface ResidentialAmenity {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResAmenityTranslationLeaf[]
  /** Residentials */
  residentials: TortoiseContribPydanticCreatorModelsResidentialLeaf[]
}

/** ResidentialAmenityIn */
export interface ResidentialAmenityIn {
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id?: number | null
  /** Residentials */
  residentials?: number[] | null
}

/** ResidentialAmenityList */
export interface ResidentialAmenityList {
  /**
   * Data
   * @default []
   */
  data?: ResidentialAmenityListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** ResidentialAmenityListItem */
export interface ResidentialAmenityListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResAmenityTranslationLeaf[]
}

/** ResidentialAmenity */
export interface ResidentialAmenity6Ktmsf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResAmenityTranslationLeaf[]
}

/** ResidentialAmenity */
export interface ResidentialAmenityJwakec {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResAmenityTranslationLeaf[]
}

/** ResidentialAmenity */
export interface ResidentialAmenityWjb2Dc {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResAmenityTranslationLeaf[]
}

/** ResidentialDict */
export interface ResidentialDict {
  /** Id */
  id: number
  /** Name */
  name: string
  /** Type */
  type: string
  /** Full Address */
  full_address: string
}

/** ResidentialIn */
export interface ResidentialIn {
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year?: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Residential Positions */
  residential_positions?: any
  /** Emlak Id */
  emlak_id?: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
  /**
   * Address Id
   * @min -2147483648
   * @max 2147483647
   */
  address_id: number
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
  /**
   * Content Manager Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  content_manager_id: number
  /** Manager Id */
  manager_id?: number | null
  /** Promotions */
  promotions?: number[] | null
  /** Presentations */
  presentations?: number[] | null
  /** Amenities */
  amenities?: number[] | null
}

/** ResidentialList */
export interface ResidentialList {
  /**
   * Data
   * @default []
   */
  data?: ResidentialListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** ResidentialListItem */
export interface ResidentialListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /** Content Manager */
  content_manager: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Manager */
  manager: TortoiseContribPydanticCreatorAuthUserLeaf | null
  company: CompanyMrwhgx
  address: TortoiseContribPydanticCreatorModelsAddressLeaf
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /** Amenities */
  amenities: ResidentialAmenityJwakec[]
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Residential Positions */
  residential_positions: any
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
  /** Buildings */
  buildings: BuildingUwewtm[]
  /** Promotions */
  promotions: TortoiseContribPydanticCreatorModelsPromotionLeaf[]
  /** Presentations */
  presentations: TortoiseContribPydanticCreatorModelsResidentialPresentationLeaf[]
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResidentialTranslationLeaf[]
  /** Photos */
  photos?: Record<string, number>[] | null
  /** Price M2 From */
  price_m2_from?: number | null
  /** Social Photos */
  social_photos?: Record<string, number>[] | null
  /** Min Price */
  min_price?: number | null
  /** Max Price */
  max_price?: number | null
  /** Min Price M2 */
  min_price_m2?: number | null
}

/** ResidentialPresentation */
export interface ResidentialPresentation {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * User Id
   * @min -2147483648
   * @max 2147483647
   */
  user_id: number
  /** Residential */
  residential: TortoiseContribPydanticCreatorModelsResidentialLeaf[]
}

/** ResidentialPresentationIn */
export interface ResidentialPresentationIn {
  /**
   * User Id
   * @min -2147483648
   * @max 2147483647
   */
  user_id: number
  /** Residential */
  residential?: number[] | null
  /** Residential Id */
  residential_id: number
  action: PresentationAction
}

/** ResidentialPresentationList */
export interface ResidentialPresentationList {
  /**
   * Data
   * @default []
   */
  data?: ResidentialPresentationListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** ResidentialPresentationListItem */
export interface ResidentialPresentationListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * User Id
   * @min -2147483648
   * @max 2147483647
   */
  user_id: number
  /** Residential */
  residential: ResidentialRakv47[]
}

/** ResidentialTranslation */
export interface ResidentialTranslation {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  residential: TortoiseContribPydanticCreatorModelsResidentialLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** ResidentialTranslationIn */
export interface ResidentialTranslationIn {
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** ResidentialTranslationList */
export interface ResidentialTranslationList {
  /**
   * Data
   * @default []
   */
  data?: ResidentialTranslationListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** ResidentialTranslationListItem */
export interface ResidentialTranslationListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  residential: TortoiseContribPydanticCreatorModelsResidentialLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Residential */
export interface Residential7R2Eqm {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Residential Positions */
  residential_positions: any
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
  /**
   * Address Id
   * @min -2147483648
   * @max 2147483647
   */
  address_id: number
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
  /**
   * Content Manager Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  content_manager_id: number
  /** Manager Id */
  manager_id?: number | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResidentialTranslationLeaf[]
}

/** Residential */
export interface ResidentialC3Oava {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /** Content Manager */
  content_manager: UserJkxtwy
  /** Manager */
  manager: UserBbamqn | null
  company: Company4Bkzii
  address: TortoiseContribPydanticCreatorModelsAddressLeaf
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /** Amenities */
  amenities: ResidentialAmenity6Ktmsf[]
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
  /** Buildings */
  buildings: Building4Zv2Va[]
  /** Orders */
  orders: OrderVymtbg[]
  /**
   * Address Id
   * @min -2147483648
   * @max 2147483647
   */
  address_id: number
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
  /**
   * Content Manager Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  content_manager_id: number
  /** Manager Id */
  manager_id?: number | null
  /** Presentations */
  presentations: TortoiseContribPydanticCreatorModelsResidentialPresentationLeaf[]
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResidentialTranslationLeaf[]
}

/** Residential */
export interface ResidentialFyglon {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  address: TortoiseContribPydanticCreatorModelsAddressLeaf
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /** Amenities */
  amenities: TortoiseContribPydanticCreatorModelsResidentialAmenityLeaf[]
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Residential Positions */
  residential_positions: any
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
  /**
   * Address Id
   * @min -2147483648
   * @max 2147483647
   */
  address_id: number
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
  /**
   * Content Manager Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  content_manager_id: number
  /** Manager Id */
  manager_id?: number | null
}

/** Residential */
export interface ResidentialG2P3Th {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Residential Positions */
  residential_positions: any
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
  /**
   * Address Id
   * @min -2147483648
   * @max 2147483647
   */
  address_id: number
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
  /**
   * Content Manager Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  content_manager_id: number
  /** Manager Id */
  manager_id?: number | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResidentialTranslationLeaf[]
}

/** Residential */
export interface ResidentialMp6K5P {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  address: TortoiseContribPydanticCreatorModelsAddressLeaf
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Residential Positions */
  residential_positions: any
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
  /**
   * Content Manager Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  content_manager_id: number
  /** Manager Id */
  manager_id?: number | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResidentialTranslationLeaf[]
}

/** Residential */
export interface ResidentialPfrrzy {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  address: TortoiseContribPydanticCreatorModelsAddressLeaf
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Residential Positions */
  residential_positions: any
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
  /**
   * Address Id
   * @min -2147483648
   * @max 2147483647
   */
  address_id: number
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
  /**
   * Content Manager Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  content_manager_id: number
  /** Manager Id */
  manager_id?: number | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResidentialTranslationLeaf[]
}

/** Residential */
export interface ResidentialRakv47 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /** Content Manager */
  content_manager: UserFnnaxn
  /** Manager */
  manager: User4Lmc2C | null
  company: CompanyXsestn
  address: TortoiseContribPydanticCreatorModelsAddressLeaf
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /** Amenities */
  amenities: ResidentialAmenityWjb2Dc[]
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Residential Positions */
  residential_positions: any
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
  /** Buildings */
  buildings: Building53Dmcg[]
  /** Orders */
  orders: OrderPkgvkb[]
  /** Promotions */
  promotions: TortoiseContribPydanticCreatorModelsPromotionLeaf[]
  /**
   * Address Id
   * @min -2147483648
   * @max 2147483647
   */
  address_id: number
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
  /**
   * Content Manager Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  content_manager_id: number
  /** Manager Id */
  manager_id?: number | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResidentialTranslationLeaf[]
}

/** Residential */
export interface ResidentialXrjntg {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  address: TortoiseContribPydanticCreatorModelsAddressLeaf
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Residential Positions */
  residential_positions: any
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
  /**
   * Company Id
   * @min -32768
   * @max 32767
   */
  company_id: number
  /**
   * Content Manager Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  content_manager_id: number
  /** Manager Id */
  manager_id?: number | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsResidentialTranslationLeaf[]
}

/** SavePhoneTmpBody */
export interface SavePhoneTmpBody {
  /** User Id */
  user_id: number
  /** Phone */
  phone: number
  /** Team Slug */
  team_slug?: string | null
}

/** SendSMSBody */
export interface SendSMSBody {
  /** Number */
  number: string
}

/** SetPersonalManagerDto */
export interface SetPersonalManagerDto {
  /** User Id */
  user_id: number
  /** Manager Id */
  manager_id: number
}

/** SignupSuccessBody */
export interface SignupSuccessBody {
  /** User Id */
  user_id: number
  /** Fbp */
  fbp?: string | null
  /** Fbc */
  fbc?: string | null
}

/** SocialPhoto */
export interface SocialPhoto {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Owner
   * Residential: 1<br/>Building: 2<br/>Unit: 3
   * @default 1
   */
  owner?: 1 | 2 | 3
  /**
   * Obj Id
   * @min -2147483648
   * @max 2147483647
   */
  obj_id: number
  /**
   * Ext
   * @maxLength 4
   */
  ext: string
  /**
   * Crop Box
   * @maxItems 2
   * @minItems 2
   */
  crop_box: any[]
  /**
   * Sort
   * @default 0
   */
  sort?: number | null
  /**
   * Tag
   * Exterior: 1<br/>Interior: 2<br/>Facilities: 3<br/>PublicSpaces: 4<br/>Infrastructure: 5<br/>BirdView: 6<br/>MasterPlan: 7<br/>BuildingProgress: 8
   */
  tag: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
}

/** SocialPhotoIn */
export interface SocialPhotoIn {
  /**
   * Owner
   * Residential: 1<br/>Building: 2<br/>Unit: 3
   * @default 1
   */
  owner?: 1 | 2 | 3
  /**
   * Obj Id
   * @min -2147483648
   * @max 2147483647
   */
  obj_id: number
  /**
   * Ext
   * @maxLength 4
   */
  ext: string
  /**
   * Crop Box
   * @maxItems 2
   * @minItems 2
   */
  crop_box: any[]
  /**
   * Sort
   * @default 0
   */
  sort?: number | null
  /**
   * Tag
   * Exterior: 1<br/>Interior: 2<br/>Facilities: 3<br/>PublicSpaces: 4<br/>Infrastructure: 5<br/>BirdView: 6<br/>MasterPlan: 7<br/>BuildingProgress: 8
   */
  tag: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
}

/** SocialPhotoList */
export interface SocialPhotoList {
  /**
   * Data
   * @default []
   */
  data?: SocialPhotoListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** SocialPhotoListItem */
export interface SocialPhotoListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Owner
   * Residential: 1<br/>Building: 2<br/>Unit: 3
   * @default 1
   */
  owner?: 1 | 2 | 3
  /**
   * Obj Id
   * @min -2147483648
   * @max 2147483647
   */
  obj_id: number
  /**
   * Ext
   * @maxLength 4
   */
  ext: string
  /**
   * Crop Box
   * @maxItems 2
   * @minItems 2
   */
  crop_box: any[]
  /**
   * Sort
   * @default 0
   */
  sort?: number | null
  /**
   * Tag
   * Exterior: 1<br/>Interior: 2<br/>Facilities: 3<br/>PublicSpaces: 4<br/>Infrastructure: 5<br/>BirdView: 6<br/>MasterPlan: 7<br/>BuildingProgress: 8
   */
  tag: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
}

/** Subscribers */
export interface Subscribers {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** User */
  user: TortoiseContribPydanticCreatorAuthUserLeaf | null
  /**
   * Telegram Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  telegram_id: number
  /** Firstname */
  firstname?: string | null
  /** Lastname */
  lastname?: string | null
  /**
   * Is Subscribed
   * @default true
   */
  is_subscribed?: boolean
  /**
   * Is Authenticated
   * @default false
   */
  is_authenticated?: boolean
  /**
   * Role
   * @maxLength 50
   * @default "manager"
   */
  role?: string
}

/** SubscribersIn */
export interface SubscribersIn {
  /**
   * Telegram Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  telegram_id: number
  /** Firstname */
  firstname?: string | null
  /** Lastname */
  lastname?: string | null
  /**
   * Is Subscribed
   * @default true
   */
  is_subscribed?: boolean
  /**
   * Is Authenticated
   * @default false
   */
  is_authenticated?: boolean
  /**
   * Role
   * @maxLength 50
   * @default "manager"
   */
  role?: string
  /** User Id */
  user_id?: number | null
}

/** SubscribersList */
export interface SubscribersList {
  /**
   * Data
   * @default []
   */
  data?: SubscribersListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** SubscribersListItem */
export interface SubscribersListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** User */
  user: TortoiseContribPydanticCreatorAuthUserLeaf | null
  /**
   * Telegram Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  telegram_id: number
  /** Firstname */
  firstname?: string | null
  /** Lastname */
  lastname?: string | null
  /**
   * Is Subscribed
   * @default true
   */
  is_subscribed?: boolean
  /**
   * Is Authenticated
   * @default false
   */
  is_authenticated?: boolean
  /**
   * Role
   * @maxLength 50
   * @default "manager"
   */
  role?: string
  /** User Id */
  user_id?: number | null
}

/** SupportForm */
export interface SupportForm {
  /** Name */
  name: string
  /** Email */
  email: string
  /** Phone */
  phone: string
  /** Subject */
  subject: string
  /** Message */
  message: string
}

/** Team */
export interface Team {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Name */
  name?: string | null
  /** Logo Url */
  logo_url?: string | null
  /** Phone */
  phone: number | null
  /** Email */
  email?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Head Name */
  head_name?: string | null
  /** Members */
  members: TortoiseContribPydanticCreatorAuthUserLeaf[]
  /** Head */
  head: TortoiseContribPydanticCreatorAuthUserLeaf | null
}

/** TeamIn */
export interface TeamIn {
  /** Name */
  name?: string | null
  /** Logo Url */
  logo_url?: string | null
  /** Phone */
  phone: number | null
  /** Email */
  email?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Head Name */
  head_name?: string | null
}

/** TeamList */
export interface TeamList {
  /**
   * Data
   * @default []
   */
  data?: TeamListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** TeamListItem */
export interface TeamListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Name */
  name?: string | null
  /** Logo Url */
  logo_url?: string | null
  /** Phone */
  phone: number | null
  /** Email */
  email?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Head Name */
  head_name?: string | null
  /** Members */
  members: TortoiseContribPydanticCreatorAuthUserLeaf[]
  /** Head */
  head: TortoiseContribPydanticCreatorAuthUserLeaf | null
}

/** Template */
export interface Template {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Content */
  content: string
  /** Comment */
  comment?: string | null
  /** Subject */
  subject?: string | null
}

/** TemplateIn */
export interface TemplateIn {
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Content */
  content: string
  /** Comment */
  comment?: string | null
  /** Subject */
  subject?: string | null
}

/** TemplateList */
export interface TemplateList {
  /**
   * Data
   * @default []
   */
  data?: TemplateListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** TemplateListItem */
export interface TemplateListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Content */
  content: string
  /** Comment */
  comment?: string | null
  /** Subject */
  subject?: string | null
}

/** Token */
export interface Token {
  /** Access Token */
  access_token: string
  /** Token Type */
  token_type: string
  user: UserSchema
}

/** TranslationBody */
export interface TranslationBody {
  /** Params */
  params: TranslationParams[]
  type: ModelTypes
}

/** TranslationParams */
export interface TranslationParams {
  /** Language */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description?: string | null
  /** Id */
  id?: number | null
  /** Unit Id */
  unit_id?: number | null
  /** Building Id */
  building_id?: number | null
  /** Residential Id */
  residential_id?: number | null
  /** Company Id */
  company_id?: number | null
  /** Amenity Id */
  amenity_id?: number | null
  /** Webinar Id */
  webinar_id?: number | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** Unit */
export interface Unit {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  building: BuildingJlld4T
  /** Buildingname */
  buildingName?: string | null
  /** Amenities */
  amenities: UnitAmenityYxl5Q5[]
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions: any
  /** Agents Comments */
  agents_comments: any
  /** Clients Likes */
  clients_likes: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Collections */
  collections: TortoiseContribPydanticCreatorModelsCollectionLeaf[]
  /** Prices */
  prices: TortoiseContribPydanticCreatorModelsPricesLeaf[]
  /**
   * Building Id
   * @min -2147483648
   * @max 2147483647
   */
  building_id: number
  /** Presentations */
  presentations: TortoiseContribPydanticCreatorModelsUnitPresentationLeaf[]
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitTranslationLeaf[]
  /** Photos */
  photos?: Record<string, number>[] | null
  /** Building Photos */
  building_photos?: Record<string, number>[] | null
  /** Residential Photos */
  residential_photos?: Record<string, number>[] | null
}

/** UnitAmenity */
export interface UnitAmenity {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitAmenityTranslationLeaf[]
}

/** UnitAmenityIn */
export interface UnitAmenityIn {
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Units */
  units?: number[] | null
}

/** UnitAmenityList */
export interface UnitAmenityList {
  /**
   * Data
   * @default []
   */
  data?: UnitAmenityListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** UnitAmenityListItem */
export interface UnitAmenityListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitAmenityTranslationLeaf[]
}

/** UnitAmenityTranslation */
export interface UnitAmenityTranslation {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Amenity */
  amenity: TortoiseContribPydanticCreatorModelsUnitAmenityLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** UnitAmenityTranslationIn */
export interface UnitAmenityTranslationIn {
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Amenity Id
   * @min -2147483648
   * @max 2147483647
   */
  amenity_id: number
}

/** UnitAmenityTranslationList */
export interface UnitAmenityTranslationList {
  /**
   * Data
   * @default []
   */
  data?: UnitAmenityTranslationListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** UnitAmenityTranslationListItem */
export interface UnitAmenityTranslationListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Amenity */
  amenity: TortoiseContribPydanticCreatorModelsUnitAmenityLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Amenity Id
   * @min -2147483648
   * @max 2147483647
   */
  amenity_id: number
}

/** UnitAmenity */
export interface UnitAmenityEcrpzk {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitAmenityTranslationLeaf[]
}

/** UnitAmenity */
export interface UnitAmenityGzbar3 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitAmenityTranslationLeaf[]
}

/** UnitAmenity */
export interface UnitAmenityYxl5Q5 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitAmenityTranslationLeaf[]
}

/** UnitIn */
export interface UnitIn {
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /** Buildingname */
  buildingName?: string | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions?: any
  /** Agents Comments */
  agents_comments?: any
  /** Clients Likes */
  clients_likes?: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id?: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Building Id
   * @min -2147483648
   * @max 2147483647
   */
  building_id: number
  /** Collections */
  collections?: number[] | null
  /** Amenities */
  amenities?: number[] | null
  /** Presentations */
  presentations?: number[] | null
}

/** UnitList */
export interface UnitList {
  /**
   * Data
   * @default []
   */
  data?: UnitListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** UnitListItem */
export interface UnitListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  building: BuildingSqejo3
  /** Buildingname */
  buildingName?: string | null
  /** Amenities */
  amenities: UnitAmenityYxl5Q5[]
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions: any
  /** Agents Comments */
  agents_comments: any
  /** Clients Likes */
  clients_likes: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Collections */
  collections: CollectionPgcpju[]
  /** Prices */
  prices: TortoiseContribPydanticCreatorModelsPricesLeaf[]
  /** Presentations */
  presentations: TortoiseContribPydanticCreatorModelsUnitPresentationLeaf[]
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitTranslationLeaf[]
  /** Photos */
  photos?: Record<string, number>[] | null
  /** Photo */
  photo?: string | null
  /** Building Photos */
  building_photos?: Record<string, number>[] | null
  /** Residential Photos */
  residential_photos?: Record<string, number>[] | null
}

/** UnitPresentBody */
export interface UnitPresentBody {
  /** User Id */
  user_id: string
  /** Unit Id */
  unit_id: string
}

/** UnitPresentation */
export interface UnitPresentation {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * User Id
   * @min -2147483648
   * @max 2147483647
   */
  user_id: number
  /** Units */
  units: TortoiseContribPydanticCreatorModelsUnitLeaf[]
}

/** UnitPresentationIn */
export interface UnitPresentationIn {
  /**
   * User Id
   * @min -2147483648
   * @max 2147483647
   */
  user_id: number
  /** Units */
  units?: number[] | null
  /** Unit Id */
  unit_id: number
  action: PresentationAction
}

/** UnitPresentationList */
export interface UnitPresentationList {
  /**
   * Data
   * @default []
   */
  data?: UnitPresentationListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** UnitPresentationListItem */
export interface UnitPresentationListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * User Id
   * @min -2147483648
   * @max 2147483647
   */
  user_id: number
  /** Units */
  units: UnitVscscj[]
}

/** UnitTranslation */
export interface UnitTranslation {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  unit: TortoiseContribPydanticCreatorModelsUnitLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** UnitTranslationIn */
export interface UnitTranslationIn {
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Unit Id
   * @min -2147483648
   * @max 2147483647
   */
  unit_id: number
}

/** UnitTranslationList */
export interface UnitTranslationList {
  /**
   * Data
   * @default []
   */
  data?: UnitTranslationListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** UnitTranslationListItem */
export interface UnitTranslationListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  unit: TortoiseContribPydanticCreatorModelsUnitLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Unit Id
   * @min -2147483648
   * @max 2147483647
   */
  unit_id: number
}

/** Unit */
export interface Unit6Z5Wak {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /** Buildingname */
  buildingName?: string | null
  /** Amenities */
  amenities: UnitAmenityGzbar3[]
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions: any
  /** Agents Comments */
  agents_comments: any
  /** Clients Likes */
  clients_likes: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Collections */
  collections: CollectionFjpviy[]
  /** Prices */
  prices: TortoiseContribPydanticCreatorModelsPricesLeaf[]
  /**
   * Building Id
   * @min -2147483648
   * @max 2147483647
   */
  building_id: number
  /** Presentations */
  presentations: TortoiseContribPydanticCreatorModelsUnitPresentationLeaf[]
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitTranslationLeaf[]
}

/** Unit */
export interface UnitAnb3Zo {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  building: TortoiseContribPydanticCreatorModelsBuildingLeaf
  /** Buildingname */
  buildingName?: string | null
  /** Amenities */
  amenities: TortoiseContribPydanticCreatorModelsUnitAmenityLeaf[]
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions: any
  /** Agents Comments */
  agents_comments: any
  /** Clients Likes */
  clients_likes: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Prices */
  prices: TortoiseContribPydanticCreatorModelsPricesLeaf[]
  /**
   * Building Id
   * @min -2147483648
   * @max 2147483647
   */
  building_id: number
  /** Presentations */
  presentations: TortoiseContribPydanticCreatorModelsUnitPresentationLeaf[]
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitTranslationLeaf[]
}

/** Unit */
export interface UnitGddxzh {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  building: TortoiseContribPydanticCreatorModelsBuildingLeaf
  /** Buildingname */
  buildingName?: string | null
  /** Amenities */
  amenities: TortoiseContribPydanticCreatorModelsUnitAmenityLeaf[]
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions: any
  /** Agents Comments */
  agents_comments: any
  /** Clients Likes */
  clients_likes: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Prices */
  prices: TortoiseContribPydanticCreatorModelsPricesLeaf[]
  /**
   * Building Id
   * @min -2147483648
   * @max 2147483647
   */
  building_id: number
  /** Presentations */
  presentations: TortoiseContribPydanticCreatorModelsUnitPresentationLeaf[]
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitTranslationLeaf[]
}

/** Unit */
export interface UnitIdj4Ef {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /** Buildingname */
  buildingName?: string | null
  /** Amenities */
  amenities: TortoiseContribPydanticCreatorModelsUnitAmenityLeaf[]
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions: any
  /** Agents Comments */
  agents_comments: any
  /** Clients Likes */
  clients_likes: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Prices */
  prices: TortoiseContribPydanticCreatorModelsPricesLeaf[]
  /**
   * Building Id
   * @min -2147483648
   * @max 2147483647
   */
  building_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitTranslationLeaf[]
}

/** Unit */
export interface UnitIfqg6W {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  building: BuildingTkqcfw
  /** Buildingname */
  buildingName?: string | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions: any
  /** Agents Comments */
  agents_comments: any
  /** Clients Likes */
  clients_likes: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitTranslationLeaf[]
}

/** Unit */
export interface UnitRledil {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /** Buildingname */
  buildingName?: string | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions: any
  /** Agents Comments */
  agents_comments: any
  /** Clients Likes */
  clients_likes: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Building Id
   * @min -2147483648
   * @max 2147483647
   */
  building_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitTranslationLeaf[]
}

/** Unit */
export interface UnitS237Cf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /** Buildingname */
  buildingName?: string | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions: any
  /** Agents Comments */
  agents_comments: any
  /** Clients Likes */
  clients_likes: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Prices */
  prices: TortoiseContribPydanticCreatorModelsPricesLeaf[]
}

/** Unit */
export interface UnitVscscj {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  building: BuildingL2Eyox
  /** Buildingname */
  buildingName?: string | null
  /** Amenities */
  amenities: UnitAmenityEcrpzk[]
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions: any
  /** Agents Comments */
  agents_comments: any
  /** Clients Likes */
  clients_likes: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /** Collections */
  collections: CollectionOlzb7T[]
  /** Prices */
  prices: TortoiseContribPydanticCreatorModelsPricesLeaf[]
  /**
   * Building Id
   * @min -2147483648
   * @max 2147483647
   */
  building_id: number
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsUnitTranslationLeaf[]
}

/** UpdateFeeResponse */
export interface UpdateFeeResponse {
  /** Updated Fee */
  updated_fee: number
  /** Status */
  status: string
}

/** UpdateResidentialsOrderDto */
export interface UpdateResidentialsOrderDto {
  /** Landing Data Id */
  landing_data_id: number
  /** Residentials Positions */
  residentials_positions: object
}

/** UpdateTeamDto */
export interface UpdateTeamDto {
  /** Team Id */
  team_id: number
  /** Name */
  name?: string | null
  /** Logo Url */
  logo_url?: string | null
  /** Phone */
  phone?: number | null
  /** Email */
  email?: string | null
}

/** UpdateUnitsOrderDto */
export interface UpdateUnitsOrderDto {
  /** Units Positions */
  units_positions: Record<string, number>
  /** Collection Id */
  collection_id: number
}

/** UpdateUserBody */
export interface UpdateUserBody {
  /** Username */
  username?: string | null
  /** Status */
  status?: number | null
  /** Email */
  email?: string | null
  /** Phone */
  phone?: number | null
  /** Role */
  role?: number | null
  /** Fullname */
  fullname?: string | null
  /** Company Name */
  company_name?: string | null
  /** Is Content Manager */
  is_content_manager?: boolean | null
  /** Is Manager */
  is_manager?: boolean | null
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Offer Id */
  offer_id?: number | null
  /** Lang */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Use Corporate Contact */
  use_corporate_contact?: boolean | null
}

/** User */
export interface User {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
}

/** UserActions */
export enum UserActions {
  RegisterUser = 1,
  CreatePresentation = 2,
  CreateCollection = 3,
  RegisterClient = 4,
  CreatePDF = 5,
  EditLanding = 6,
  CopyLandingLink = 7,
  PublishLanding = 8,
  AddClient = 9,
  DownloadApp = 10,
  CreateQuiz = 11,
}

/** UserActionsLog */
export interface UserActionsLog {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Contact */
  contact: TortoiseContribPydanticCreatorModelsContactLeaf | null
}

/** UserActionsLogIn */
export interface UserActionsLogIn {
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  /** Contact Id */
  contact_id?: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserActionsLogList */
export interface UserActionsLogList {
  /**
   * Data
   * @default []
   */
  data?: UserActionsLogListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** UserActionsLogListItem */
export interface UserActionsLogListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Contact */
  contact: TortoiseContribPydanticCreatorModelsContactLeaf | null
  /** Contact Id */
  contact_id: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserActionsLog */
export interface UserActionsLog3Usw75 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  /** Contact */
  contact: TortoiseContribPydanticCreatorModelsContactLeaf | null
  /** Contact Id */
  contact_id: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserActionsLog */
export interface UserActionsLog5Ew6Ev {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  /** Contact */
  contact: TortoiseContribPydanticCreatorModelsContactLeaf | null
  /** Contact Id */
  contact_id: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserActionsLog */
export interface UserActionsLog5Vaxfe {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  /** Contact */
  contact: ContactDzpw6W | null
  /** Contact Id */
  contact_id: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserActionsLog */
export interface UserActionsLogAfjups {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  /** Contact */
  contact: TortoiseContribPydanticCreatorModelsContactLeaf | null
  /** Contact Id */
  contact_id: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserActionsLog */
export interface UserActionsLogAvy3Ex {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  /** Contact */
  contact: TortoiseContribPydanticCreatorModelsContactLeaf | null
  /** Contact Id */
  contact_id: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserActionsLog */
export interface UserActionsLogCmyntr {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /** Contact Id */
  contact_id: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserActionsLog */
export interface UserActionsLogFo3256 {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  /** Contact */
  contact: ContactP4F6Wp | null
  /** Contact Id */
  contact_id: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserActionsLog */
export interface UserActionsLogG2K7Wj {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  /** Contact */
  contact: TortoiseContribPydanticCreatorModelsContactLeaf | null
  /** Contact Id */
  contact_id: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserActionsLog */
export interface UserActionsLogRt7Wvw {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  /** Contact */
  contact: TortoiseContribPydanticCreatorModelsContactLeaf | null
  /** Contact Id */
  contact_id: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserActivities */
export interface UserActivities {
  agents_registered: MetricData
  collections_created: MetricData
  projects_added: MetricData
  published_landings: MetricData
  active_users: MetricData
  units_with_local_prices_last_7d: MetricData
  price_changes_last_7d: MetricData
  app_downloads: MetricData
}

/** UserIn */
export interface UserIn {
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars?: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data?: any
  /** Third Party */
  third_party?: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id?: number | null
  /** Crm Deal Id */
  crm_deal_id?: number | null
  /** Offer Id */
  offer_id?: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Team Id */
  team_id?: number | null
  /** Head Team Id */
  head_team_id?: number | null
}

/** UserList */
export interface UserList {
  /**
   * Data
   * @default []
   */
  data?: UserListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** UserListItem */
export interface UserListItem {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Personal Manager */
  personal_manager: TortoiseContribPydanticCreatorAuthUserLeaf | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
}

/** UserPhotoType */
export enum UserPhotoType {
  Avatar = 'avatar',
  CompanyLogo = 'company_logo',
}

/** UserReg */
export interface UserReg {
  /** Password */
  password?: string | null
  /** Username */
  username: string
  /** Email */
  email?: string | null
  /** Phone */
  phone?: number | null
  /** Google Id */
  google_id?: string | null
  /** Fullname */
  fullname: string | null
  /** Offer Id */
  offer_id: number | null
  /** Lang */
  lang: string | null
  /** @default 2 */
  role?: AuthUserRole1 | null
  /** Utm Data */
  utm_data?: object | null
  /** Third Party */
  third_party?: object | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
}

/** UserSchema */
export interface UserSchema {
  /** Username */
  username: string
  status: AuthUserStatus2
  /** Email */
  email: string | null
  /** Phone */
  phone: number | null
  role: AuthUserRole1
  /** Id */
  id: number
  /** Fullname */
  fullname: string | null
  /** Avatar Url */
  avatar_url: string | null
  /** Offer Id */
  offer_id: number | null
  /** Hash Slug */
  hash_slug: string | null
  /** Lang */
  lang: string | null
  /** Last Login */
  last_login: string | null
  /** Landing Slug */
  landing_slug: string | null
  /** Watched Webinars */
  watched_webinars: number[] | null
  /** Updated At */
  updated_at: string | null
  /** Use Corporate Contact */
  use_corporate_contact: boolean | null
  /** Company Name */
  company_name: string | null
  /** Company Logo Url */
  company_logo_url: string | null
  /** Company Phone */
  company_phone: number | null
  /** Company Email */
  company_email: string | null
  /** City */
  city: string | null
  /** Personal Manager Id */
  personal_manager_id: number | null
}

/** UserSessionLog */
export interface UserSessionLog {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /**
   * Start Session
   * @format date-time
   */
  start_session: string
  /** End Session */
  end_session?: string | null
  /** Browser */
  browser?: string | null
  /** Device */
  device?: string | null
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean
}

/** UserSessionLogDto */
export interface UserSessionLogDto {
  /** User Id */
  user_id: number
  /** Browser */
  browser: string | null
  /** Device */
  device: string | null
}

/** UserSessionLogIn */
export interface UserSessionLogIn {
  /** End Session */
  end_session?: string | null
  /** Browser */
  browser?: string | null
  /** Device */
  device?: string | null
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserSessionLogList */
export interface UserSessionLogList {
  /**
   * Data
   * @default []
   */
  data?: UserSessionLogListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** UserSessionLogListItem */
export interface UserSessionLogListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  user: TortoiseContribPydanticCreatorAuthUserLeaf
  /**
   * Start Session
   * @format date-time
   */
  start_session: string
  /** End Session */
  end_session?: string | null
  /** Browser */
  browser?: string | null
  /** Device */
  device?: string | null
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** User */
export interface User2Tounm {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: TortoiseContribPydanticCreatorModelsCollectionLeaf[]
  /** Contacts */
  contacts: TortoiseContribPydanticCreatorModelsContactLeaf[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface User3Miexi {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: TortoiseContribPydanticCreatorModelsCollectionLeaf[]
  /** Companies */
  companies: TortoiseContribPydanticCreatorModelsCompanyLeaf[]
  /** Contacts */
  contacts: TortoiseContribPydanticCreatorModelsContactLeaf[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface User4Lmc2C {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Personal Manager */
  personal_manager: UserL7Xarb | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: CollectionV34Mu3[]
  /** Companies */
  companies: CompanyGwtedv[]
  /** Contacts */
  contacts: ContactOyjnkb[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Orders */
  orders: OrderFj6Tlq[]
  /** Quiz */
  quiz: QuizH6Oocn[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Clients */
  clients: User6Zskl4[]
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: UserActionsLog5Vaxfe[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface User6Zskl4 {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: CollectionB3P2D3[]
  /** Companies */
  companies: CompanyRhznc5[]
  /** Contacts */
  contacts: ContactLufwyf[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Orders */
  orders: OrderZipmpl[]
  /** Quiz */
  quiz: QuizL3Qyb5[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: UserActionsLogAfjups[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface UserBbamqn {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Personal Manager */
  personal_manager: TortoiseContribPydanticCreatorAuthUserLeaf | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: TortoiseContribPydanticCreatorModelsCollectionLeaf[]
  /** Companies */
  companies: TortoiseContribPydanticCreatorModelsCompanyLeaf[]
  /** Contacts */
  contacts: TortoiseContribPydanticCreatorModelsContactLeaf[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Clients */
  clients: TortoiseContribPydanticCreatorAuthUserLeaf[]
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface UserDrywye {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Personal Manager */
  personal_manager: User3Miexi | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: Collection2Xszo4[]
  /** Companies */
  companies: CompanyHjogan[]
  /** Contacts */
  contacts: ContactW3Cne2[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Quiz */
  quiz: QuizL2W2M7[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Clients */
  clients: UserK7Hblo[]
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: UserActionsLog5Ew6Ev[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface UserEjjlre {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: CollectionUmu7Bq[]
  /** Companies */
  companies: CompanyKlr2Sr[]
  /** Contacts */
  contacts: ContactRflxc7[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Orders */
  orders: OrderGekht7[]
  /** Quiz */
  quiz: Quiz3Pq6Oy[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: UserActionsLogRt7Wvw[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface UserEkm62B {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: TortoiseContribPydanticCreatorModelsCollectionLeaf[]
  /** Contacts */
  contacts: TortoiseContribPydanticCreatorModelsContactLeaf[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface UserFnnaxn {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Personal Manager */
  personal_manager: UserEjjlre | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: CollectionRycztj[]
  /** Companies */
  companies: CompanyXsklya[]
  /** Contacts */
  contacts: ContactOwwawm[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Orders */
  orders: OrderMili7P[]
  /** Quiz */
  quiz: Quiz4Uldnh[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Clients */
  clients: UserHb3Ex5[]
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: UserActionsLogFo3256[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface UserHb3Ex5 {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: CollectionYydmvv[]
  /** Companies */
  companies: CompanyZpnp7L[]
  /** Contacts */
  contacts: ContactWo67Xp[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Orders */
  orders: OrderQmk3Fh[]
  /** Quiz */
  quiz: Quiz3Dhdsw[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: UserActionsLogAvy3Ex[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface UserJkxtwy {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Personal Manager */
  personal_manager: TortoiseContribPydanticCreatorAuthUserLeaf | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: TortoiseContribPydanticCreatorModelsCollectionLeaf[]
  /** Companies */
  companies: TortoiseContribPydanticCreatorModelsCompanyLeaf[]
  /** Contacts */
  contacts: TortoiseContribPydanticCreatorModelsContactLeaf[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Orders */
  orders: TortoiseContribPydanticCreatorModelsOrderLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Clients */
  clients: TortoiseContribPydanticCreatorAuthUserLeaf[]
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface UserK7Hblo {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: TortoiseContribPydanticCreatorModelsCollectionLeaf[]
  /** Companies */
  companies: TortoiseContribPydanticCreatorModelsCompanyLeaf[]
  /** Contacts */
  contacts: TortoiseContribPydanticCreatorModelsContactLeaf[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface UserL7Xarb {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: CollectionZf5Gts[]
  /** Companies */
  companies: CompanyEhrt3R[]
  /** Contacts */
  contacts: ContactPt4Dm2[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Orders */
  orders: OrderVskt4A[]
  /** Quiz */
  quiz: QuizSou3We[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: UserActionsLog3Usw75[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface UserNqjhhu {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Personal Manager */
  personal_manager: User2Tounm | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: Collection4Eaqo6[]
  /** Contacts */
  contacts: ContactZ3Og4L[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Orders */
  orders: OrderSogas3[]
  /** Quiz */
  quiz: QuizD7Wd45[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Clients */
  clients: UserEkm62B[]
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: UserActionsLogG2K7Wj[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** User */
export interface UserPwefns {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
}

/** User */
export interface UserYddl3U {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /** Offer */
  offer: TortoiseContribPydanticCreatorModelsOfferLeaf | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
  /** Personal Manager */
  personal_manager: TortoiseContribPydanticCreatorAuthUserLeaf | null
  /** Head Team */
  head_team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Team */
  team: TortoiseContribPydanticCreatorModelsTeamLeaf | null
  /** Collections */
  collections: TortoiseContribPydanticCreatorModelsCollectionLeaf[]
  /** Companies */
  companies: TortoiseContribPydanticCreatorModelsCompanyLeaf[]
  /** Emails Log */
  emails_log: TortoiseContribPydanticCreatorModelsEmailsLogLeaf[]
  /** Landing Data */
  landing_data: TortoiseContribPydanticCreatorModelsLandingDataLeaf | null
  /** Landing Forms */
  landing_forms: TortoiseContribPydanticCreatorModelsLandingFormsLeaf[]
  /** Quiz */
  quiz: TortoiseContribPydanticCreatorModelsQuizLeaf[]
  /** Subscribers */
  subscribers: TortoiseContribPydanticCreatorModelsSubscribersLeaf[]
  /** Offer Id */
  offer_id: number | null
  /** Personal Manager Id */
  personal_manager_id?: number | null
  /** Clients */
  clients: TortoiseContribPydanticCreatorAuthUserLeaf[]
  /** Team Id */
  team_id: number | null
  /** Head Team Id */
  head_team_id: number | null
  /** User Actions Log */
  user_actions_log: TortoiseContribPydanticCreatorModelsUserActionsLogLeaf[]
  /** User Sessions Log */
  user_sessions_log: TortoiseContribPydanticCreatorModelsUserSessionLogLeaf[]
}

/** UsersSessionsHistory */
export interface UsersSessionsHistory {
  /**
   * Date
   * @format date
   */
  date: string
  /** Numberofsession */
  numberOfSession: number
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[]
  /** Message */
  msg: string
  /** Error Type */
  type: string
}

/** VerifyRecPwdBody */
export interface VerifyRecPwdBody {
  /** Email */
  email: string
  /** Code */
  code: string
}

/** VerifySMSBody */
export interface VerifySMSBody {
  /** Verification Id */
  verification_id: string
  /** Code */
  code: string
  /** User Id */
  user_id: number
  /** Phone */
  phone: number
}

/** WatchWebinarDto */
export interface WatchWebinarDto {
  /** User Id */
  user_id: number
  /** Webinar Id */
  webinar_id: number
}

/** Webinar */
export interface Webinar {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Name */
  name?: string | null
  /** Release Date */
  release_date?: string | null
  /** Description */
  description: string | null
  /** Thumbnail */
  thumbnail?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsWebinarTranslationsLeaf[]
}

/** WebinarIn */
export interface WebinarIn {
  /** Name */
  name?: string | null
  /** Release Date */
  release_date?: string | null
  /** Description */
  description?: string | null
  /** Thumbnail */
  thumbnail?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
}

/** WebinarList */
export interface WebinarList {
  /**
   * Data
   * @default []
   */
  data?: WebinarListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** WebinarListItem */
export interface WebinarListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Name */
  name?: string | null
  /** Release Date */
  release_date?: string | null
  /** Description */
  description: string | null
  /** Thumbnail */
  thumbnail?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Translations */
  translations: TortoiseContribPydanticCreatorModelsWebinarTranslationsLeaf[]
}

/** WebinarTranslations */
export interface WebinarTranslations {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  webinar: TortoiseContribPydanticCreatorModelsWebinarLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** WebinarTranslationsIn */
export interface WebinarTranslationsIn {
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Webinar Id
   * @min -2147483648
   * @max 2147483647
   */
  webinar_id: number
}

/** WebinarTranslationsList */
export interface WebinarTranslationsList {
  /**
   * Data
   * @default []
   */
  data?: WebinarTranslationsListItem[]
  /**
   * Total
   * @default 0
   */
  total?: number
  /** Filtered */
  filtered?: number | null
}

/** WebinarTranslationsListItem */
export interface WebinarTranslationsListItem {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  webinar: TortoiseContribPydanticCreatorModelsWebinarLeaf
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Webinar Id
   * @min -2147483648
   * @max 2147483647
   */
  webinar_id: number
}

/** UserRole */
export enum AuthUserRole1 {
  Client = 1,
  Agent = 2,
  Manager = 3,
  Admin = 4,
  TeamHead = 5,
  TeamMember = 6,
}

/**
 * UserRole
 * @default 2
 */
export enum AuthUserRole2 {
  Client = 1,
  Agent = 2,
  Manager = 3,
  Admin = 4,
  TeamHead = 5,
  TeamMember = 6,
}

/**
 * UserStatus
 * @default 1
 */
export enum AuthUserStatus1 {
  Banned = 0,
  Wait = 1,
  Test = 2,
  Active = 3,
  Trial = 4,
  TrialEnd = 5,
}

/** UserStatus */
export enum AuthUserStatus2 {
  Banned = 0,
  Wait = 1,
  Test = 2,
  Active = 3,
  Trial = 4,
  TrialEnd = 5,
}

/**
 * ImagableType
 * @default 1
 */
export enum ModelsImagableType1 {
  Residential = 1,
  Building = 2,
  Unit = 3,
}

/** ImagableType */
export enum ModelsImagableType2 {
  Residential = 1,
  Building = 2,
  Unit = 3,
}

/** LandingFormType */
export enum ModelsLandingFormType1 {
  Feedback = 1,
  Info = 2,
}

/** LandingFormType */
export enum ModelsLandingFormType2 {
  Feedback = 1,
  Info = 2,
}

/** PhotoTag */
export enum ModelsPhotoTag1 {
  Exterior = 1,
  Interior = 2,
  Facilities = 3,
  PublicSpaces = 4,
  Infrastructure = 5,
  BirdView = 6,
  MasterPlan = 7,
  BuildingProgress = 8,
}

/** PhotoTag */
export enum ModelsPhotoTag2 {
  Exterior = 1,
  Interior = 2,
  Facilities = 3,
  PublicSpaces = 4,
  Infrastructure = 5,
  BirdView = 6,
  MasterPlan = 7,
  BuildingProgress = 8,
}

/** Type */
export enum ModelsType1 {
  Apartment = 1,
  Villa = 2,
  Townhouse = 3,
  Duplex = 4,
  Penthouse = 5,
  Triplex = 6,
}

/** Type */
export enum ModelsType2 {
  Apartment = 1,
  Villa = 2,
  Townhouse = 3,
  Duplex = 4,
  Penthouse = 5,
  Triplex = 6,
}

/** User */
export interface TortoiseContribPydanticCreatorAuthUserLeaf {
  /**
   * Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Banned: 0<br/>Wait: 1<br/>Test: 2<br/>Active: 3<br/>Trial: 4<br/>TrialEnd: 5
   * @default 1
   */
  status?: 0 | 1 | 2 | 3 | 4 | 5
  /** Username */
  username?: string | null
  /** Email */
  email?: string | null
  /** Password */
  password?: string | null
  /** Phone */
  phone?: number | null
  /**
   * Role
   * Client: 1<br/>Agent: 2<br/>Manager: 3<br/>Admin: 4<br/>TeamHead: 5<br/>TeamMember: 6
   * @default 2
   */
  role?: 1 | 2 | 3 | 4 | 5 | 6
  /** Google Id */
  google_id?: string | null
  /**
   * Fullname
   * @default "user name"
   */
  fullname?: string | null
  /**
   * Is Manager
   * @default false
   */
  is_manager?: boolean
  /**
   * Is Content Manager
   * @default false
   */
  is_content_manager?: boolean
  /** Avatar Url */
  avatar_url?: string | null
  /** Company Name */
  company_name?: string | null
  /** Company Logo Url */
  company_logo_url?: string | null
  /** Company Phone */
  company_phone?: number | null
  /** Company Email */
  company_email?: string | null
  /** Recovery Code */
  recovery_code?: string | null
  /** Recovery Code Created At */
  recovery_code_created_at?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Last Login */
  last_login?: string | null
  /** City */
  city?: string | null
  /**
   * Profile Completed
   * @default false
   */
  profile_completed?: boolean
  /**
   * Lang
   * @default "tr-TR"
   */
  lang?: string | null
  /** Landing Slug */
  landing_slug?: string | null
  /** Watched Webinars */
  watched_webinars: any
  /**
   * Use Corporate Contact
   * @default false
   */
  use_corporate_contact?: boolean
  /** Utm Data */
  utm_data: any
  /** Third Party */
  third_party: any
  /**
   * Is Default Manager
   * @default false
   */
  is_default_manager?: boolean
  /** Crm Responsible Id */
  crm_responsible_id: number | null
  /** Crm Deal Id */
  crm_deal_id: number | null
}

/** Address */
export interface TortoiseContribPydanticCreatorModelsAddressLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Formatted
   * @maxLength 255
   */
  formatted: string
  /**
   * Gid
   * @maxLength 63
   */
  gid: string
  /** Loc */
  loc?: any[] | null
  /** Lat */
  lat?: number | null
  /** Lng */
  lng?: number | null
  /** Street Number */
  street_number?: string | null
  /** Route */
  route?: string | null
  /** Locality */
  locality?: string | null
  /** Administrative Area Level 2 */
  administrative_area_level_2?: string | null
  /**
   * Administrative Area Level 1
   * @maxLength 63
   */
  administrative_area_level_1: string
  /**
   * Country
   * @maxLength 63
   */
  country: string
  /**
   * Postal Code
   * @maxLength 31
   */
  postal_code: string
  /**
   * Plus Code
   * @maxLength 31
   */
  plus_code: string
  /** Emlak Id */
  emlak_id: number | null
  /** City Slug */
  city_slug?: string | null
  /** District Slug */
  district_slug?: string | null
}

/** BuildingTranslation */
export interface TortoiseContribPydanticCreatorModelsBuildingTranslationLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** Building */
export interface TortoiseContribPydanticCreatorModelsBuildingLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /** Type */
  type?: ModelsType2[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /**
   * Nol
   * Number of levels
   */
  nol?: number | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
}

/** Collection */
export interface TortoiseContribPydanticCreatorModelsCollectionLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Client Name */
  client_name?: string | null
  /**
   * Is Deleted
   * @default false
   */
  is_deleted?: boolean | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
}

/** CompanyTranslation */
export interface TortoiseContribPydanticCreatorModelsCompanyTranslationLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** Company */
export interface TortoiseContribPydanticCreatorModelsCompanyLeaf {
  /**
   * Id
   * @min -32768
   * @max 32767
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /**
   * Year
   * Founded year
   */
  year?: number | null
  /**
   * Email
   * @maxLength 63
   */
  email: string
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /**
   * Address
   * @maxLength 127
   */
  address: string
  /**
   * Website
   * @maxLength 63
   */
  website: string
  /** Type */
  type: CompanyType[]
  /**
   * Featured
   * Featured
   * @default false
   */
  featured?: boolean | null
  /**
   * Only On Topli
   * @default false
   */
  only_on_topli?: boolean | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
}

/** Contact */
export interface TortoiseContribPydanticCreatorModelsContactLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Second Name
   * @maxLength 127
   */
  second_name: string
  /**
   * Fullname
   * @default ""
   */
  fullname?: string | null
  /**
   * Title
   * Mr: 1<br/>Ms: 2<br/>Mis: 3<br/>Dr: 4
   */
  title?: 1 | 2 | 3 | 4 | null
  /** Email */
  email?: string | null
  /**
   * Phone
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  phone: number
  /** Phone2 */
  phone2?: number | null
  /**
   * Is Man
   * Gender
   * @default true
   */
  is_man?: boolean
  /**
   * Is Client
   * Client
   * @default false
   */
  is_client?: boolean | null
  /** Comment */
  comment?: string | null
}

/** EmailsLog */
export interface TortoiseContribPydanticCreatorModelsEmailsLogLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Mail Id
   * @maxLength 255
   */
  mail_id: string
  /**
   * Email
   * @maxLength 255
   */
  email: string
  /**
   * Status
   * @maxLength 255
   */
  status: string
  /**
   * Template
   * @maxLength 255
   */
  template: string
  /** User Id */
  user_id?: number | null
}

/** LandingData */
export interface TortoiseContribPydanticCreatorModelsLandingDataLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Email */
  email?: string | null
  /** Residential Projects */
  residential_projects: any
  /** Avatar Url */
  avatar_url?: string | null
  /** Fullname */
  fullname?: string | null
  /** Description */
  description: string | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /**
   * Client Type
   * Local: 1<br/>International: 2
   * @default 1
   */
  client_type?: 1 | 2
  /** Socials */
  socials: any
  /**
   * Slug
   * @maxLength 255
   */
  slug: string
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /**
   * Hide Name
   * @default false
   */
  hide_name?: boolean | null
  /**
   * Is Published
   * @default true
   */
  is_published?: boolean | null
  /**
   * Ai Auto Project Selection
   * @default true
   */
  ai_auto_project_selection?: boolean | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** LandingForms */
export interface TortoiseContribPydanticCreatorModelsLandingFormsLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Bedrooms */
  bedrooms?: string | null
  /** Client Name */
  client_name?: string | null
  /** Currency */
  currency?: string | null
  /** District */
  district?: string | null
  /** Phone */
  phone: number | null
  /** Price From */
  price_from: number | null
  /** Price To */
  price_to: number | null
  /**
   * Is Read
   * @default false
   */
  is_read?: boolean | null
  /** Residential Id */
  residential_id?: number | null
  /** Residential Name */
  residential_name?: string | null
  /**
   * Form Type
   * Feedback: 1<br/>Info: 2
   */
  form_type: 1 | 2
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** Macrozone */
export interface TortoiseContribPydanticCreatorModelsMacrozoneLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Macrozone
   * @maxLength 100
   */
  macrozone: string
  /**
   * Side
   * @maxLength 50
   */
  side: string
  /** Districts */
  districts: string[]
}

/** Offer */
export interface TortoiseContribPydanticCreatorModelsOfferLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Content */
  content: string
}

/** Order */
export interface TortoiseContribPydanticCreatorModelsOrderLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Status
   * Reservation_pending: 1<br/>Contract_signed: 2<br/>Payment_made: 3<br/>Commission_delivery: 4<br/>Declined_by_developer: 5<br/>Declined_by_platform: 6<br/>Appointment_set: 7<br/>Reservation_confirmed: 8<br/>Commission_received: 9
   * @default 1
   */
  status?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | null
  /** Comment */
  comment?: string | null
  /**
   * Contact Id
   * @min -2147483648
   * @max 2147483647
   */
  contact_id: number
  /**
   * Created By Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  created_by_id: number
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Photo */
export interface TortoiseContribPydanticCreatorModelsPhotoLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Owner
   * Residential: 1<br/>Building: 2<br/>Unit: 3
   * @default 1
   */
  owner: 1 | 2 | 3
  /**
   * Obj Id
   * @min -32768
   * @max 32767
   */
  obj_id: number
  /**
   * Ext
   * @maxLength 4
   */
  ext: string
  /**
   * Crop Box
   * @maxItems 2
   * @minItems 2
   */
  crop_box: any[]
  /**
   * Sort
   * @default 0
   */
  sort?: number | null
  /**
   * Tag
   * Exterior: 1<br/>Interior: 2<br/>Facilities: 3<br/>PublicSpaces: 4<br/>Infrastructure: 5<br/>BirdView: 6<br/>MasterPlan: 7<br/>BuildingProgress: 8
   */
  tag: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /** Polygons */
  polygons: any
}

/** Prices */
export interface TortoiseContribPydanticCreatorModelsPricesLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Is Local
   * Price for locals only
   * @default false
   */
  is_local?: boolean
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /**
   * Price
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price: number
  /**
   * Main
   * Main price
   * @default false
   */
  main?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /**
   * Parent Price Id
   * ID of the parent main price
   */
  parent_price_id: number | null
  /**
   * Unit Id
   * @min -2147483648
   * @max 2147483647
   */
  unit_id: number
}

/** Promotion */
export interface TortoiseContribPydanticCreatorModelsPromotionLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 255
   */
  name: string
  /** Description */
  description: string
  /**
   * Start Date
   * @format date
   */
  start_date: string
  /** End Date */
  end_date?: string | null
  /** Thumbnail */
  thumbnail?: string | null
  /**
   * Is Permanent
   * @default false
   */
  is_permanent?: boolean | null
}

/** Quiz */
export interface TortoiseContribPydanticCreatorModelsQuizLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Apartment Type */
  apartment_type?: number[] | null
  /**
   * Price Min
   * @min -9223372036854776000
   * @max 9223372036854776000
   * @default 0
   */
  price_min?: number
  /**
   * Price Max
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  price_max: number
  /**
   * Purchase Timing
   * Immediately: 1<br/>OneToThreeMonths: 2<br/>ThreeToSixMonths: 3<br/>NotSure: 4
   */
  purchase_timing?: 1 | 2 | 3 | 4 | null
}

/** ResAmenityTranslation */
export interface TortoiseContribPydanticCreatorModelsResAmenityTranslationLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** ResidentialAmenity */
export interface TortoiseContribPydanticCreatorModelsResidentialAmenityLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
}

/** ResidentialPresentation */
export interface TortoiseContribPydanticCreatorModelsResidentialPresentationLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * User Id
   * @min -2147483648
   * @max 2147483647
   */
  user_id: number
}

/** ResidentialTranslation */
export interface TortoiseContribPydanticCreatorModelsResidentialTranslationLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
  /**
   * Residential Id
   * @min -2147483648
   * @max 2147483647
   */
  residential_id: number
}

/** Residential */
export interface TortoiseContribPydanticCreatorModelsResidentialLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * @default true
   */
  activity?: boolean | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Description */
  description?: string | null
  /** Polygon */
  polygon?: any[][] | null
  /** Delivery Date */
  delivery_date?: string | null
  /** Delivery Year */
  delivery_year: number | null
  /**
   * Done
   * Project completed
   * @default true
   */
  done?: boolean | null
  /** Video Url */
  video_url?: string | null
  /**
   * Clas
   * Normal: 1<br/>Business: 2<br/>Luxury: 3
   */
  clas?: 1 | 2 | 3 | null
  /** Purpose */
  purpose?: Purpose[] | null
  /**
   * Currency
   * USD: 1<br/>EUR: 2<br/>TRY: 3
   */
  currency?: 1 | 2 | 3 | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Prices */
  prices?: any[] | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /**
   * Area
   * Total project area
   * @min -2147483648
   * @max 2147483647
   */
  area: number
  /**
   * Areas
   * Lot area range
   */
  areas?: any[] | null
  /**
   * Unitcount
   * Number of residences
   */
  unitcount?: number | null
  /**
   * Car Unitcount
   * Number of parking lots
   */
  car_unitcount?: number | null
  /**
   * Heating
   * Type of heating
   */
  heating?: 1 | 2 | 3 | null
  /** Type */
  type?: ResidenceType[] | null
  /**
   * Parking Type
   * underground: 1<br/>street: 2<br/>no: 3
   */
  parking_type?: 1 | 2 | 3 | null
  /** Project Url */
  project_url?: string | null
  /** Googledrive Url */
  googledrive_url?: string | null
  /** Googledrive Company Url */
  googledrive_company_url?: string | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Residency Supported
   * Supports residency permit
   * @default false
   */
  residency_supported?: boolean
  /** Social Text */
  social_text?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /**
   * Citizenship
   * Eligible for citizenship/residency
   * @default true
   */
  citizenship?: boolean | null
  /**
   * Downpayment
   * Downpayment percentage
   * @default 100
   */
  downpayment?: number | null
  /**
   * Duration
   * Duration of installment plan in months
   * @default 12
   */
  duration?: number | null
  /**
   * Title Deed
   * Title deed payment percentage
   * @default 4
   */
  title_deed?: number | null
  /**
   * Vat
   * VAT percentage
   * @default 18
   */
  vat?: number | null
  /**
   * Local Homepage
   * Show on homepage for local users
   * @default false
   */
  local_homepage?: boolean | null
  /**
   * International Homepage
   * Show on homepage for international users
   * @default false
   */
  international_homepage?: boolean | null
  /** Residential Positions */
  residential_positions: any
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
  /**
   * Grade
   * Grade
   * @default 1
   */
  grade?: 1 | 2 | null
  /**
   * Views Count
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  views_count?: number
  /**
   * Export To Projeturk
   * @default false
   */
  export_to_projeturk?: boolean
  /** Slug */
  slug?: string | null
}

/** Subscribers */
export interface TortoiseContribPydanticCreatorModelsSubscribersLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Telegram Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  telegram_id: number
  /** Firstname */
  firstname?: string | null
  /** Lastname */
  lastname?: string | null
  /**
   * Is Subscribed
   * @default true
   */
  is_subscribed?: boolean
  /**
   * Is Authenticated
   * @default false
   */
  is_authenticated?: boolean
  /**
   * Role
   * @maxLength 50
   * @default "manager"
   */
  role?: string
  /** User Id */
  user_id?: number | null
}

/** Team */
export interface TortoiseContribPydanticCreatorModelsTeamLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Name */
  name?: string | null
  /** Logo Url */
  logo_url?: string | null
  /** Phone */
  phone: number | null
  /** Email */
  email?: string | null
  /** Hash Slug */
  hash_slug?: string | null
  /** Head Name */
  head_name?: string | null
}

/** UnitAmenityTranslation */
export interface TortoiseContribPydanticCreatorModelsUnitAmenityTranslationLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** UnitAmenity */
export interface TortoiseContribPydanticCreatorModelsUnitAmenityLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /** Pic Url */
  pic_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
}

/** UnitPresentation */
export interface TortoiseContribPydanticCreatorModelsUnitPresentationLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * User Id
   * @min -2147483648
   * @max 2147483647
   */
  user_id: number
}

/** UnitTranslation */
export interface TortoiseContribPydanticCreatorModelsUnitTranslationLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** Unit */
export interface TortoiseContribPydanticCreatorModelsUnitLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Activity
   * Is active
   * @default true
   */
  activity?: boolean
  /**
   * Type
   * Apartment: 1<br/>Villa: 2<br/>Townhouse: 3<br/>Duplex: 4<br/>Penthouse: 5<br/>Triplex: 6
   */
  type?: 1 | 2 | 3 | 4 | 5 | 6 | null
  /** Level */
  level?: number | null
  /**
   * Last Floor
   * Is the unit on the last floor
   * @default false
   */
  last_floor?: boolean | null
  /** Price M2 */
  price_m2?: number | null
  /** Size */
  size?: number | null
  /**
   * Net Size
   * @default 0
   */
  net_size?: number | null
  /**
   * Lotsize
   * Lot area
   */
  lotSize?: number | null
  /** Bedrooms */
  bedrooms?: number | null
  /** Bathrooms */
  bathrooms?: number | null
  /**
   * Name
   * @maxLength 127
   */
  name: string
  /**
   * Condition
   * Furnished: 1<br/>Finished: 2
   */
  condition?: 1 | 2 | null
  /** Description */
  description?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Hide Price
   * @default false
   */
  hide_price?: boolean | null
  /** Buildingname */
  buildingName?: string | null
  /** Fee */
  fee?: number | null
  /**
   * Fee Local
   * Fee for local users
   */
  fee_local?: number | null
  /** Agent Fee */
  agent_fee?: number | null
  /** Agent Fee Local */
  agent_fee_local?: number | null
  /** Hn Hash */
  hn_hash?: string | null
  /** Sn Hash */
  sn_hash?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
  /** Unit Positions */
  unit_positions: any
  /** Agents Comments */
  agents_comments: any
  /** Clients Likes */
  clients_likes: any
  /**
   * Default Collection
   * @default false
   */
  default_collection?: boolean | null
  /** Emlak Id */
  emlak_id: number | null
  /** Emlak Code */
  emlak_code?: string | null
  /**
   * Checked Manual
   * @default true
   */
  checked_manual?: boolean | null
}

/** UserActionsLog */
export interface TortoiseContribPydanticCreatorModelsUserActionsLogLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Action
   * RegisterUser: 1<br/>CreatePresentation: 2<br/>CreateCollection: 3<br/>RegisterClient: 4<br/>CreatePDF: 5<br/>EditLanding: 6<br/>CopyLandingLink: 7<br/>PublishLanding: 8<br/>AddClient: 9<br/>DownloadApp: 10<br/>CreateQuiz: 11
   */
  action: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
  /** Link */
  link?: string | null
  /** Contact Id */
  contact_id: number | null
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** UserSessionLog */
export interface TortoiseContribPydanticCreatorModelsUserSessionLogLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Start Session
   * @format date-time
   */
  start_session: string
  /** End Session */
  end_session?: string | null
  /** Browser */
  browser?: string | null
  /** Device */
  device?: string | null
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean
  /**
   * User Id
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  user_id: number
}

/** WebinarTranslations */
export interface TortoiseContribPydanticCreatorModelsWebinarTranslationsLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /**
   * Language
   * @maxLength 10
   */
  language: string
  /** Name */
  name?: string | null
  /** Description */
  description: string | null
  /**
   * Ai Translated
   * @default false
   */
  ai_translated?: boolean | null
}

/** Webinar */
export interface TortoiseContribPydanticCreatorModelsWebinarLeaf {
  /**
   * Id
   * @min -2147483648
   * @max 2147483647
   */
  id: number
  /** Created At */
  created_at: string | null
  /** Updated At */
  updated_at: string | null
  /** Name */
  name?: string | null
  /** Release Date */
  release_date?: string | null
  /** Description */
  description: string | null
  /** Thumbnail */
  thumbnail?: string | null
  /** Video Url */
  video_url?: string | null
  /**
   * Has Ai Translation
   * @default false
   */
  has_ai_translation?: boolean | null
}

export interface GetCollectionNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewCollectionParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetResidentialAmenityNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewResidentialAmenityParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetMacrozoneNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewMacrozoneParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetUnitAmenityNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewUnitAmenityParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetAddressNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewAddressParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetCompanyNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewCompanyParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetQuizNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewQuizParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetTeamNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewTeamParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetSocialPhotoNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewSocialPhotoParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetCompanyTranslationNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewCompanyTranslationParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetUnitPresentationNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewUnitPresentationParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetWebinarNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewWebinarParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetUnitNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewUnitParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetPricesNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewPricesParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetUnitTranslationNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewUnitTranslationParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetBuildingTranslationNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewBuildingTranslationParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetUserSessionLogNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewUserSessionLogParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetUserActionsLogNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewUserActionsLogParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetResidentialTranslationNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewResidentialTranslationParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetResidentialNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewResidentialParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetTemplateNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewTemplateParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetUnitAmenityTranslationNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewUnitAmenityTranslationParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetResAmenityTranslationNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewResAmenityTranslationParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetResidentialPresentationNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewResidentialPresentationParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetSubscribersNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewSubscribersParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetContactNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewContactParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetLandingFormsNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewLandingFormsParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetUserNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewUserParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetWebinarTranslationsNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewWebinarTranslationsParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetPromotionNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewPromotionParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetBuildingNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewBuildingParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetEmailsLogNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewEmailsLogParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetOrderNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewOrderParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetNotificationLogNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewNotificationLogParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetLandingDataNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewLandingDataParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetOfferNamesListParams {
  /** Fname */
  fname?: string
  /** Fval */
  fval?: number | string | boolean
  /** Sname */
  sname?: string
  /** Sid */
  sid?: number
  /**
   * Page
   * @default 1
   */
  page?: number
  /**
   * Limit
   * @default 50
   */
  limit?: number
  /** Search */
  search?: string
}

export interface NewOfferParams {
  /** Item Id */
  item_id?: number | null
}

export interface GetAddrOptsGapiAddrOptsGetParams {
  /** Query */
  query: string
}

export interface PhotosUploadPhotoPostParams {
  owner: ModelsImagableType2
  /** Obj Id */
  obj_id: number
  tag: ModelsPhotoTag2
  /**
   * X
   * @default 0
   */
  x?: number
  /**
   * Y
   * @default 0
   */
  y?: number
  /**
   * Zoom
   * @default 1
   */
  zoom?: number
  /**
   * Sort
   * @default 0
   */
  sort?: number
}

/** Order */
export type PhotosSortPhotoSortPostPayload = object

/** Order */
export type SocialPhotosSortPhotoSocialSortPostPayload = object

export interface PhotoUpdPhotoItemIdPostParams {
  tag: ModelsPhotoTag2
  /**
   * X
   * @default 0
   */
  x?: number
  /**
   * Y
   * @default 0
   */
  y?: number
  /**
   * Zoom
   * @default 1
   */
  zoom?: number
  /**
   * Sort
   * @default 0
   */
  sort?: number
  /** Item Id */
  itemId: number
}

/** Polygons */
export type PhotoEditPolygonPhotoItemIdPolygonPatchPayload = object[] | null

export interface SocialPhotoUpdPhotoSocialItemIdPostParams {
  tag: ModelsPhotoTag2
  /**
   * X
   * @default 0
   */
  x?: number
  /**
   * Y
   * @default 0
   */
  y?: number
  /**
   * Zoom
   * @default 1
   */
  zoom?: number
  /**
   * Sort
   * @default 0
   */
  sort?: number
  /** Item Id */
  itemId: number
}

/** Params */
export type GetAllUnitsPresentationAllUnitsPostPayload = object

/** Params */
export type GetResidentialPresPresentationGetResidentialsPostPayload = object

/** Params */
export type GetUnitPresPresentationGetUnitsPostPayload = object

export interface GetUserStatusesUserGetStatusesGetParams {
  /** User Id */
  user_id: number
}

/** Body */
export type GetClientsV2ClientsPostPayload = object

/** Data */
export type EditCollectionV2CollectionEditIdPatchPayload = object

/** Data */
export type CreateQuizWithCollectionV2QuizCreatePostPayload = object

/** Data */
export type UpdateQuizWithCollectionV2QuizUpdateQuizIdPutPayload = object

/** Body */
export type GetResidentialByIdsV2ResidentialGetByIdsPublicPostPayload = object

/** Kwargs */
export type CreatePublicNotificationsV2NotificationLogPublicPutPayload = object

/** Kwargs */
export type CreateLdNotificationV2NotificationLogPublicLdPutPayload = object

/** Data */
export type EditNotificationV2NotificationLogEditIdPatchPayload = object

/** Data */
export type EditLandingDataV2LandingDataEditIdPatchPayload = object

/** Body */
export type PublishLdV2LandingDataPublishIdPostPayload = object

/** Data */
export type EditContactV2ContactEditIdPatchPayload = object

/** Body */
export type LandingFormsReedNotificationV2LandingFormsReadIdPostPayload = object

export namespace Auth {
  /**
   * @description Signup
   * @tags auth
   * @name Register
   * @summary Signup
   * @request POST:/register
   * @response `200` `Token` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace Register {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = UserReg
    export type RequestHeaders = {}
    export type ResponseBody = Token
  }
  /**
   * @description Login For Access Token
   * @tags auth
   * @name Token
   * @summary Login For Access Token
   * @request POST:/token
   * @response `200` `Token` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace Token {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = LoginFormData
    export type RequestHeaders = {}
    export type ResponseBody = Token
  }
  /**
   * @description Change Password
   * @tags auth
   * @name ChangePasswordChangePasswordUidPatch
   * @summary Change Password
   * @request PATCH:/change-password/{uid}
   * @secure
   * @response `200` `string` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace ChangePasswordChangePasswordUidPatch {
    export type RequestParams = {
      /** Uid */
      uid: number
    }
    export type RequestQuery = {}
    export type RequestBody = ChangePwdBody
    export type RequestHeaders = {}
    export type ResponseBody = string
  }
  /**
   * @description Send Sms
   * @tags auth
   * @name SendSmsAuthGetSmsPost
   * @summary Send Sms
   * @request POST:/auth/get-sms
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SendSmsAuthGetSmsPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = SendSMSBody
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Verify Code
   * @tags auth
   * @name VerifyCodeAuthVerifySmsPost
   * @summary Verify Code
   * @request POST:/auth/verify-sms
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace VerifyCodeAuthVerifySmsPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = VerifySMSBody
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Reg User
   * @tags auth
   * @name RegUserAuthSignUpPost
   * @summary Reg User
   * @request POST:/auth/sign-up
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace RegUserAuthSignUpPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = UserReg
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Google Auth
   * @tags auth
   * @name GoogleAuthAuthGooglePost
   * @summary Google Auth
   * @request POST:/auth/google
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GoogleAuthAuthGooglePost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = AuthGoogle
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Send Pwd Recovery Code
   * @tags auth
   * @name SendPwdRecoveryCodeAuthRecoveryPwdGetCodePost
   * @summary Send Pwd Recovery Code
   * @request POST:/auth/recovery_pwd/get_code
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SendPwdRecoveryCodeAuthRecoveryPwdGetCodePost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = RecoveryPwdSendEmailBody
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Verify Recovery Code
   * @tags auth
   * @name VerifyRecoveryCodeAuthRecoveryPwdVerifyCodePost
   * @summary Verify Recovery Code
   * @request POST:/auth/recovery_pwd/verify_code
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace VerifyRecoveryCodeAuthRecoveryPwdVerifyCodePost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = VerifyRecPwdBody
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Recovery Pwd
   * @tags auth
   * @name RecoveryPwdAuthRecoveryPwdSetNewPwdPost
   * @summary Recovery Pwd
   * @request POST:/auth/recovery_pwd/set_new_pwd
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace RecoveryPwdAuthRecoveryPwdSetNewPwdPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = RecoveryPwdBody
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Save Phone Tmp
   * @tags auth
   * @name SavePhoneTmpAuthSavePhonePost
   * @summary Save Phone Tmp
   * @request POST:/auth/save-phone
   * @response `200` `Token` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SavePhoneTmpAuthSavePhonePost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = SavePhoneTmpBody
    export type RequestHeaders = {}
    export type ResponseBody = Token
  }
}

export namespace Collection {
  /**
   * @description Collection Objects List
   * @tags Collection
   * @name GetCollectionList
   * @summary Collection Objects List
   * @request POST:/v2/Collection
   * @secure
   * @response `200` `CollectionList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetCollectionList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = CollectionList
  }
  /**
   * @description Collection Names List
   * @tags Collection
   * @name GetCollectionNamesList
   * @summary Collection Names List
   * @request GET:/v2/Collection
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetCollectionNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Collection Object Create
   * @tags Collection
   * @name NewCollection
   * @summary Collection Object Create
   * @request PUT:/v2/Collection
   * @secure
   * @response `200` `Collection` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewCollection {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = CollectionIn
    export type RequestHeaders = {}
    export type ResponseBody = Collection
  }
  /**
   * @description Collection Object Get
   * @tags Collection
   * @name GetCollection
   * @summary Collection Object Get
   * @request GET:/v2/Collection/{item_id}
   * @secure
   * @response `200` `Collection` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetCollection {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Collection
  }
  /**
   * @description Collection Object Update
   * @tags Collection
   * @name UpdCollection
   * @summary Collection Object Update
   * @request PATCH:/v2/Collection/{item_id}
   * @secure
   * @response `200` `Collection` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdCollection {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = CollectionIn
    export type RequestHeaders = {}
    export type ResponseBody = Collection
  }
  /**
   * @description Collection Object Delete
   * @tags Collection
   * @name DelCollection
   * @summary Collection Object Delete
   * @request DELETE:/v2/Collection/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelCollection {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get Public Collection
   * @tags Collection
   * @name GetPublicCollectionV2CollectionPublicHashSlugPost
   * @summary Get Public Collection
   * @request POST:/v2/Collection/public/{hash_slug}
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetPublicCollectionV2CollectionPublicHashSlugPost {
    export type RequestParams = {
      /** Hash Slug */
      hashSlug: string
    }
    export type RequestQuery = {}
    export type RequestBody = PubColBody
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Fill Unique Hash Slugs
   * @tags Collection
   * @name FillUniqueHashSlugsV2CollectionUpdateSlugPost
   * @summary Fill Unique Hash Slugs
   * @request POST:/v2/Collection/update-slug
   * @response `200` `any` Successful Response
   */
  export namespace FillUniqueHashSlugsV2CollectionUpdateSlugPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Edit Collection
   * @tags Collection
   * @name EditCollectionV2CollectionEditIdPatch
   * @summary Edit Collection
   * @request PATCH:/v2/Collection/edit/{id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace EditCollectionV2CollectionEditIdPatch {
    export type RequestParams = {
      /** Id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = EditCollectionV2CollectionEditIdPatchPayload
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Safe Delete
   * @tags Collection
   * @name SafeDeleteV2CollectionSafeDeleteCollectionIdDelete
   * @summary Safe Delete
   * @request DELETE:/v2/Collection/safe-delete/{collection_id}
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SafeDeleteV2CollectionSafeDeleteCollectionIdDelete {
    export type RequestParams = {
      /** Collection Id */
      collectionId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace ResidentialAmenity {
  /**
   * @description Residentialamenity Objects List
   * @tags ResidentialAmenity
   * @name GetResidentialAmenityList
   * @summary Residentialamenity Objects List
   * @request POST:/v2/ResidentialAmenity
   * @secure
   * @response `200` `ResidentialAmenityList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialAmenityList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialAmenityList
  }
  /**
   * @description Residentialamenity Names List
   * @tags ResidentialAmenity
   * @name GetResidentialAmenityNamesList
   * @summary Residentialamenity Names List
   * @request GET:/v2/ResidentialAmenity
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialAmenityNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Residentialamenity Object Create
   * @tags ResidentialAmenity
   * @name NewResidentialAmenity
   * @summary Residentialamenity Object Create
   * @request PUT:/v2/ResidentialAmenity
   * @secure
   * @response `200` `ResidentialAmenity` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewResidentialAmenity {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = ResidentialAmenityIn
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialAmenity
  }
  /**
   * @description Residentialamenity Object Get
   * @tags ResidentialAmenity
   * @name GetResidentialAmenity
   * @summary Residentialamenity Object Get
   * @request GET:/v2/ResidentialAmenity/{item_id}
   * @secure
   * @response `200` `ResidentialAmenity` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialAmenity {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialAmenity
  }
  /**
   * @description Residentialamenity Object Update
   * @tags ResidentialAmenity
   * @name UpdResidentialAmenity
   * @summary Residentialamenity Object Update
   * @request PATCH:/v2/ResidentialAmenity/{item_id}
   * @secure
   * @response `200` `ResidentialAmenity` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdResidentialAmenity {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = ResidentialAmenityIn
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialAmenity
  }
  /**
   * @description Residentialamenity Object Delete
   * @tags ResidentialAmenity
   * @name DelResidentialAmenity
   * @summary Residentialamenity Object Delete
   * @request DELETE:/v2/ResidentialAmenity/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelResidentialAmenity {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Macrozone {
  /**
   * @description Macrozone Objects List
   * @tags Macrozone
   * @name GetMacrozoneList
   * @summary Macrozone Objects List
   * @request POST:/v2/Macrozone
   * @secure
   * @response `200` `MacrozoneList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetMacrozoneList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = MacrozoneList
  }
  /**
   * @description Macrozone Names List
   * @tags Macrozone
   * @name GetMacrozoneNamesList
   * @summary Macrozone Names List
   * @request GET:/v2/Macrozone
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetMacrozoneNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Macrozone Object Create
   * @tags Macrozone
   * @name NewMacrozone
   * @summary Macrozone Object Create
   * @request PUT:/v2/Macrozone
   * @secure
   * @response `200` `Macrozone` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewMacrozone {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = MacrozoneIn
    export type RequestHeaders = {}
    export type ResponseBody = Macrozone
  }
  /**
   * @description Macrozone Object Get
   * @tags Macrozone
   * @name GetMacrozone
   * @summary Macrozone Object Get
   * @request GET:/v2/Macrozone/{item_id}
   * @secure
   * @response `200` `Macrozone` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetMacrozone {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Macrozone
  }
  /**
   * @description Macrozone Object Update
   * @tags Macrozone
   * @name UpdMacrozone
   * @summary Macrozone Object Update
   * @request PATCH:/v2/Macrozone/{item_id}
   * @secure
   * @response `200` `Macrozone` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdMacrozone {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = MacrozoneIn
    export type RequestHeaders = {}
    export type ResponseBody = Macrozone
  }
  /**
   * @description Macrozone Object Delete
   * @tags Macrozone
   * @name DelMacrozone
   * @summary Macrozone Object Delete
   * @request DELETE:/v2/Macrozone/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelMacrozone {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace UnitAmenity {
  /**
   * @description Unitamenity Objects List
   * @tags UnitAmenity
   * @name GetUnitAmenityList
   * @summary Unitamenity Objects List
   * @request POST:/v2/UnitAmenity
   * @secure
   * @response `200` `UnitAmenityList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitAmenityList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = UnitAmenityList
  }
  /**
   * @description Unitamenity Names List
   * @tags UnitAmenity
   * @name GetUnitAmenityNamesList
   * @summary Unitamenity Names List
   * @request GET:/v2/UnitAmenity
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitAmenityNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Unitamenity Object Create
   * @tags UnitAmenity
   * @name NewUnitAmenity
   * @summary Unitamenity Object Create
   * @request PUT:/v2/UnitAmenity
   * @secure
   * @response `200` `UnitAmenity` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewUnitAmenity {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = UnitAmenityIn
    export type RequestHeaders = {}
    export type ResponseBody = UnitAmenity
  }
  /**
   * @description Unitamenity Object Get
   * @tags UnitAmenity
   * @name GetUnitAmenity
   * @summary Unitamenity Object Get
   * @request GET:/v2/UnitAmenity/{item_id}
   * @secure
   * @response `200` `UnitAmenity` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitAmenity {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = UnitAmenity
  }
  /**
   * @description Unitamenity Object Update
   * @tags UnitAmenity
   * @name UpdUnitAmenity
   * @summary Unitamenity Object Update
   * @request PATCH:/v2/UnitAmenity/{item_id}
   * @secure
   * @response `200` `UnitAmenity` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdUnitAmenity {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = UnitAmenityIn
    export type RequestHeaders = {}
    export type ResponseBody = UnitAmenity
  }
  /**
   * @description Unitamenity Object Delete
   * @tags UnitAmenity
   * @name DelUnitAmenity
   * @summary Unitamenity Object Delete
   * @request DELETE:/v2/UnitAmenity/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelUnitAmenity {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Address {
  /**
   * @description Address Objects List
   * @tags Address
   * @name GetAddressList
   * @summary Address Objects List
   * @request POST:/v2/Address
   * @secure
   * @response `200` `AddressList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetAddressList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = AddressList
  }
  /**
   * @description Address Names List
   * @tags Address
   * @name GetAddressNamesList
   * @summary Address Names List
   * @request GET:/v2/Address
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetAddressNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Address Object Create
   * @tags Address
   * @name NewAddress
   * @summary Address Object Create
   * @request PUT:/v2/Address
   * @secure
   * @response `200` `Address` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewAddress {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = AddressIn
    export type RequestHeaders = {}
    export type ResponseBody = Address
  }
  /**
   * @description Address Object Get
   * @tags Address
   * @name GetAddress
   * @summary Address Object Get
   * @request GET:/v2/Address/{item_id}
   * @secure
   * @response `200` `Address` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetAddress {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Address
  }
  /**
   * @description Address Object Update
   * @tags Address
   * @name UpdAddress
   * @summary Address Object Update
   * @request PATCH:/v2/Address/{item_id}
   * @secure
   * @response `200` `Address` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdAddress {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = AddressIn
    export type RequestHeaders = {}
    export type ResponseBody = Address
  }
  /**
   * @description Address Object Delete
   * @tags Address
   * @name DelAddress
   * @summary Address Object Delete
   * @request DELETE:/v2/Address/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelAddress {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get Locations
   * @tags Address
   * @name GetLocationsGetLocationsPost
   * @summary Get Locations
   * @request POST:/get-locations
   * @secure
   * @response `200` `LocationsResult` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetLocationsGetLocationsPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = GetLocationBody
    export type RequestHeaders = {}
    export type ResponseBody = LocationsResult
  }
}

export namespace Company {
  /**
   * @description Company Objects List
   * @tags Company
   * @name GetCompanyList
   * @summary Company Objects List
   * @request POST:/v2/Company
   * @secure
   * @response `200` `CompanyList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetCompanyList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = CompanyList
  }
  /**
   * @description Company Names List
   * @tags Company
   * @name GetCompanyNamesList
   * @summary Company Names List
   * @request GET:/v2/Company
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetCompanyNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Company Object Create
   * @tags Company
   * @name NewCompany
   * @summary Company Object Create
   * @request PUT:/v2/Company
   * @secure
   * @response `200` `Company` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewCompany {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = CompanyIn
    export type RequestHeaders = {}
    export type ResponseBody = Company
  }
  /**
   * @description Company Object Get
   * @tags Company
   * @name GetCompany
   * @summary Company Object Get
   * @request GET:/v2/Company/{item_id}
   * @secure
   * @response `200` `Company` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetCompany {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Company
  }
  /**
   * @description Company Object Update
   * @tags Company
   * @name UpdCompany
   * @summary Company Object Update
   * @request PATCH:/v2/Company/{item_id}
   * @secure
   * @response `200` `Company` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdCompany {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = CompanyIn
    export type RequestHeaders = {}
    export type ResponseBody = Company
  }
  /**
   * @description Company Object Delete
   * @tags Company
   * @name DelCompany
   * @summary Company Object Delete
   * @request DELETE:/v2/Company/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelCompany {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Quiz {
  /**
   * @description Quiz Objects List
   * @tags Quiz
   * @name GetQuizList
   * @summary Quiz Objects List
   * @request POST:/v2/Quiz
   * @secure
   * @response `200` `QuizList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetQuizList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = QuizList
  }
  /**
   * @description Quiz Names List
   * @tags Quiz
   * @name GetQuizNamesList
   * @summary Quiz Names List
   * @request GET:/v2/Quiz
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetQuizNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Quiz Object Create
   * @tags Quiz
   * @name NewQuiz
   * @summary Quiz Object Create
   * @request PUT:/v2/Quiz
   * @secure
   * @response `200` `Quiz` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewQuiz {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = QuizIn
    export type RequestHeaders = {}
    export type ResponseBody = Quiz
  }
  /**
   * @description Quiz Object Get
   * @tags Quiz
   * @name GetQuiz
   * @summary Quiz Object Get
   * @request GET:/v2/Quiz/{item_id}
   * @secure
   * @response `200` `Quiz` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetQuiz {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Quiz
  }
  /**
   * @description Quiz Object Update
   * @tags Quiz
   * @name UpdQuiz
   * @summary Quiz Object Update
   * @request PATCH:/v2/Quiz/{item_id}
   * @secure
   * @response `200` `Quiz` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdQuiz {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = QuizIn
    export type RequestHeaders = {}
    export type ResponseBody = Quiz
  }
  /**
   * @description Quiz Object Delete
   * @tags Quiz
   * @name DelQuiz
   * @summary Quiz Object Delete
   * @request DELETE:/v2/Quiz/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelQuiz {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Create Quiz With Collection
   * @tags Quiz
   * @name CreateQuizWithCollectionV2QuizCreatePost
   * @summary Create Quiz With Collection
   * @request POST:/v2/Quiz/create
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace CreateQuizWithCollectionV2QuizCreatePost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = CreateQuizWithCollectionV2QuizCreatePostPayload
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Update Quiz With Collection
   * @tags Quiz
   * @name UpdateQuizWithCollectionV2QuizUpdateQuizIdPut
   * @summary Update Quiz With Collection
   * @request PUT:/v2/Quiz/update/{quiz_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdateQuizWithCollectionV2QuizUpdateQuizIdPut {
    export type RequestParams = {
      /** Quiz Id */
      quizId: number
    }
    export type RequestQuery = {}
    export type RequestBody = UpdateQuizWithCollectionV2QuizUpdateQuizIdPutPayload
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Delete Quiz
   * @tags Quiz
   * @name DeleteQuizV2QuizDeleteQuizIdDelete
   * @summary Delete Quiz
   * @request DELETE:/v2/Quiz/delete/{quiz_id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DeleteQuizV2QuizDeleteQuizIdDelete {
    export type RequestParams = {
      /** Quiz Id */
      quizId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace Team {
  /**
   * @description Team Objects List
   * @tags Team
   * @name GetTeamList
   * @summary Team Objects List
   * @request POST:/v2/Team
   * @secure
   * @response `200` `TeamList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetTeamList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = TeamList
  }
  /**
   * @description Team Names List
   * @tags Team
   * @name GetTeamNamesList
   * @summary Team Names List
   * @request GET:/v2/Team
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetTeamNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Team Object Create
   * @tags Team
   * @name NewTeam
   * @summary Team Object Create
   * @request PUT:/v2/Team
   * @secure
   * @response `200` `Team` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewTeam {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = TeamIn
    export type RequestHeaders = {}
    export type ResponseBody = Team
  }
  /**
   * @description Team Object Get
   * @tags Team
   * @name GetTeam
   * @summary Team Object Get
   * @request GET:/v2/Team/{item_id}
   * @secure
   * @response `200` `Team` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetTeam {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Team
  }
  /**
   * @description Team Object Update
   * @tags Team
   * @name UpdTeam
   * @summary Team Object Update
   * @request PATCH:/v2/Team/{item_id}
   * @secure
   * @response `200` `Team` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdTeam {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = TeamIn
    export type RequestHeaders = {}
    export type ResponseBody = Team
  }
  /**
   * @description Team Object Delete
   * @tags Team
   * @name DelTeam
   * @summary Team Object Delete
   * @request DELETE:/v2/Team/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelTeam {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get Team
   * @tags Team
   * @name GetTeamV2TeamGetTeamHashGet
   * @summary Get Team
   * @request GET:/v2/Team/get_team/{hash}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetTeamV2TeamGetTeamHashGet {
    export type RequestParams = {
      /** Hash */
      hash: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Create Team
   * @tags Team
   * @name CreateTeamV2TeamCreateUserIdPost
   * @summary Create Team
   * @request POST:/v2/Team/create/{user_id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace CreateTeamV2TeamCreateUserIdPost {
    export type RequestParams = {
      /** User Id */
      userId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Add Team Member
   * @tags Team
   * @name AddTeamMemberV2TeamAddMemberTeamIdUserIdPost
   * @summary Add Team Member
   * @request POST:/v2/Team/add-member/{team_id}/{user_id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace AddTeamMemberV2TeamAddMemberTeamIdUserIdPost {
    export type RequestParams = {
      /** User Id */
      userId: number
      /** Team Id */
      teamId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Remove User From Team
   * @tags Team
   * @name RemoveUserFromTeamV2TeamRemoveMemberUserIdPost
   * @summary Remove User From Team
   * @request POST:/v2/Team/remove-member/{user_id}
   * @secure
   * @response `200` `(any)[]` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace RemoveUserFromTeamV2TeamRemoveMemberUserIdPost {
    export type RequestParams = {
      /** User Id */
      userId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any[]
  }
  /**
   * @description Invite User To Team
   * @tags Team
   * @name InviteUserToTeamV2TeamInviteMemberPost
   * @summary Invite User To Team
   * @request POST:/v2/Team/invite-member
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace InviteUserToTeamV2TeamInviteMemberPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = InviteToTeam
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Update Team And Members
   * @tags Team
   * @name UpdateTeamAndMembersV2TeamUpdateTeamPost
   * @summary Update Team And Members
   * @request POST:/v2/Team/update-team
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdateTeamAndMembersV2TeamUpdateTeamPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = UpdateTeamDto
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Block All Team Users
   * @tags Team
   * @name BlockAllTeamUsersV2TeamBlockTeamHashSlugPost
   * @summary Block All Team Users
   * @request POST:/v2/Team/block-team/{hash_slug}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace BlockAllTeamUsersV2TeamBlockTeamHashSlugPost {
    export type RequestParams = {
      /** Hash Slug */
      hashSlug: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace SocialPhoto {
  /**
   * @description Socialphoto Objects List
   * @tags SocialPhoto
   * @name GetSocialPhotoList
   * @summary Socialphoto Objects List
   * @request POST:/v2/SocialPhoto
   * @secure
   * @response `200` `SocialPhotoList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetSocialPhotoList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = SocialPhotoList
  }
  /**
   * @description Socialphoto Names List
   * @tags SocialPhoto
   * @name GetSocialPhotoNamesList
   * @summary Socialphoto Names List
   * @request GET:/v2/SocialPhoto
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetSocialPhotoNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Socialphoto Object Create
   * @tags SocialPhoto
   * @name NewSocialPhoto
   * @summary Socialphoto Object Create
   * @request PUT:/v2/SocialPhoto
   * @secure
   * @response `200` `SocialPhoto` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewSocialPhoto {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = SocialPhotoIn
    export type RequestHeaders = {}
    export type ResponseBody = SocialPhoto
  }
  /**
   * @description Socialphoto Object Get
   * @tags SocialPhoto
   * @name GetSocialPhoto
   * @summary Socialphoto Object Get
   * @request GET:/v2/SocialPhoto/{item_id}
   * @secure
   * @response `200` `SocialPhoto` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetSocialPhoto {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = SocialPhoto
  }
  /**
   * @description Socialphoto Object Update
   * @tags SocialPhoto
   * @name UpdSocialPhoto
   * @summary Socialphoto Object Update
   * @request PATCH:/v2/SocialPhoto/{item_id}
   * @secure
   * @response `200` `SocialPhoto` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdSocialPhoto {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = SocialPhotoIn
    export type RequestHeaders = {}
    export type ResponseBody = SocialPhoto
  }
  /**
   * @description Socialphoto Object Delete
   * @tags SocialPhoto
   * @name DelSocialPhoto
   * @summary Socialphoto Object Delete
   * @request DELETE:/v2/SocialPhoto/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelSocialPhoto {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace CompanyTranslation {
  /**
   * @description Companytranslation Objects List
   * @tags CompanyTranslation
   * @name GetCompanyTranslationList
   * @summary Companytranslation Objects List
   * @request POST:/v2/CompanyTranslation
   * @secure
   * @response `200` `CompanyTranslationList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetCompanyTranslationList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = CompanyTranslationList
  }
  /**
   * @description Companytranslation Names List
   * @tags CompanyTranslation
   * @name GetCompanyTranslationNamesList
   * @summary Companytranslation Names List
   * @request GET:/v2/CompanyTranslation
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetCompanyTranslationNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Companytranslation Object Create
   * @tags CompanyTranslation
   * @name NewCompanyTranslation
   * @summary Companytranslation Object Create
   * @request PUT:/v2/CompanyTranslation
   * @secure
   * @response `200` `CompanyTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewCompanyTranslation {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = CompanyTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = CompanyTranslation
  }
  /**
   * @description Companytranslation Object Get
   * @tags CompanyTranslation
   * @name GetCompanyTranslation
   * @summary Companytranslation Object Get
   * @request GET:/v2/CompanyTranslation/{item_id}
   * @secure
   * @response `200` `CompanyTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetCompanyTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = CompanyTranslation
  }
  /**
   * @description Companytranslation Object Update
   * @tags CompanyTranslation
   * @name UpdCompanyTranslation
   * @summary Companytranslation Object Update
   * @request PATCH:/v2/CompanyTranslation/{item_id}
   * @secure
   * @response `200` `CompanyTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdCompanyTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = CompanyTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = CompanyTranslation
  }
  /**
   * @description Companytranslation Object Delete
   * @tags CompanyTranslation
   * @name DelCompanyTranslation
   * @summary Companytranslation Object Delete
   * @request DELETE:/v2/CompanyTranslation/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelCompanyTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace UnitPresentation {
  /**
   * @description Unitpresentation Objects List
   * @tags UnitPresentation
   * @name GetUnitPresentationList
   * @summary Unitpresentation Objects List
   * @request POST:/v2/UnitPresentation
   * @secure
   * @response `200` `UnitPresentationList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitPresentationList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = UnitPresentationList
  }
  /**
   * @description Unitpresentation Names List
   * @tags UnitPresentation
   * @name GetUnitPresentationNamesList
   * @summary Unitpresentation Names List
   * @request GET:/v2/UnitPresentation
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitPresentationNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Unitpresentation Object Create
   * @tags UnitPresentation
   * @name NewUnitPresentation
   * @summary Unitpresentation Object Create
   * @request PUT:/v2/UnitPresentation
   * @secure
   * @response `200` `UnitPresentation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewUnitPresentation {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = UnitPresentationIn
    export type RequestHeaders = {}
    export type ResponseBody = UnitPresentation
  }
  /**
   * @description Unitpresentation Object Get
   * @tags UnitPresentation
   * @name GetUnitPresentation
   * @summary Unitpresentation Object Get
   * @request GET:/v2/UnitPresentation/{item_id}
   * @secure
   * @response `200` `UnitPresentation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitPresentation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = UnitPresentation
  }
  /**
   * @description Unitpresentation Object Update
   * @tags UnitPresentation
   * @name UpdUnitPresentation
   * @summary Unitpresentation Object Update
   * @request PATCH:/v2/UnitPresentation/{item_id}
   * @secure
   * @response `200` `UnitPresentation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdUnitPresentation {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = UnitPresentationIn
    export type RequestHeaders = {}
    export type ResponseBody = UnitPresentation
  }
  /**
   * @description Unitpresentation Object Delete
   * @tags UnitPresentation
   * @name DelUnitPresentation
   * @summary Unitpresentation Object Delete
   * @request DELETE:/v2/UnitPresentation/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelUnitPresentation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Webinar {
  /**
   * @description Webinar Objects List
   * @tags Webinar
   * @name GetWebinarList
   * @summary Webinar Objects List
   * @request POST:/v2/Webinar
   * @secure
   * @response `200` `WebinarList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetWebinarList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = WebinarList
  }
  /**
   * @description Webinar Names List
   * @tags Webinar
   * @name GetWebinarNamesList
   * @summary Webinar Names List
   * @request GET:/v2/Webinar
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetWebinarNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Webinar Object Create
   * @tags Webinar
   * @name NewWebinar
   * @summary Webinar Object Create
   * @request PUT:/v2/Webinar
   * @secure
   * @response `200` `Webinar` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewWebinar {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = WebinarIn
    export type RequestHeaders = {}
    export type ResponseBody = Webinar
  }
  /**
   * @description Webinar Object Get
   * @tags Webinar
   * @name GetWebinar
   * @summary Webinar Object Get
   * @request GET:/v2/Webinar/{item_id}
   * @secure
   * @response `200` `Webinar` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetWebinar {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Webinar
  }
  /**
   * @description Webinar Object Update
   * @tags Webinar
   * @name UpdWebinar
   * @summary Webinar Object Update
   * @request PATCH:/v2/Webinar/{item_id}
   * @secure
   * @response `200` `Webinar` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdWebinar {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = WebinarIn
    export type RequestHeaders = {}
    export type ResponseBody = Webinar
  }
  /**
   * @description Webinar Object Delete
   * @tags Webinar
   * @name DelWebinar
   * @summary Webinar Object Delete
   * @request DELETE:/v2/Webinar/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelWebinar {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Unit {
  /**
   * @description Unit Objects List
   * @tags Unit
   * @name GetUnitList
   * @summary Unit Objects List
   * @request POST:/v2/Unit
   * @secure
   * @response `200` `UnitList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = UnitList
  }
  /**
   * @description Unit Names List
   * @tags Unit
   * @name GetUnitNamesList
   * @summary Unit Names List
   * @request GET:/v2/Unit
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Unit Object Create
   * @tags Unit
   * @name NewUnit
   * @summary Unit Object Create
   * @request PUT:/v2/Unit
   * @secure
   * @response `200` `Unit` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewUnit {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = UnitIn
    export type RequestHeaders = {}
    export type ResponseBody = Unit
  }
  /**
   * @description Unit Object Get
   * @tags Unit
   * @name GetUnit
   * @summary Unit Object Get
   * @request GET:/v2/Unit/{item_id}
   * @secure
   * @response `200` `Unit` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnit {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Unit
  }
  /**
   * @description Unit Object Update
   * @tags Unit
   * @name UpdUnit
   * @summary Unit Object Update
   * @request PATCH:/v2/Unit/{item_id}
   * @secure
   * @response `200` `Unit` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdUnit {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = UnitIn
    export type RequestHeaders = {}
    export type ResponseBody = Unit
  }
  /**
   * @description Unit Object Delete
   * @tags Unit
   * @name DelUnit
   * @summary Unit Object Delete
   * @request DELETE:/v2/Unit/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelUnit {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Prices {
  /**
   * @description Prices Objects List
   * @tags Prices
   * @name GetPricesList
   * @summary Prices Objects List
   * @request POST:/v2/Prices
   * @secure
   * @response `200` `PricesList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetPricesList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = PricesList
  }
  /**
   * @description Prices Names List
   * @tags Prices
   * @name GetPricesNamesList
   * @summary Prices Names List
   * @request GET:/v2/Prices
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetPricesNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Prices Object Create
   * @tags Prices
   * @name NewPrices
   * @summary Prices Object Create
   * @request PUT:/v2/Prices
   * @secure
   * @response `200` `Prices` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewPrices {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = PricesIn
    export type RequestHeaders = {}
    export type ResponseBody = Prices
  }
  /**
   * @description Prices Object Get
   * @tags Prices
   * @name GetPrices
   * @summary Prices Object Get
   * @request GET:/v2/Prices/{item_id}
   * @secure
   * @response `200` `Prices` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetPrices {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Prices
  }
  /**
   * @description Prices Object Update
   * @tags Prices
   * @name UpdPrices
   * @summary Prices Object Update
   * @request PATCH:/v2/Prices/{item_id}
   * @secure
   * @response `200` `Prices` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdPrices {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = PricesIn
    export type RequestHeaders = {}
    export type ResponseBody = Prices
  }
  /**
   * @description Prices Object Delete
   * @tags Prices
   * @name DelPrices
   * @summary Prices Object Delete
   * @request DELETE:/v2/Prices/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelPrices {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Add Prices
   * @tags Prices
   * @name AddPricesV2PricesAddPricesPut
   * @summary Add Prices
   * @request PUT:/v2/Prices/add-prices
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace AddPricesV2PricesAddPricesPut {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = PricesBody
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Edit Prices
   * @tags Prices
   * @name EditPricesV2PricesEditPricesPut
   * @summary Edit Prices
   * @request PUT:/v2/Prices/edit-prices
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace EditPricesV2PricesEditPricesPut {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = PricesBody
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Delete Prices
   * @tags Prices
   * @name DeletePricesV2PricesDeletePricesPost
   * @summary Delete Prices
   * @request POST:/v2/Prices/delete-prices
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DeletePricesV2PricesDeletePricesPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = DeletePriceBody
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Send Price Request
   * @tags Prices
   * @name SendPriceRequestPriceRequestPost
   * @summary Send Price Request
   * @request POST:/price-request
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SendPriceRequestPriceRequestPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = PriceRequest
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace UnitTranslation {
  /**
   * @description Unittranslation Objects List
   * @tags UnitTranslation
   * @name GetUnitTranslationList
   * @summary Unittranslation Objects List
   * @request POST:/v2/UnitTranslation
   * @secure
   * @response `200` `UnitTranslationList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitTranslationList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = UnitTranslationList
  }
  /**
   * @description Unittranslation Names List
   * @tags UnitTranslation
   * @name GetUnitTranslationNamesList
   * @summary Unittranslation Names List
   * @request GET:/v2/UnitTranslation
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitTranslationNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Unittranslation Object Create
   * @tags UnitTranslation
   * @name NewUnitTranslation
   * @summary Unittranslation Object Create
   * @request PUT:/v2/UnitTranslation
   * @secure
   * @response `200` `UnitTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewUnitTranslation {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = UnitTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = UnitTranslation
  }
  /**
   * @description Unittranslation Object Get
   * @tags UnitTranslation
   * @name GetUnitTranslation
   * @summary Unittranslation Object Get
   * @request GET:/v2/UnitTranslation/{item_id}
   * @secure
   * @response `200` `UnitTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = UnitTranslation
  }
  /**
   * @description Unittranslation Object Update
   * @tags UnitTranslation
   * @name UpdUnitTranslation
   * @summary Unittranslation Object Update
   * @request PATCH:/v2/UnitTranslation/{item_id}
   * @secure
   * @response `200` `UnitTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdUnitTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = UnitTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = UnitTranslation
  }
  /**
   * @description Unittranslation Object Delete
   * @tags UnitTranslation
   * @name DelUnitTranslation
   * @summary Unittranslation Object Delete
   * @request DELETE:/v2/UnitTranslation/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelUnitTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace BuildingTranslation {
  /**
   * @description Buildingtranslation Objects List
   * @tags BuildingTranslation
   * @name GetBuildingTranslationList
   * @summary Buildingtranslation Objects List
   * @request POST:/v2/BuildingTranslation
   * @secure
   * @response `200` `BuildingTranslationList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetBuildingTranslationList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = BuildingTranslationList
  }
  /**
   * @description Buildingtranslation Names List
   * @tags BuildingTranslation
   * @name GetBuildingTranslationNamesList
   * @summary Buildingtranslation Names List
   * @request GET:/v2/BuildingTranslation
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetBuildingTranslationNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Buildingtranslation Object Create
   * @tags BuildingTranslation
   * @name NewBuildingTranslation
   * @summary Buildingtranslation Object Create
   * @request PUT:/v2/BuildingTranslation
   * @secure
   * @response `200` `BuildingTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewBuildingTranslation {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = BuildingTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = BuildingTranslation
  }
  /**
   * @description Buildingtranslation Object Get
   * @tags BuildingTranslation
   * @name GetBuildingTranslation
   * @summary Buildingtranslation Object Get
   * @request GET:/v2/BuildingTranslation/{item_id}
   * @secure
   * @response `200` `BuildingTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetBuildingTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = BuildingTranslation
  }
  /**
   * @description Buildingtranslation Object Update
   * @tags BuildingTranslation
   * @name UpdBuildingTranslation
   * @summary Buildingtranslation Object Update
   * @request PATCH:/v2/BuildingTranslation/{item_id}
   * @secure
   * @response `200` `BuildingTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdBuildingTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = BuildingTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = BuildingTranslation
  }
  /**
   * @description Buildingtranslation Object Delete
   * @tags BuildingTranslation
   * @name DelBuildingTranslation
   * @summary Buildingtranslation Object Delete
   * @request DELETE:/v2/BuildingTranslation/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelBuildingTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace UserSessionLog {
  /**
   * @description Usersessionlog Objects List
   * @tags UserSessionLog
   * @name GetUserSessionLogList
   * @summary Usersessionlog Objects List
   * @request POST:/v2/UserSessionLog
   * @secure
   * @response `200` `UserSessionLogList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUserSessionLogList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = UserSessionLogList
  }
  /**
   * @description Usersessionlog Names List
   * @tags UserSessionLog
   * @name GetUserSessionLogNamesList
   * @summary Usersessionlog Names List
   * @request GET:/v2/UserSessionLog
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUserSessionLogNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Usersessionlog Object Create
   * @tags UserSessionLog
   * @name NewUserSessionLog
   * @summary Usersessionlog Object Create
   * @request PUT:/v2/UserSessionLog
   * @secure
   * @response `200` `UserSessionLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewUserSessionLog {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = UserSessionLogIn
    export type RequestHeaders = {}
    export type ResponseBody = UserSessionLog
  }
  /**
   * @description Usersessionlog Object Get
   * @tags UserSessionLog
   * @name GetUserSessionLog
   * @summary Usersessionlog Object Get
   * @request GET:/v2/UserSessionLog/{item_id}
   * @secure
   * @response `200` `UserSessionLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUserSessionLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = UserSessionLog
  }
  /**
   * @description Usersessionlog Object Update
   * @tags UserSessionLog
   * @name UpdUserSessionLog
   * @summary Usersessionlog Object Update
   * @request PATCH:/v2/UserSessionLog/{item_id}
   * @secure
   * @response `200` `UserSessionLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdUserSessionLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = UserSessionLogIn
    export type RequestHeaders = {}
    export type ResponseBody = UserSessionLog
  }
  /**
   * @description Usersessionlog Object Delete
   * @tags UserSessionLog
   * @name DelUserSessionLog
   * @summary Usersessionlog Object Delete
   * @request DELETE:/v2/UserSessionLog/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelUserSessionLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace UserActionsLog {
  /**
   * @description Useractionslog Objects List
   * @tags UserActionsLog
   * @name GetUserActionsLogList
   * @summary Useractionslog Objects List
   * @request POST:/v2/UserActionsLog
   * @secure
   * @response `200` `UserActionsLogList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUserActionsLogList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = UserActionsLogList
  }
  /**
   * @description Useractionslog Names List
   * @tags UserActionsLog
   * @name GetUserActionsLogNamesList
   * @summary Useractionslog Names List
   * @request GET:/v2/UserActionsLog
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUserActionsLogNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Useractionslog Object Create
   * @tags UserActionsLog
   * @name NewUserActionsLog
   * @summary Useractionslog Object Create
   * @request PUT:/v2/UserActionsLog
   * @secure
   * @response `200` `UserActionsLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewUserActionsLog {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = UserActionsLogIn
    export type RequestHeaders = {}
    export type ResponseBody = UserActionsLog
  }
  /**
   * @description Useractionslog Object Get
   * @tags UserActionsLog
   * @name GetUserActionsLog
   * @summary Useractionslog Object Get
   * @request GET:/v2/UserActionsLog/{item_id}
   * @secure
   * @response `200` `UserActionsLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUserActionsLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = UserActionsLog
  }
  /**
   * @description Useractionslog Object Update
   * @tags UserActionsLog
   * @name UpdUserActionsLog
   * @summary Useractionslog Object Update
   * @request PATCH:/v2/UserActionsLog/{item_id}
   * @secure
   * @response `200` `UserActionsLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdUserActionsLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = UserActionsLogIn
    export type RequestHeaders = {}
    export type ResponseBody = UserActionsLog
  }
  /**
   * @description Useractionslog Object Delete
   * @tags UserActionsLog
   * @name DelUserActionsLog
   * @summary Useractionslog Object Delete
   * @request DELETE:/v2/UserActionsLog/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelUserActionsLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace ResidentialTranslation {
  /**
   * @description Residentialtranslation Objects List
   * @tags ResidentialTranslation
   * @name GetResidentialTranslationList
   * @summary Residentialtranslation Objects List
   * @request POST:/v2/ResidentialTranslation
   * @secure
   * @response `200` `ResidentialTranslationList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialTranslationList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialTranslationList
  }
  /**
   * @description Residentialtranslation Names List
   * @tags ResidentialTranslation
   * @name GetResidentialTranslationNamesList
   * @summary Residentialtranslation Names List
   * @request GET:/v2/ResidentialTranslation
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialTranslationNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Residentialtranslation Object Create
   * @tags ResidentialTranslation
   * @name NewResidentialTranslation
   * @summary Residentialtranslation Object Create
   * @request PUT:/v2/ResidentialTranslation
   * @secure
   * @response `200` `ResidentialTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewResidentialTranslation {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = ResidentialTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialTranslation
  }
  /**
   * @description Residentialtranslation Object Get
   * @tags ResidentialTranslation
   * @name GetResidentialTranslation
   * @summary Residentialtranslation Object Get
   * @request GET:/v2/ResidentialTranslation/{item_id}
   * @secure
   * @response `200` `ResidentialTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialTranslation
  }
  /**
   * @description Residentialtranslation Object Update
   * @tags ResidentialTranslation
   * @name UpdResidentialTranslation
   * @summary Residentialtranslation Object Update
   * @request PATCH:/v2/ResidentialTranslation/{item_id}
   * @secure
   * @response `200` `ResidentialTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdResidentialTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = ResidentialTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialTranslation
  }
  /**
   * @description Residentialtranslation Object Delete
   * @tags ResidentialTranslation
   * @name DelResidentialTranslation
   * @summary Residentialtranslation Object Delete
   * @request DELETE:/v2/ResidentialTranslation/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelResidentialTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Residential {
  /**
   * @description Residential Objects List
   * @tags Residential
   * @name GetResidentialList
   * @summary Residential Objects List
   * @request POST:/v2/Residential
   * @secure
   * @response `200` `ResidentialList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialList
  }
  /**
   * @description Residential Names List
   * @tags Residential
   * @name GetResidentialNamesList
   * @summary Residential Names List
   * @request GET:/v2/Residential
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Residential Object Create
   * @tags Residential
   * @name NewResidential
   * @summary Residential Object Create
   * @request PUT:/v2/Residential
   * @secure
   * @response `200` `Residential` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewResidential {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = ResidentialIn
    export type RequestHeaders = {}
    export type ResponseBody = Residential
  }
  /**
   * @description Residential Object Get
   * @tags Residential
   * @name GetResidential
   * @summary Residential Object Get
   * @request GET:/v2/Residential/{item_id}
   * @secure
   * @response `200` `Residential` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidential {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Residential
  }
  /**
   * @description Residential Object Update
   * @tags Residential
   * @name UpdResidential
   * @summary Residential Object Update
   * @request PATCH:/v2/Residential/{item_id}
   * @secure
   * @response `200` `Residential` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdResidential {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = ResidentialIn
    export type RequestHeaders = {}
    export type ResponseBody = Residential
  }
  /**
   * @description Residential Object Delete
   * @tags Residential
   * @name DelResidential
   * @summary Residential Object Delete
   * @request DELETE:/v2/Residential/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelResidential {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get Residential By Id
   * @tags Residential
   * @name GetResidentialByIdV2ResidentialGetByIdPublicUidGet
   * @summary Get Residential By Id
   * @request GET:/v2/Residential/get_by_id_public/{uid}
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialByIdV2ResidentialGetByIdPublicUidGet {
    export type RequestParams = {
      /** Uid */
      uid: any
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Get Residential By Hash
   * @tags Residential
   * @name GetResidentialByHashV2ResidentialGetByHashPublicPost
   * @summary Get Residential By Hash
   * @request POST:/v2/Residential/get_by_hash_public
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialByHashV2ResidentialGetByHashPublicPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = GetResBody
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Get Residential By Ids
   * @tags Residential
   * @name GetResidentialByIdsV2ResidentialGetByIdsPublicPost
   * @summary Get Residential By Ids
   * @request POST:/v2/Residential/get_by_ids_public
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialByIdsV2ResidentialGetByIdsPublicPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = GetResidentialByIdsV2ResidentialGetByIdsPublicPostPayload
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Update Residentials Order
   * @tags Residential
   * @name UpdateResidentialsOrderV2ResidentialUpdateOrderPut
   * @summary Update Residentials Order
   * @request PUT:/v2/Residential/update_order
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdateResidentialsOrderV2ResidentialUpdateOrderPut {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = UpdateResidentialsOrderDto
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Template {
  /**
   * @description Template Objects List
   * @tags Template
   * @name GetTemplateList
   * @summary Template Objects List
   * @request POST:/v2/Template
   * @secure
   * @response `200` `TemplateList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetTemplateList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = TemplateList
  }
  /**
   * @description Template Names List
   * @tags Template
   * @name GetTemplateNamesList
   * @summary Template Names List
   * @request GET:/v2/Template
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetTemplateNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Template Object Create
   * @tags Template
   * @name NewTemplate
   * @summary Template Object Create
   * @request PUT:/v2/Template
   * @secure
   * @response `200` `Template` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewTemplate {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = TemplateIn
    export type RequestHeaders = {}
    export type ResponseBody = Template
  }
  /**
   * @description Template Object Get
   * @tags Template
   * @name GetTemplate
   * @summary Template Object Get
   * @request GET:/v2/Template/{item_id}
   * @secure
   * @response `200` `Template` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetTemplate {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Template
  }
  /**
   * @description Template Object Update
   * @tags Template
   * @name UpdTemplate
   * @summary Template Object Update
   * @request PATCH:/v2/Template/{item_id}
   * @secure
   * @response `200` `Template` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdTemplate {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = TemplateIn
    export type RequestHeaders = {}
    export type ResponseBody = Template
  }
  /**
   * @description Template Object Delete
   * @tags Template
   * @name DelTemplate
   * @summary Template Object Delete
   * @request DELETE:/v2/Template/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelTemplate {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace UnitAmenityTranslation {
  /**
   * @description Unitamenitytranslation Objects List
   * @tags UnitAmenityTranslation
   * @name GetUnitAmenityTranslationList
   * @summary Unitamenitytranslation Objects List
   * @request POST:/v2/UnitAmenityTranslation
   * @secure
   * @response `200` `UnitAmenityTranslationList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitAmenityTranslationList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = UnitAmenityTranslationList
  }
  /**
   * @description Unitamenitytranslation Names List
   * @tags UnitAmenityTranslation
   * @name GetUnitAmenityTranslationNamesList
   * @summary Unitamenitytranslation Names List
   * @request GET:/v2/UnitAmenityTranslation
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitAmenityTranslationNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Unitamenitytranslation Object Create
   * @tags UnitAmenityTranslation
   * @name NewUnitAmenityTranslation
   * @summary Unitamenitytranslation Object Create
   * @request PUT:/v2/UnitAmenityTranslation
   * @secure
   * @response `200` `UnitAmenityTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewUnitAmenityTranslation {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = UnitAmenityTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = UnitAmenityTranslation
  }
  /**
   * @description Unitamenitytranslation Object Get
   * @tags UnitAmenityTranslation
   * @name GetUnitAmenityTranslation
   * @summary Unitamenitytranslation Object Get
   * @request GET:/v2/UnitAmenityTranslation/{item_id}
   * @secure
   * @response `200` `UnitAmenityTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitAmenityTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = UnitAmenityTranslation
  }
  /**
   * @description Unitamenitytranslation Object Update
   * @tags UnitAmenityTranslation
   * @name UpdUnitAmenityTranslation
   * @summary Unitamenitytranslation Object Update
   * @request PATCH:/v2/UnitAmenityTranslation/{item_id}
   * @secure
   * @response `200` `UnitAmenityTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdUnitAmenityTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = UnitAmenityTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = UnitAmenityTranslation
  }
  /**
   * @description Unitamenitytranslation Object Delete
   * @tags UnitAmenityTranslation
   * @name DelUnitAmenityTranslation
   * @summary Unitamenitytranslation Object Delete
   * @request DELETE:/v2/UnitAmenityTranslation/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelUnitAmenityTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace ResAmenityTranslation {
  /**
   * @description Resamenitytranslation Objects List
   * @tags ResAmenityTranslation
   * @name GetResAmenityTranslationList
   * @summary Resamenitytranslation Objects List
   * @request POST:/v2/ResAmenityTranslation
   * @secure
   * @response `200` `ResAmenityTranslationList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResAmenityTranslationList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = ResAmenityTranslationList
  }
  /**
   * @description Resamenitytranslation Names List
   * @tags ResAmenityTranslation
   * @name GetResAmenityTranslationNamesList
   * @summary Resamenitytranslation Names List
   * @request GET:/v2/ResAmenityTranslation
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResAmenityTranslationNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Resamenitytranslation Object Create
   * @tags ResAmenityTranslation
   * @name NewResAmenityTranslation
   * @summary Resamenitytranslation Object Create
   * @request PUT:/v2/ResAmenityTranslation
   * @secure
   * @response `200` `ResAmenityTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewResAmenityTranslation {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = ResAmenityTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = ResAmenityTranslation
  }
  /**
   * @description Resamenitytranslation Object Get
   * @tags ResAmenityTranslation
   * @name GetResAmenityTranslation
   * @summary Resamenitytranslation Object Get
   * @request GET:/v2/ResAmenityTranslation/{item_id}
   * @secure
   * @response `200` `ResAmenityTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResAmenityTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ResAmenityTranslation
  }
  /**
   * @description Resamenitytranslation Object Update
   * @tags ResAmenityTranslation
   * @name UpdResAmenityTranslation
   * @summary Resamenitytranslation Object Update
   * @request PATCH:/v2/ResAmenityTranslation/{item_id}
   * @secure
   * @response `200` `ResAmenityTranslation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdResAmenityTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = ResAmenityTranslationIn
    export type RequestHeaders = {}
    export type ResponseBody = ResAmenityTranslation
  }
  /**
   * @description Resamenitytranslation Object Delete
   * @tags ResAmenityTranslation
   * @name DelResAmenityTranslation
   * @summary Resamenitytranslation Object Delete
   * @request DELETE:/v2/ResAmenityTranslation/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelResAmenityTranslation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace ResidentialPresentation {
  /**
   * @description Residentialpresentation Objects List
   * @tags ResidentialPresentation
   * @name GetResidentialPresentationList
   * @summary Residentialpresentation Objects List
   * @request POST:/v2/ResidentialPresentation
   * @secure
   * @response `200` `ResidentialPresentationList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialPresentationList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialPresentationList
  }
  /**
   * @description Residentialpresentation Names List
   * @tags ResidentialPresentation
   * @name GetResidentialPresentationNamesList
   * @summary Residentialpresentation Names List
   * @request GET:/v2/ResidentialPresentation
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialPresentationNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Residentialpresentation Object Create
   * @tags ResidentialPresentation
   * @name NewResidentialPresentation
   * @summary Residentialpresentation Object Create
   * @request PUT:/v2/ResidentialPresentation
   * @secure
   * @response `200` `ResidentialPresentation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewResidentialPresentation {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = ResidentialPresentationIn
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialPresentation
  }
  /**
   * @description Residentialpresentation Object Get
   * @tags ResidentialPresentation
   * @name GetResidentialPresentation
   * @summary Residentialpresentation Object Get
   * @request GET:/v2/ResidentialPresentation/{item_id}
   * @secure
   * @response `200` `ResidentialPresentation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialPresentation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialPresentation
  }
  /**
   * @description Residentialpresentation Object Update
   * @tags ResidentialPresentation
   * @name UpdResidentialPresentation
   * @summary Residentialpresentation Object Update
   * @request PATCH:/v2/ResidentialPresentation/{item_id}
   * @secure
   * @response `200` `ResidentialPresentation` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdResidentialPresentation {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = ResidentialPresentationIn
    export type RequestHeaders = {}
    export type ResponseBody = ResidentialPresentation
  }
  /**
   * @description Residentialpresentation Object Delete
   * @tags ResidentialPresentation
   * @name DelResidentialPresentation
   * @summary Residentialpresentation Object Delete
   * @request DELETE:/v2/ResidentialPresentation/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelResidentialPresentation {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Subscribers {
  /**
   * @description Subscribers Objects List
   * @tags Subscribers
   * @name GetSubscribersList
   * @summary Subscribers Objects List
   * @request POST:/v2/Subscribers
   * @secure
   * @response `200` `SubscribersList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetSubscribersList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = SubscribersList
  }
  /**
   * @description Subscribers Names List
   * @tags Subscribers
   * @name GetSubscribersNamesList
   * @summary Subscribers Names List
   * @request GET:/v2/Subscribers
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetSubscribersNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Subscribers Object Create
   * @tags Subscribers
   * @name NewSubscribers
   * @summary Subscribers Object Create
   * @request PUT:/v2/Subscribers
   * @secure
   * @response `200` `Subscribers` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewSubscribers {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = SubscribersIn
    export type RequestHeaders = {}
    export type ResponseBody = Subscribers
  }
  /**
   * @description Subscribers Object Get
   * @tags Subscribers
   * @name GetSubscribers
   * @summary Subscribers Object Get
   * @request GET:/v2/Subscribers/{item_id}
   * @secure
   * @response `200` `Subscribers` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetSubscribers {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Subscribers
  }
  /**
   * @description Subscribers Object Update
   * @tags Subscribers
   * @name UpdSubscribers
   * @summary Subscribers Object Update
   * @request PATCH:/v2/Subscribers/{item_id}
   * @secure
   * @response `200` `Subscribers` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdSubscribers {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = SubscribersIn
    export type RequestHeaders = {}
    export type ResponseBody = Subscribers
  }
  /**
   * @description Subscribers Object Delete
   * @tags Subscribers
   * @name DelSubscribers
   * @summary Subscribers Object Delete
   * @request DELETE:/v2/Subscribers/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelSubscribers {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Contact {
  /**
   * @description Contact Objects List
   * @tags Contact
   * @name GetContactList
   * @summary Contact Objects List
   * @request POST:/v2/Contact
   * @secure
   * @response `200` `ContactList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetContactList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = ContactList
  }
  /**
   * @description Contact Names List
   * @tags Contact
   * @name GetContactNamesList
   * @summary Contact Names List
   * @request GET:/v2/Contact
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetContactNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Contact Object Create
   * @tags Contact
   * @name NewContact
   * @summary Contact Object Create
   * @request PUT:/v2/Contact
   * @secure
   * @response `200` `Contact` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewContact {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = ContactIn
    export type RequestHeaders = {}
    export type ResponseBody = Contact
  }
  /**
   * @description Contact Object Get
   * @tags Contact
   * @name GetContact
   * @summary Contact Object Get
   * @request GET:/v2/Contact/{item_id}
   * @secure
   * @response `200` `Contact` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetContact {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Contact
  }
  /**
   * @description Contact Object Update
   * @tags Contact
   * @name UpdContact
   * @summary Contact Object Update
   * @request PATCH:/v2/Contact/{item_id}
   * @secure
   * @response `200` `Contact` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdContact {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = ContactIn
    export type RequestHeaders = {}
    export type ResponseBody = Contact
  }
  /**
   * @description Contact Object Delete
   * @tags Contact
   * @name DelContact
   * @summary Contact Object Delete
   * @request DELETE:/v2/Contact/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelContact {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Edit Contact
   * @tags Contact
   * @name EditContactV2ContactEditIdPatch
   * @summary Edit Contact
   * @request PATCH:/v2/Contact/edit/{id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace EditContactV2ContactEditIdPatch {
    export type RequestParams = {
      /** Id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = EditContactV2ContactEditIdPatchPayload
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace LandingForms {
  /**
   * @description Landingforms Objects List
   * @tags LandingForms
   * @name GetLandingFormsList
   * @summary Landingforms Objects List
   * @request POST:/v2/LandingForms
   * @secure
   * @response `200` `LandingFormsList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetLandingFormsList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = LandingFormsList
  }
  /**
   * @description Landingforms Names List
   * @tags LandingForms
   * @name GetLandingFormsNamesList
   * @summary Landingforms Names List
   * @request GET:/v2/LandingForms
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetLandingFormsNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Landingforms Object Create
   * @tags LandingForms
   * @name NewLandingForms
   * @summary Landingforms Object Create
   * @request PUT:/v2/LandingForms
   * @secure
   * @response `200` `LandingForms` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewLandingForms {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = LandingFormsIn
    export type RequestHeaders = {}
    export type ResponseBody = LandingForms
  }
  /**
   * @description Landingforms Object Get
   * @tags LandingForms
   * @name GetLandingForms
   * @summary Landingforms Object Get
   * @request GET:/v2/LandingForms/{item_id}
   * @secure
   * @response `200` `LandingForms` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetLandingForms {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = LandingForms
  }
  /**
   * @description Landingforms Object Update
   * @tags LandingForms
   * @name UpdLandingForms
   * @summary Landingforms Object Update
   * @request PATCH:/v2/LandingForms/{item_id}
   * @secure
   * @response `200` `LandingForms` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdLandingForms {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = LandingFormsIn
    export type RequestHeaders = {}
    export type ResponseBody = LandingForms
  }
  /**
   * @description Landingforms Object Delete
   * @tags LandingForms
   * @name DelLandingForms
   * @summary Landingforms Object Delete
   * @request DELETE:/v2/LandingForms/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelLandingForms {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace User {
  /**
   * @description User Objects List
   * @tags User
   * @name GetUserList
   * @summary User Objects List
   * @request POST:/v2/User
   * @secure
   * @response `200` `UserList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUserList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = UserList
  }
  /**
   * @description User Names List
   * @tags User
   * @name GetUserNamesList
   * @summary User Names List
   * @request GET:/v2/User
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUserNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description User Object Create
   * @tags User
   * @name NewUser
   * @summary User Object Create
   * @request PUT:/v2/User
   * @secure
   * @response `200` `User` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewUser {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = UserIn
    export type RequestHeaders = {}
    export type ResponseBody = User
  }
  /**
   * @description User Object Get
   * @tags User
   * @name GetUser
   * @summary User Object Get
   * @request GET:/v2/User/{item_id}
   * @secure
   * @response `200` `User` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUser {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = User
  }
  /**
   * @description User Object Update
   * @tags User
   * @name UpdUser
   * @summary User Object Update
   * @request PATCH:/v2/User/{item_id}
   * @secure
   * @response `200` `User` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdUser {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = UserIn
    export type RequestHeaders = {}
    export type ResponseBody = User
  }
  /**
   * @description User Object Delete
   * @tags User
   * @name DelUser
   * @summary User Object Delete
   * @request DELETE:/v2/User/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelUser {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Update User
   * @tags User
   * @name UpdateUserEditUserUidPatch
   * @summary Update User
   * @request PATCH:/edit-user/{uid}
   * @secure
   * @response `200` `TortoiseContribPydanticCreatorAuthUserLeaf` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdateUserEditUserUidPatch {
    export type RequestParams = {
      /** Uid */
      uid: number
    }
    export type RequestQuery = {}
    export type RequestBody = UpdateUserBody
    export type RequestHeaders = {}
    export type ResponseBody = TortoiseContribPydanticCreatorAuthUserLeaf
  }
  /**
   * @description Update Active User
   * @tags User
   * @name UpdateActiveUserEditActiveUserUidPatch
   * @summary Update Active User
   * @request PATCH:/edit-active-user/{uid}
   * @secure
   * @response `200` `Token` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdateActiveUserEditActiveUserUidPatch {
    export type RequestParams = {
      /** Uid */
      uid: number
    }
    export type RequestQuery = {}
    export type RequestBody = UpdateUserBody
    export type RequestHeaders = {}
    export type ResponseBody = Token
  }
  /**
   * @description Update User Photos
   * @tags User
   * @name UpdateUserPhotosUserPhotoUploadTypeUidPost
   * @summary Update User Photos
   * @request POST:/User/photo_upload/{type}/{uid}
   * @response `200` `TortoiseContribPydanticCreatorAuthUserLeaf` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdateUserPhotosUserPhotoUploadTypeUidPost {
    export type RequestParams = {
      /** Uid */
      uid: number
      type: UserPhotoType
    }
    export type RequestQuery = {}
    export type RequestBody = BodyUpdateUserPhotosUserPhotoUploadTypeUidPost
    export type RequestHeaders = {}
    export type ResponseBody = TortoiseContribPydanticCreatorAuthUserLeaf
  }
  /**
   * @description Get User Statuses
   * @tags User
   * @name GetUserStatusesUserGetStatusesGet
   * @summary Get User Statuses
   * @request GET:/User/getStatuses
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUserStatusesUserGetStatusesGet {
    export type RequestParams = {}
    export type RequestQuery = {
      /** User Id */
      user_id: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Get User By Slug
   * @tags User
   * @name GetUserBySlugUserGetUserSlugGet
   * @summary Get User By Slug
   * @request GET:/User/get_user/{slug}
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUserBySlugUserGetUserSlugGet {
    export type RequestParams = {
      /** Slug */
      slug: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Delete User
   * @tags User
   * @name DeleteUserUserDeleteUidDelete
   * @summary Delete User
   * @request DELETE:/User/delete/{uid}
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DeleteUserUserDeleteUidDelete {
    export type RequestParams = {
      /** Uid */
      uid: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Is Slug Taken
   * @tags User
   * @name IsSlugTakenUserCheckSlugSlugGet
   * @summary Is Slug Taken
   * @request GET:/User/check-slug/{slug}
   * @secure
   * @response `200` `boolean` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace IsSlugTakenUserCheckSlugSlugGet {
    export type RequestParams = {
      /** Slug */
      slug: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = boolean
  }
  /**
   * @description Create Default User Data
   * @tags User
   * @name CreateDefaultUserDataUserCreateDefaultUserDataUidPost
   * @summary Create Default User Data
   * @request POST:/User/create_default_user_data/{uid}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace CreateDefaultUserDataUserCreateDefaultUserDataUidPost {
    export type RequestParams = {
      /** Uid */
      uid: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Mark Webinar As Watched
   * @tags User
   * @name MarkWebinarAsWatchedUserWatchWebinarPost
   * @summary Mark Webinar As Watched
   * @request POST:/User/watch-webinar
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace MarkWebinarAsWatchedUserWatchWebinarPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = WatchWebinarDto
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Unmark Webinar As Watched
   * @tags User
   * @name UnmarkWebinarAsWatchedUserUnwatchWebinarPost
   * @summary Unmark Webinar As Watched
   * @request POST:/User/unwatch-webinar
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UnmarkWebinarAsWatchedUserUnwatchWebinarPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = WatchWebinarDto
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Set Personal Manager
   * @tags User
   * @name SetPersonalManagerUserSetManagerPost
   * @summary Set Personal Manager
   * @request POST:/User/set-manager
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SetPersonalManagerUserSetManagerPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = SetPersonalManagerDto
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Change Default Personal Manager
   * @tags User
   * @name ChangeDefaultPersonalManagerUserChangeDefaultManagerPost
   * @summary Change Default Personal Manager
   * @request POST:/User/change-default-manager
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace ChangeDefaultPersonalManagerUserChangeDefaultManagerPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ChangePersonalManagerDto
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Get Default Manager
   * @tags User
   * @name GetDefaultManagerUserGetDefaultManagerGet
   * @summary Get Default Manager
   * @request GET:/User/get-default-manager
   * @secure
   * @response `200` `any` Successful Response
   */
  export namespace GetDefaultManagerUserGetDefaultManagerGet {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace WebinarTranslations {
  /**
   * @description Webinartranslations Objects List
   * @tags WebinarTranslations
   * @name GetWebinarTranslationsList
   * @summary Webinartranslations Objects List
   * @request POST:/v2/WebinarTranslations
   * @secure
   * @response `200` `WebinarTranslationsList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetWebinarTranslationsList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = WebinarTranslationsList
  }
  /**
   * @description Webinartranslations Names List
   * @tags WebinarTranslations
   * @name GetWebinarTranslationsNamesList
   * @summary Webinartranslations Names List
   * @request GET:/v2/WebinarTranslations
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetWebinarTranslationsNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Webinartranslations Object Create
   * @tags WebinarTranslations
   * @name NewWebinarTranslations
   * @summary Webinartranslations Object Create
   * @request PUT:/v2/WebinarTranslations
   * @secure
   * @response `200` `WebinarTranslations` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewWebinarTranslations {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = WebinarTranslationsIn
    export type RequestHeaders = {}
    export type ResponseBody = WebinarTranslations
  }
  /**
   * @description Webinartranslations Object Get
   * @tags WebinarTranslations
   * @name GetWebinarTranslations
   * @summary Webinartranslations Object Get
   * @request GET:/v2/WebinarTranslations/{item_id}
   * @secure
   * @response `200` `WebinarTranslations` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetWebinarTranslations {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = WebinarTranslations
  }
  /**
   * @description Webinartranslations Object Update
   * @tags WebinarTranslations
   * @name UpdWebinarTranslations
   * @summary Webinartranslations Object Update
   * @request PATCH:/v2/WebinarTranslations/{item_id}
   * @secure
   * @response `200` `WebinarTranslations` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdWebinarTranslations {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = WebinarTranslationsIn
    export type RequestHeaders = {}
    export type ResponseBody = WebinarTranslations
  }
  /**
   * @description Webinartranslations Object Delete
   * @tags WebinarTranslations
   * @name DelWebinarTranslations
   * @summary Webinartranslations Object Delete
   * @request DELETE:/v2/WebinarTranslations/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelWebinarTranslations {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Promotion {
  /**
   * @description Promotion Objects List
   * @tags Promotion
   * @name GetPromotionList
   * @summary Promotion Objects List
   * @request POST:/v2/Promotion
   * @secure
   * @response `200` `PromotionList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetPromotionList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = PromotionList
  }
  /**
   * @description Promotion Names List
   * @tags Promotion
   * @name GetPromotionNamesList
   * @summary Promotion Names List
   * @request GET:/v2/Promotion
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetPromotionNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Promotion Object Create
   * @tags Promotion
   * @name NewPromotion
   * @summary Promotion Object Create
   * @request PUT:/v2/Promotion
   * @secure
   * @response `200` `Promotion` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewPromotion {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = PromotionIn
    export type RequestHeaders = {}
    export type ResponseBody = Promotion
  }
  /**
   * @description Promotion Object Get
   * @tags Promotion
   * @name GetPromotion
   * @summary Promotion Object Get
   * @request GET:/v2/Promotion/{item_id}
   * @secure
   * @response `200` `Promotion` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetPromotion {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Promotion
  }
  /**
   * @description Promotion Object Update
   * @tags Promotion
   * @name UpdPromotion
   * @summary Promotion Object Update
   * @request PATCH:/v2/Promotion/{item_id}
   * @secure
   * @response `200` `Promotion` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdPromotion {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = PromotionIn
    export type RequestHeaders = {}
    export type ResponseBody = Promotion
  }
  /**
   * @description Promotion Object Delete
   * @tags Promotion
   * @name DelPromotion
   * @summary Promotion Object Delete
   * @request DELETE:/v2/Promotion/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelPromotion {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get Active Promotions
   * @tags Promotion
   * @name GetActivePromotionsV2PromotionGetActivePost
   * @summary Get Active Promotions
   * @request POST:/v2/Promotion/get-active
   * @secure
   * @response `200` `any` Successful Response
   */
  export namespace GetActivePromotionsV2PromotionGetActivePost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Delete Promotion
   * @tags Promotion
   * @name DeletePromotionV2PromotionIdWithDependenciesDelete
   * @summary Delete Promotion
   * @request DELETE:/v2/Promotion/{id}/with-dependencies
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DeletePromotionV2PromotionIdWithDependenciesDelete {
    export type RequestParams = {
      /** Id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace Building {
  /**
   * @description Building Objects List
   * @tags Building
   * @name GetBuildingList
   * @summary Building Objects List
   * @request POST:/v2/Building
   * @secure
   * @response `200` `BuildingList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetBuildingList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = BuildingList
  }
  /**
   * @description Building Names List
   * @tags Building
   * @name GetBuildingNamesList
   * @summary Building Names List
   * @request GET:/v2/Building
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetBuildingNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Building Object Create
   * @tags Building
   * @name NewBuilding
   * @summary Building Object Create
   * @request PUT:/v2/Building
   * @secure
   * @response `200` `Building` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewBuilding {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = BuildingIn
    export type RequestHeaders = {}
    export type ResponseBody = Building
  }
  /**
   * @description Building Object Get
   * @tags Building
   * @name GetBuilding
   * @summary Building Object Get
   * @request GET:/v2/Building/{item_id}
   * @secure
   * @response `200` `Building` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetBuilding {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Building
  }
  /**
   * @description Building Object Update
   * @tags Building
   * @name UpdBuilding
   * @summary Building Object Update
   * @request PATCH:/v2/Building/{item_id}
   * @secure
   * @response `200` `Building` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdBuilding {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = BuildingIn
    export type RequestHeaders = {}
    export type ResponseBody = Building
  }
  /**
   * @description Building Object Delete
   * @tags Building
   * @name DelBuilding
   * @summary Building Object Delete
   * @request DELETE:/v2/Building/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelBuilding {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace EmailsLog {
  /**
   * @description Emailslog Objects List
   * @tags EmailsLog
   * @name GetEmailsLogList
   * @summary Emailslog Objects List
   * @request POST:/v2/EmailsLog
   * @secure
   * @response `200` `EmailsLogList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetEmailsLogList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = EmailsLogList
  }
  /**
   * @description Emailslog Names List
   * @tags EmailsLog
   * @name GetEmailsLogNamesList
   * @summary Emailslog Names List
   * @request GET:/v2/EmailsLog
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetEmailsLogNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Emailslog Object Create
   * @tags EmailsLog
   * @name NewEmailsLog
   * @summary Emailslog Object Create
   * @request PUT:/v2/EmailsLog
   * @secure
   * @response `200` `EmailsLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewEmailsLog {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = EmailsLogIn
    export type RequestHeaders = {}
    export type ResponseBody = EmailsLog
  }
  /**
   * @description Emailslog Object Get
   * @tags EmailsLog
   * @name GetEmailsLog
   * @summary Emailslog Object Get
   * @request GET:/v2/EmailsLog/{item_id}
   * @secure
   * @response `200` `EmailsLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetEmailsLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = EmailsLog
  }
  /**
   * @description Emailslog Object Update
   * @tags EmailsLog
   * @name UpdEmailsLog
   * @summary Emailslog Object Update
   * @request PATCH:/v2/EmailsLog/{item_id}
   * @secure
   * @response `200` `EmailsLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdEmailsLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = EmailsLogIn
    export type RequestHeaders = {}
    export type ResponseBody = EmailsLog
  }
  /**
   * @description Emailslog Object Delete
   * @tags EmailsLog
   * @name DelEmailsLog
   * @summary Emailslog Object Delete
   * @request DELETE:/v2/EmailsLog/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelEmailsLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Order {
  /**
   * @description Order Objects List
   * @tags Order
   * @name GetOrderList
   * @summary Order Objects List
   * @request POST:/v2/Order
   * @secure
   * @response `200` `OrderList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetOrderList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = OrderList
  }
  /**
   * @description Order Names List
   * @tags Order
   * @name GetOrderNamesList
   * @summary Order Names List
   * @request GET:/v2/Order
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetOrderNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Order Object Create
   * @tags Order
   * @name NewOrder
   * @summary Order Object Create
   * @request PUT:/v2/Order
   * @secure
   * @response `200` `Order` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewOrder {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = OrderIn
    export type RequestHeaders = {}
    export type ResponseBody = Order
  }
  /**
   * @description Order Object Get
   * @tags Order
   * @name GetOrder
   * @summary Order Object Get
   * @request GET:/v2/Order/{item_id}
   * @secure
   * @response `200` `Order` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetOrder {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Order
  }
  /**
   * @description Order Object Update
   * @tags Order
   * @name UpdOrder
   * @summary Order Object Update
   * @request PATCH:/v2/Order/{item_id}
   * @secure
   * @response `200` `Order` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdOrder {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = OrderIn
    export type RequestHeaders = {}
    export type ResponseBody = Order
  }
  /**
   * @description Order Object Delete
   * @tags Order
   * @name DelOrder
   * @summary Order Object Delete
   * @request DELETE:/v2/Order/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelOrder {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get Clients
   * @tags Order
   * @name GetClientsV2ClientsPost
   * @summary Get Clients
   * @request POST:/v2/Clients
   * @secure
   * @response `200` `ContactList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetClientsV2ClientsPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = GetClientsV2ClientsPostPayload
    export type RequestHeaders = {}
    export type ResponseBody = ContactList
  }
}

export namespace NotificationLog {
  /**
   * @description Notificationlog Objects List
   * @tags NotificationLog
   * @name GetNotificationLogList
   * @summary Notificationlog Objects List
   * @request POST:/v2/NotificationLog
   * @secure
   * @response `200` `NotificationLogList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetNotificationLogList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = NotificationLogList
  }
  /**
   * @description Notificationlog Names List
   * @tags NotificationLog
   * @name GetNotificationLogNamesList
   * @summary Notificationlog Names List
   * @request GET:/v2/NotificationLog
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetNotificationLogNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Notificationlog Object Create
   * @tags NotificationLog
   * @name NewNotificationLog
   * @summary Notificationlog Object Create
   * @request PUT:/v2/NotificationLog
   * @secure
   * @response `200` `NotificationLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewNotificationLog {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = NotificationLogIn
    export type RequestHeaders = {}
    export type ResponseBody = NotificationLog
  }
  /**
   * @description Notificationlog Object Get
   * @tags NotificationLog
   * @name GetNotificationLog
   * @summary Notificationlog Object Get
   * @request GET:/v2/NotificationLog/{item_id}
   * @secure
   * @response `200` `NotificationLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetNotificationLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = NotificationLog
  }
  /**
   * @description Notificationlog Object Update
   * @tags NotificationLog
   * @name UpdNotificationLog
   * @summary Notificationlog Object Update
   * @request PATCH:/v2/NotificationLog/{item_id}
   * @secure
   * @response `200` `NotificationLog` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdNotificationLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = NotificationLogIn
    export type RequestHeaders = {}
    export type ResponseBody = NotificationLog
  }
  /**
   * @description Notificationlog Object Delete
   * @tags NotificationLog
   * @name DelNotificationLog
   * @summary Notificationlog Object Delete
   * @request DELETE:/v2/NotificationLog/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelNotificationLog {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Read Notifications
   * @tags NotificationLog
   * @name ReadNotificationsV2NotificationLogReadNotificationsPost
   * @summary Read Notifications
   * @request POST:/v2/NotificationLog/read_notifications
   * @secure
   * @response `200` `Record<string,(number | string)>` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace ReadNotificationsV2NotificationLogReadNotificationsPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ReadNotificationsDto
    export type RequestHeaders = {}
    export type ResponseBody = Record<string, number | string>
  }
  /**
   * @description Create Public Notifications
   * @tags NotificationLog
   * @name CreatePublicNotificationsV2NotificationLogPublicPut
   * @summary Create Public Notifications
   * @request PUT:/v2/NotificationLog/public
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace CreatePublicNotificationsV2NotificationLogPublicPut {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = CreatePublicNotificationsV2NotificationLogPublicPutPayload
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Create Ld Notification
   * @tags NotificationLog
   * @name CreateLdNotificationV2NotificationLogPublicLdPut
   * @summary Create Ld Notification
   * @request PUT:/v2/NotificationLog/public/ld
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace CreateLdNotificationV2NotificationLogPublicLdPut {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = CreateLdNotificationV2NotificationLogPublicLdPutPayload
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Edit Notification
   * @tags NotificationLog
   * @name EditNotificationV2NotificationLogEditIdPatch
   * @summary Edit Notification
   * @request PATCH:/v2/NotificationLog/edit/{id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace EditNotificationV2NotificationLogEditIdPatch {
    export type RequestParams = {
      /** Id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = EditNotificationV2NotificationLogEditIdPatchPayload
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace LandingData {
  /**
   * @description Landingdata Objects List
   * @tags LandingData
   * @name GetLandingDataList
   * @summary Landingdata Objects List
   * @request POST:/v2/LandingData
   * @secure
   * @response `200` `LandingDataList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetLandingDataList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = LandingDataList
  }
  /**
   * @description Landingdata Names List
   * @tags LandingData
   * @name GetLandingDataNamesList
   * @summary Landingdata Names List
   * @request GET:/v2/LandingData
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetLandingDataNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Landingdata Object Create
   * @tags LandingData
   * @name NewLandingData
   * @summary Landingdata Object Create
   * @request PUT:/v2/LandingData
   * @secure
   * @response `200` `LandingData` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewLandingData {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = LandingDataIn
    export type RequestHeaders = {}
    export type ResponseBody = LandingData
  }
  /**
   * @description Landingdata Object Get
   * @tags LandingData
   * @name GetLandingData
   * @summary Landingdata Object Get
   * @request GET:/v2/LandingData/{item_id}
   * @secure
   * @response `200` `LandingData` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetLandingData {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = LandingData
  }
  /**
   * @description Landingdata Object Update
   * @tags LandingData
   * @name UpdLandingData
   * @summary Landingdata Object Update
   * @request PATCH:/v2/LandingData/{item_id}
   * @secure
   * @response `200` `LandingData` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdLandingData {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = LandingDataIn
    export type RequestHeaders = {}
    export type ResponseBody = LandingData
  }
  /**
   * @description Landingdata Object Delete
   * @tags LandingData
   * @name DelLandingData
   * @summary Landingdata Object Delete
   * @request DELETE:/v2/LandingData/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelLandingData {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get Landing Data By Slug
   * @tags LandingData
   * @name GetLandingDataBySlugV2LandingDataGetBySlugSlugGet
   * @summary Get Landing Data By Slug
   * @request GET:/v2/LandingData/get_by_slug/{slug}
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetLandingDataBySlugV2LandingDataGetBySlugSlugGet {
    export type RequestParams = {
      /** Slug */
      slug: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Set Default Landing Data
   * @tags LandingData
   * @name SetDefaultLandingDataV2LandingDataSetLandingDataUidPost
   * @summary Set Default Landing Data
   * @request POST:/v2/LandingData/set_landing_data/{uid}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SetDefaultLandingDataV2LandingDataSetLandingDataUidPost {
    export type RequestParams = {
      /** Uid */
      uid: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Edit Landing Data
   * @tags LandingData
   * @name EditLandingDataV2LandingDataEditIdPatch
   * @summary Edit Landing Data
   * @request PATCH:/v2/LandingData/edit/{id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace EditLandingDataV2LandingDataEditIdPatch {
    export type RequestParams = {
      /** Id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = EditLandingDataV2LandingDataEditIdPatchPayload
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Get Ld Views
   * @tags LandingData
   * @name GetLdViewsV2LandingDataViewsUserIdPost
   * @summary Get Ld Views
   * @request POST:/v2/LandingData/views/{user_id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetLdViewsV2LandingDataViewsUserIdPost {
    export type RequestParams = {
      /** User Id */
      userId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Publish Ld
   * @tags LandingData
   * @name PublishLdV2LandingDataPublishIdPost
   * @summary Publish Ld
   * @request POST:/v2/LandingData/publish/{id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace PublishLdV2LandingDataPublishIdPost {
    export type RequestParams = {
      /** Id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = PublishLdV2LandingDataPublishIdPostPayload
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace Offer {
  /**
   * @description Offer Objects List
   * @tags Offer
   * @name GetOfferList
   * @summary Offer Objects List
   * @request POST:/v2/Offer
   * @secure
   * @response `200` `OfferList` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetOfferList {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ListArgs
    export type RequestHeaders = {}
    export type ResponseBody = OfferList
  }
  /**
   * @description Offer Names List
   * @tags Offer
   * @name GetOfferNamesList
   * @summary Offer Names List
   * @request GET:/v2/Offer
   * @secure
   * @response `200` `Names` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetOfferNamesList {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Fname */
      fname?: string
      /** Fval */
      fval?: number | string | boolean
      /** Sname */
      sname?: string
      /** Sid */
      sid?: number
      /**
       * Page
       * @default 1
       */
      page?: number
      /**
       * Limit
       * @default 50
       */
      limit?: number
      /** Search */
      search?: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Names
  }
  /**
   * @description Offer Object Create
   * @tags Offer
   * @name NewOffer
   * @summary Offer Object Create
   * @request PUT:/v2/Offer
   * @secure
   * @response `200` `Offer` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace NewOffer {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Item Id */
      item_id?: number | null
    }
    export type RequestBody = OfferIn
    export type RequestHeaders = {}
    export type ResponseBody = Offer
  }
  /**
   * @description Offer Object Get
   * @tags Offer
   * @name GetOffer
   * @summary Offer Object Get
   * @request GET:/v2/Offer/{item_id}
   * @secure
   * @response `200` `Offer` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetOffer {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = Offer
  }
  /**
   * @description Offer Object Update
   * @tags Offer
   * @name UpdOffer
   * @summary Offer Object Update
   * @request PATCH:/v2/Offer/{item_id}
   * @secure
   * @response `200` `Offer` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdOffer {
    export type RequestParams = {
      /** Item Id */
      itemId: number | null
    }
    export type RequestQuery = {}
    export type RequestBody = OfferIn
    export type RequestHeaders = {}
    export type ResponseBody = Offer
  }
  /**
   * @description Offer Object Delete
   * @tags Offer
   * @name DelOffer
   * @summary Offer Object Delete
   * @request DELETE:/v2/Offer/{item_id}
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DelOffer {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get Offers
   * @tags Offer
   * @name GetOffersGetOffersGet
   * @summary Get Offers
   * @request GET:/get_offers
   * @response `200` `OfferList` Successful Response
   */
  export namespace GetOffersGetOffersGet {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = OfferList
  }
}

export namespace GoogleApi {
  /**
   * @description Get Addr Opts
   * @tags google-api
   * @name GetAddrOptsGapiAddrOptsGet
   * @summary Get Addr Opts
   * @request GET:/gapi/addr-opts
   * @secure
   * @response `200` `AddressSuggestions` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetAddrOptsGapiAddrOptsGet {
    export type RequestParams = {}
    export type RequestQuery = {
      /** Query */
      query: string
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = AddressSuggestions
  }
  /**
   * @description Get Addr
   * @tags google-api
   * @name GetAddrGapiAddrGidGet
   * @summary Get Addr
   * @request GET:/gapi/addr/{gid}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetAddrGapiAddrGidGet {
    export type RequestParams = {
      /** Gid */
      gid: string
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace PhotoModule {
  /**
   * @description Photos Upload
   * @tags photo-module
   * @name PhotosUploadPhotoPost
   * @summary Photos Upload
   * @request POST:/photo
   * @secure
   * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace PhotosUploadPhotoPost {
    export type RequestParams = {}
    export type RequestQuery = {
      owner: ModelsImagableType2
      /** Obj Id */
      obj_id: number
      tag: ModelsPhotoTag2
      /**
       * X
       * @default 0
       */
      x?: number
      /**
       * Y
       * @default 0
       */
      y?: number
      /**
       * Zoom
       * @default 1
       */
      zoom?: number
      /**
       * Sort
       * @default 0
       */
      sort?: number
    }
    export type RequestBody = BodyPhotosUploadPhotoPost
    export type RequestHeaders = {}
    export type ResponseBody = TortoiseContribPydanticCreatorModelsPhotoLeaf
  }
  /**
   * @description Photos Sort
   * @tags photo-module
   * @name PhotosSortPhotoSortPost
   * @summary Photos Sort
   * @request POST:/photo/sort/
   * @secure
   * @response `200` `boolean` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace PhotosSortPhotoSortPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = PhotosSortPhotoSortPostPayload
    export type RequestHeaders = {}
    export type ResponseBody = boolean
  }
  /**
   * @description Social Photos Sort
   * @tags photo-module
   * @name SocialPhotosSortPhotoSocialSortPost
   * @summary Social Photos Sort
   * @request POST:/photo/social/sort/
   * @secure
   * @response `200` `boolean` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SocialPhotosSortPhotoSocialSortPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = SocialPhotosSortPhotoSocialSortPostPayload
    export type RequestHeaders = {}
    export type ResponseBody = boolean
  }
  /**
   * @description Photo Upd
   * @tags photo-module
   * @name PhotoUpdPhotoItemIdPost
   * @summary Photo Upd
   * @request POST:/photo/{item_id}
   * @secure
   * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace PhotoUpdPhotoItemIdPost {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {
      tag: ModelsPhotoTag2
      /**
       * X
       * @default 0
       */
      x?: number
      /**
       * Y
       * @default 0
       */
      y?: number
      /**
       * Zoom
       * @default 1
       */
      zoom?: number
      /**
       * Sort
       * @default 0
       */
      sort?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = TortoiseContribPydanticCreatorModelsPhotoLeaf
  }
  /**
   * @description Photo Get
   * @tags photo-module
   * @name PhotoGetPhotoItemIdGet
   * @summary Photo Get
   * @request GET:/photo/{item_id}
   * @secure
   * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace PhotoGetPhotoItemIdGet {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = TortoiseContribPydanticCreatorModelsPhotoLeaf
  }
  /**
   * @description Photo Del
   * @tags photo-module
   * @name PhotoDelPhotoItemIdDelete
   * @summary Photo Del
   * @request DELETE:/photo/{item_id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace PhotoDelPhotoItemIdDelete {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Photo Edit Polygon
   * @tags photo-module
   * @name PhotoEditPolygonPhotoItemIdPolygonPatch
   * @summary Photo Edit Polygon
   * @request PATCH:/photo/{item_id}/polygon
   * @secure
   * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace PhotoEditPolygonPhotoItemIdPolygonPatch {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = PhotoEditPolygonPhotoItemIdPolygonPatchPayload
    export type RequestHeaders = {}
    export type ResponseBody = TortoiseContribPydanticCreatorModelsPhotoLeaf
  }
  /**
   * @description Social Photo Upd
   * @tags photo-module
   * @name SocialPhotoUpdPhotoSocialItemIdPost
   * @summary Social Photo Upd
   * @request POST:/photo/social/{item_id}
   * @secure
   * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SocialPhotoUpdPhotoSocialItemIdPost {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {
      tag: ModelsPhotoTag2
      /**
       * X
       * @default 0
       */
      x?: number
      /**
       * Y
       * @default 0
       */
      y?: number
      /**
       * Zoom
       * @default 1
       */
      zoom?: number
      /**
       * Sort
       * @default 0
       */
      sort?: number
    }
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = TortoiseContribPydanticCreatorModelsPhotoLeaf
  }
  /**
   * @description Social Photo Get
   * @tags photo-module
   * @name SocialPhotoGetPhotoSocialItemIdGet
   * @summary Social Photo Get
   * @request GET:/photo/social/{item_id}
   * @secure
   * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SocialPhotoGetPhotoSocialItemIdGet {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = TortoiseContribPydanticCreatorModelsPhotoLeaf
  }
  /**
   * @description Social Photo Del
   * @tags photo-module
   * @name SocialPhotoDelPhotoSocialItemIdDelete
   * @summary Social Photo Del
   * @request DELETE:/photo/social/{item_id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SocialPhotoDelPhotoSocialItemIdDelete {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Delete Photos
   * @tags photo-module
   * @name DeletePhotosPhotoAllPhotosDeleteDelete
   * @summary Delete Photos
   * @request DELETE:/photo/all_photos/delete
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace DeletePhotosPhotoAllPhotosDeleteDelete {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = DeletePhotosDto
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Get Bytes
   * @tags photo-module
   * @name GetBytesPhotoBytesItemIdGet
   * @summary Get Bytes
   * @request GET:/photo/bytes/{item_id}
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetBytesPhotoBytesItemIdGet {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Social Get Bytes
   * @tags photo-module
   * @name SocialGetBytesPhotoSocialBytesItemIdGet
   * @summary Social Get Bytes
   * @request GET:/photo/social/bytes/{item_id}
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SocialGetBytesPhotoSocialBytesItemIdGet {
    export type RequestParams = {
      /** Item Id */
      itemId: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Order File Upload
   * @tags photo-module
   * @name OrderFileUploadPhotoOrderOidPhotoUploadPost
   * @summary Order File Upload
   * @request POST:/photo/Order/{oid}/photo_upload
   * @response `200` `string` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace OrderFileUploadPhotoOrderOidPhotoUploadPost {
    export type RequestParams = {
      /** Oid */
      oid: number
    }
    export type RequestQuery = {}
    export type RequestBody = BodyOrderFileUploadPhotoOrderOidPhotoUploadPost
    export type RequestHeaders = {}
    export type ResponseBody = string
  }
  /**
   * @description Add Amenity Photo
   * @tags photo-module
   * @name AddAmenityPhotoPhotoAmenityOidPost
   * @summary Add Amenity Photo
   * @request POST:/photo/Amenity/{oid}
   * @response `200` `string` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace AddAmenityPhotoPhotoAmenityOidPost {
    export type RequestParams = {
      /** Oid */
      oid: number
    }
    export type RequestQuery = {}
    export type RequestBody = BodyAddAmenityPhotoPhotoAmenityOidPost
    export type RequestHeaders = {}
    export type ResponseBody = string
  }
  /**
   * @description Webinar Photo Update
   * @tags photo-module
   * @name WebinarPhotoUpdatePhotoWebinarIdPost
   * @summary Webinar Photo Update
   * @request POST:/photo/Webinar/{id}
   * @response `200` `string` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace WebinarPhotoUpdatePhotoWebinarIdPost {
    export type RequestParams = {
      /** Id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = BodyWebinarPhotoUpdatePhotoWebinarIdPost
    export type RequestHeaders = {}
    export type ResponseBody = string
  }
  /**
   * @description Promotion Photo Update
   * @tags photo-module
   * @name PromotionPhotoUpdatePhotoPromotionIdPost
   * @summary Promotion Photo Update
   * @request POST:/photo/Promotion/{id}
   * @secure
   * @response `200` `string` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace PromotionPhotoUpdatePhotoPromotionIdPost {
    export type RequestParams = {
      /** Id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = BodyPromotionPhotoUpdatePhotoPromotionIdPost
    export type RequestHeaders = {}
    export type ResponseBody = string
  }
}

export namespace Presentation {
  /**
   * @description Get Unit Presentation
   * @tags presentation
   * @name GetUnitPresentationPresentationUnitPost
   * @summary Get Unit Presentation
   * @request POST:/presentation/unit
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitPresentationPresentationUnitPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = UnitPresentBody
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Update Units Order
   * @tags presentation
   * @name UpdateUnitsOrderPresentationUnitUpdateOrderPut
   * @summary Update Units Order
   * @request PUT:/presentation/unit/update_order
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdateUnitsOrderPresentationUnitUpdateOrderPut {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = UpdateUnitsOrderDto
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Update Agent Comment
   * @tags presentation
   * @name UpdateAgentCommentPresentationUnitUpdateAgentCommentPut
   * @summary Update Agent Comment
   * @request PUT:/presentation/unit/update_agent_comment
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdateAgentCommentPresentationUnitUpdateAgentCommentPut {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = AddAgentCommentDto
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Update Client Likes
   * @tags presentation
   * @name UpdateClientLikesPresentationUnitUpdateLikesPut
   * @summary Update Client Likes
   * @request PUT:/presentation/unit/update_likes
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdateClientLikesPresentationUnitUpdateLikesPut {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = LikeDto
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get All Units
   * @tags presentation
   * @name GetAllUnitsPresentationAllUnitsPost
   * @summary Get All Units
   * @request POST:/presentation/all_units
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetAllUnitsPresentationAllUnitsPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = GetAllUnitsPresentationAllUnitsPostPayload
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get Res Presentation
   * @tags presentation
   * @name GetResPresentationPresentationResidentialPost
   * @summary Get Res Presentation
   * @request POST:/presentation/residential
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResPresentationPresentationResidentialPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = ResPresentBody
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get Residential Pres
   * @tags presentation
   * @name GetResidentialPresPresentationGetResidentialsPost
   * @summary Get Residential Pres
   * @request POST:/presentation/get_residentials
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetResidentialPresPresentationGetResidentialsPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = GetResidentialPresPresentationGetResidentialsPostPayload
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
  /**
   * @description Get Unit Pres
   * @tags presentation
   * @name GetUnitPresPresentationGetUnitsPost
   * @summary Get Unit Pres
   * @request POST:/presentation/get_units
   * @secure
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetUnitPresPresentationGetUnitsPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = GetUnitPresPresentationGetUnitsPostPayload
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

export namespace Translations {
  /**
   * @description Add Translation
   * @tags Translations
   * @name AddTranslationTranslationAddPost
   * @summary Add Translation
   * @request POST:/translation/add
   * @secure
   * @response `200` `string` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace AddTranslationTranslationAddPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = TranslationBody
    export type RequestHeaders = {}
    export type ResponseBody = string
  }
  /**
   * @description Edit Translation
   * @tags Translations
   * @name EditTranslationTranslationEditPatch
   * @summary Edit Translation
   * @request PATCH:/translation/edit
   * @secure
   * @response `200` `string` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace EditTranslationTranslationEditPatch {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = TranslationBody
    export type RequestHeaders = {}
    export type ResponseBody = string
  }
}

export namespace PlatformServiceFee {
  /**
   * @description Get Platform Service Fee
   * @tags Platform Service Fee
   * @name GetPlatformServiceFeeV2GetPlatformServiceFeeGet
   * @summary Get Platform Service Fee
   * @request GET:/v2/get_platform_service_fee
   * @secure
   * @response `200` `(FeeResponse | ErrorResponse)` Successful Response
   */
  export namespace GetPlatformServiceFeeV2GetPlatformServiceFeeGet {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = FeeResponse | ErrorResponse
  }
  /**
   * @description Update Service Fee
   * @tags Platform Service Fee
   * @name UpdateServiceFeeV2UpdateServiceFeeNewFeePost
   * @summary Update Service Fee
   * @request POST:/v2/update_service_fee/{new_fee}
   * @secure
   * @response `200` `(UpdateFeeResponse | ErrorResponse)` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdateServiceFeeV2UpdateServiceFeeNewFeePost {
    export type RequestParams = {
      /** New Fee */
      newFee: number
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = UpdateFeeResponse | ErrorResponse
  }
  /**
   * @description Create Service Fee File
   * @tags Platform Service Fee
   * @name CreateServiceFeeFileV2CreateServiceFeePost
   * @summary Create Service Fee File
   * @request POST:/v2/create_service_fee
   * @secure
   * @response `200` `any` Successful Response
   */
  export namespace CreateServiceFeeFileV2CreateServiceFeePost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace Utils {
  /**
   * @description Fill Unique Units Hash
   * @tags Utils
   * @name FillUniqueUnitsHashGenUnitsHashPost
   * @summary Fill Unique Units Hash
   * @request POST:/gen-units-hash
   * @secure
   * @response `200` `any` Successful Response
   */
  export namespace FillUniqueUnitsHashGenUnitsHashPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Fill Unique Residential Hash
   * @tags Utils
   * @name FillUniqueResidentialHashGenResidentialHashPost
   * @summary Fill Unique Residential Hash
   * @request POST:/gen-residential-hash
   * @secure
   * @response `200` `any` Successful Response
   */
  export namespace FillUniqueResidentialHashGenResidentialHashPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Fill Unique User Hash
   * @tags Utils
   * @name FillUniqueUserHashGenUserHashPost
   * @summary Fill Unique User Hash
   * @request POST:/gen-user-hash
   * @secure
   * @response `200` `any` Successful Response
   */
  export namespace FillUniqueUserHashGenUserHashPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Get Statistics Data
   * @tags Utils
   * @name GetStatisticsDataGetDashboardPost
   * @summary Get Statistics Data
   * @request POST:/get-dashboard
   * @secure
   * @response `200` `MetricsResponse` Successful Response
   */
  export namespace GetStatisticsDataGetDashboardPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = MetricsResponse
  }
  /**
   * @description Generate Missing Social Photos
   * @tags Utils
   * @name GenerateMissingSocialPhotosFixSocialPost
   * @summary Generate Missing Social Photos
   * @request POST:/fix-social
   * @secure
   * @response `200` `any` Successful Response
   */
  export namespace GenerateMissingSocialPhotosFixSocialPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Create Landing Data For All Users
   * @tags Utils
   * @name CreateLandingDataForAllUsersFillLandingDataPost
   * @summary Create Landing Data For All Users
   * @request POST:/fill-landing-data
   * @secure
   * @response `200` `any` Successful Response
   */
  export namespace CreateLandingDataForAllUsersFillLandingDataPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Upd User Statuses Sendpulse
   * @tags Utils
   * @name UpdUserStatusesSendpulseUpdSpStatusesPost
   * @summary Upd User Statuses Sendpulse
   * @request POST:/upd-sp-statuses
   * @secure
   * @response `200` `any` Successful Response
   */
  export namespace UpdUserStatusesSendpulseUpdSpStatusesPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Get Deal
   * @tags Utils
   * @name GetDealGetDealIdPost
   * @summary Get Deal
   * @request POST:/get_deal/{id}
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace GetDealGetDealIdPost {
    export type RequestParams = {
      /** Id */
      id: any
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Check Deal
   * @tags Utils
   * @name CheckDealCheckDealEmailPost
   * @summary Check Deal
   * @request POST:/check_deal/{email}
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace CheckDealCheckDealEmailPost {
    export type RequestParams = {
      /** Email */
      email: any
    }
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Get Attrs
   * @tags Utils
   * @name GetAttrsGetAttrsPost
   * @summary Get Attrs
   * @request POST:/get_attrs
   * @response `200` `any` Successful Response
   */
  export namespace GetAttrsGetAttrsPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Update Users Deals Id
   * @tags Utils
   * @name UpdateUsersDealsIdUpdateUsersDealsIdPost
   * @summary Update Users Deals Id
   * @request POST:/update_users_deals_id
   * @response `200` `any` Successful Response
   */
  export namespace UpdateUsersDealsIdUpdateUsersDealsIdPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Sync Deal Responsibles
   * @tags Utils
   * @name SyncDealResponsiblesUpdateManagersCrmPost
   * @summary Sync Deal Responsibles
   * @request POST:/update-managers-crm
   * @response `200` `any` Successful Response
   */
  export namespace SyncDealResponsiblesUpdateManagersCrmPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace Forms {
  /**
   * @description Send Feedback Form
   * @tags Forms
   * @name SendFeedbackFormV2FormsFeedbackPost
   * @summary Send Feedback Form
   * @request POST:/v2/forms/feedback
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SendFeedbackFormV2FormsFeedbackPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = FeedbackForm
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Send Support Form
   * @tags Forms
   * @name SendSupportFormV2FormsSupportPost
   * @summary Send Support Form
   * @request POST:/v2/forms/support
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SendSupportFormV2FormsSupportPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = SupportForm
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Send Ld Form
   * @tags Forms
   * @name SendLdFormV2FormsLandingFormPost
   * @summary Send Ld Form
   * @request POST:/v2/forms/landing-form
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SendLdFormV2FormsLandingFormPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = LandingFormsDto
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Send Personal Offer Form
   * @tags Forms
   * @name SendPersonalOfferFormV2FormsPersonalOfferPost
   * @summary Send Personal Offer Form
   * @request POST:/v2/forms/personal-offer
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SendPersonalOfferFormV2FormsPersonalOfferPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = PersonalOffer
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Send Add Client Notification
   * @tags Forms
   * @name SendAddClientNotificationV2FormsClientAddedPost
   * @summary Send Add Client Notification
   * @request POST:/v2/forms/client-added
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SendAddClientNotificationV2FormsClientAddedPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = AddClientAction
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Send Register Client Notification
   * @tags Forms
   * @name SendRegisterClientNotificationV2FormsClientRegisteredPost
   * @summary Send Register Client Notification
   * @request POST:/v2/forms/client-registered
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SendRegisterClientNotificationV2FormsClientRegisteredPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = RegisterClientAction
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Send Create Quiz Notification
   * @tags Forms
   * @name SendCreateQuizNotificationV2FormsQuizCreatedPost
   * @summary Send Create Quiz Notification
   * @request POST:/v2/forms/quiz-created
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace SendCreateQuizNotificationV2FormsQuizCreatedPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = CreateQuizAction
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace UserSessions {
  /**
   * @description Update User Session Log
   * @tags User Sessions
   * @name UpdateUserSessionLogAddUserSessionPost
   * @summary Update User Session Log
   * @request POST:/add_user_session
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace UpdateUserSessionLogAddUserSessionPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = UserSessionLogDto
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Count Online Users
   * @tags User Sessions
   * @name CountOnlineUsersGetOnlineGet
   * @summary Count Online Users
   * @request GET:/get_online
   * @response `200` `any` Successful Response
   */
  export namespace CountOnlineUsersGetOnlineGet {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
  /**
   * @description Count Logins Last 24H
   * @tags User Sessions
   * @name CountLoginsLast24HGetLastLoginsGet
   * @summary Count Logins Last 24H
   * @request GET:/get_last_logins
   * @response `200` `any` Successful Response
   */
  export namespace CountLoginsLast24HGetLastLoginsGet {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = never
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace LandingForm {
  /**
   * @description Landing Forms Reed Notification
   * @tags LandingForm
   * @name LandingFormsReedNotificationV2LandingFormsReadIdPost
   * @summary Landing Forms Reed Notification
   * @request POST:/v2/LandingForms/read/{id}
   * @secure
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace LandingFormsReedNotificationV2LandingFormsReadIdPost {
    export type RequestParams = {
      /** Id */
      id: number
    }
    export type RequestQuery = {}
    export type RequestBody = LandingFormsReedNotificationV2LandingFormsReadIdPostPayload
    export type RequestHeaders = {}
    export type ResponseBody = any
  }
}

export namespace Webhook {
  /**
   * @description Webhook Signup Success
   * @tags Webhook
   * @name WebhookSignupSuccessV2WebhookSignupSuccessPost
   * @summary Webhook Signup Success
   * @request POST:/v2/Webhook/signup-success
   * @response `200` `object` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  export namespace WebhookSignupSuccessV2WebhookSignupSuccessPost {
    export type RequestParams = {}
    export type RequestQuery = {}
    export type RequestBody = SignupSuccessBody
    export type RequestHeaders = {}
    export type ResponseBody = object
  }
}

/**
 * @title Topli API
 * @version 0.1.0
 */
export class Api {
  http: HttpClient

  constructor(http: HttpClient) {
    this.http = http
  }

  auth = {
    /**
     * @description Signup
     *
     * @tags auth
     * @name Register
     * @summary Signup
     * @request POST:/register
     * @response `200` `Token` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    register: (data: UserReg, params: RequestParams = {}) =>
      this.http.request<Token, HTTPValidationError>({
        path: `/register`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Login For Access Token
     *
     * @tags auth
     * @name Token
     * @summary Login For Access Token
     * @request POST:/token
     * @response `200` `Token` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    token: (data: LoginFormData, params: RequestParams = {}) =>
      this.http.request<Token, HTTPValidationError>({
        path: `/token`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Change Password
     *
     * @tags auth
     * @name ChangePasswordChangePasswordUidPatch
     * @summary Change Password
     * @request PATCH:/change-password/{uid}
     * @secure
     * @response `200` `string` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    changePasswordChangePasswordUidPatch: (uid: number, data: ChangePwdBody, params: RequestParams = {}) =>
      this.http.request<string, HTTPValidationError>({
        path: `/change-password/${uid}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send Sms
     *
     * @tags auth
     * @name SendSmsAuthGetSmsPost
     * @summary Send Sms
     * @request POST:/auth/get-sms
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    sendSmsAuthGetSmsPost: (data: SendSMSBody, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/auth/get-sms`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Verify Code
     *
     * @tags auth
     * @name VerifyCodeAuthVerifySmsPost
     * @summary Verify Code
     * @request POST:/auth/verify-sms
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    verifyCodeAuthVerifySmsPost: (data: VerifySMSBody, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/auth/verify-sms`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reg User
     *
     * @tags auth
     * @name RegUserAuthSignUpPost
     * @summary Reg User
     * @request POST:/auth/sign-up
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    regUserAuthSignUpPost: (data: UserReg, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/auth/sign-up`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Google Auth
     *
     * @tags auth
     * @name GoogleAuthAuthGooglePost
     * @summary Google Auth
     * @request POST:/auth/google
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    googleAuthAuthGooglePost: (data: AuthGoogle, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/auth/google`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send Pwd Recovery Code
     *
     * @tags auth
     * @name SendPwdRecoveryCodeAuthRecoveryPwdGetCodePost
     * @summary Send Pwd Recovery Code
     * @request POST:/auth/recovery_pwd/get_code
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    sendPwdRecoveryCodeAuthRecoveryPwdGetCodePost: (data: RecoveryPwdSendEmailBody, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/auth/recovery_pwd/get_code`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Verify Recovery Code
     *
     * @tags auth
     * @name VerifyRecoveryCodeAuthRecoveryPwdVerifyCodePost
     * @summary Verify Recovery Code
     * @request POST:/auth/recovery_pwd/verify_code
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    verifyRecoveryCodeAuthRecoveryPwdVerifyCodePost: (data: VerifyRecPwdBody, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/auth/recovery_pwd/verify_code`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Recovery Pwd
     *
     * @tags auth
     * @name RecoveryPwdAuthRecoveryPwdSetNewPwdPost
     * @summary Recovery Pwd
     * @request POST:/auth/recovery_pwd/set_new_pwd
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    recoveryPwdAuthRecoveryPwdSetNewPwdPost: (data: RecoveryPwdBody, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/auth/recovery_pwd/set_new_pwd`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Save Phone Tmp
     *
     * @tags auth
     * @name SavePhoneTmpAuthSavePhonePost
     * @summary Save Phone Tmp
     * @request POST:/auth/save-phone
     * @response `200` `Token` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    savePhoneTmpAuthSavePhonePost: (data: SavePhoneTmpBody, params: RequestParams = {}) =>
      this.http.request<Token, HTTPValidationError>({
        path: `/auth/save-phone`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  collection = {
    /**
     * @description Collection Objects List
     *
     * @tags Collection
     * @name GetCollectionList
     * @summary Collection Objects List
     * @request POST:/v2/Collection
     * @secure
     * @response `200` `CollectionList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getCollectionList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<CollectionList, HTTPValidationError>({
        path: `/v2/Collection`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Collection Names List
     *
     * @tags Collection
     * @name GetCollectionNamesList
     * @summary Collection Names List
     * @request GET:/v2/Collection
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getCollectionNamesList: (query: GetCollectionNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Collection`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Collection Object Create
     *
     * @tags Collection
     * @name NewCollection
     * @summary Collection Object Create
     * @request PUT:/v2/Collection
     * @secure
     * @response `200` `Collection` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newCollection: (query: NewCollectionParams, data: CollectionIn, params: RequestParams = {}) =>
      this.http.request<Collection, HTTPValidationError>({
        path: `/v2/Collection`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Collection Object Get
     *
     * @tags Collection
     * @name GetCollection
     * @summary Collection Object Get
     * @request GET:/v2/Collection/{item_id}
     * @secure
     * @response `200` `Collection` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getCollection: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Collection, HTTPValidationError>({
        path: `/v2/Collection/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Collection Object Update
     *
     * @tags Collection
     * @name UpdCollection
     * @summary Collection Object Update
     * @request PATCH:/v2/Collection/{item_id}
     * @secure
     * @response `200` `Collection` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updCollection: (itemId: number | null, data: CollectionIn, params: RequestParams = {}) =>
      this.http.request<Collection, HTTPValidationError>({
        path: `/v2/Collection/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Collection Object Delete
     *
     * @tags Collection
     * @name DelCollection
     * @summary Collection Object Delete
     * @request DELETE:/v2/Collection/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delCollection: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Collection/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Public Collection
     *
     * @tags Collection
     * @name GetPublicCollectionV2CollectionPublicHashSlugPost
     * @summary Get Public Collection
     * @request POST:/v2/Collection/public/{hash_slug}
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getPublicCollectionV2CollectionPublicHashSlugPost: (
      hashSlug: string,
      data: PubColBody,
      params: RequestParams = {},
    ) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Collection/public/${hashSlug}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fill Unique Hash Slugs
     *
     * @tags Collection
     * @name FillUniqueHashSlugsV2CollectionUpdateSlugPost
     * @summary Fill Unique Hash Slugs
     * @request POST:/v2/Collection/update-slug
     * @response `200` `any` Successful Response
     */
    fillUniqueHashSlugsV2CollectionUpdateSlugPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/v2/Collection/update-slug`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @description Edit Collection
     *
     * @tags Collection
     * @name EditCollectionV2CollectionEditIdPatch
     * @summary Edit Collection
     * @request PATCH:/v2/Collection/edit/{id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    editCollectionV2CollectionEditIdPatch: (
      id: number,
      data: EditCollectionV2CollectionEditIdPatchPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Collection/edit/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Safe Delete
     *
     * @tags Collection
     * @name SafeDeleteV2CollectionSafeDeleteCollectionIdDelete
     * @summary Safe Delete
     * @request DELETE:/v2/Collection/safe-delete/{collection_id}
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    safeDeleteV2CollectionSafeDeleteCollectionIdDelete: (collectionId: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Collection/safe-delete/${collectionId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  }
  residentialAmenity = {
    /**
     * @description Residentialamenity Objects List
     *
     * @tags ResidentialAmenity
     * @name GetResidentialAmenityList
     * @summary Residentialamenity Objects List
     * @request POST:/v2/ResidentialAmenity
     * @secure
     * @response `200` `ResidentialAmenityList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialAmenityList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<ResidentialAmenityList, HTTPValidationError>({
        path: `/v2/ResidentialAmenity`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialamenity Names List
     *
     * @tags ResidentialAmenity
     * @name GetResidentialAmenityNamesList
     * @summary Residentialamenity Names List
     * @request GET:/v2/ResidentialAmenity
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialAmenityNamesList: (query: GetResidentialAmenityNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/ResidentialAmenity`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialamenity Object Create
     *
     * @tags ResidentialAmenity
     * @name NewResidentialAmenity
     * @summary Residentialamenity Object Create
     * @request PUT:/v2/ResidentialAmenity
     * @secure
     * @response `200` `ResidentialAmenity` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newResidentialAmenity: (
      query: NewResidentialAmenityParams,
      data: ResidentialAmenityIn,
      params: RequestParams = {},
    ) =>
      this.http.request<ResidentialAmenity, HTTPValidationError>({
        path: `/v2/ResidentialAmenity`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialamenity Object Get
     *
     * @tags ResidentialAmenity
     * @name GetResidentialAmenity
     * @summary Residentialamenity Object Get
     * @request GET:/v2/ResidentialAmenity/{item_id}
     * @secure
     * @response `200` `ResidentialAmenity` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialAmenity: (itemId: number, params: RequestParams = {}) =>
      this.http.request<ResidentialAmenity, HTTPValidationError>({
        path: `/v2/ResidentialAmenity/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialamenity Object Update
     *
     * @tags ResidentialAmenity
     * @name UpdResidentialAmenity
     * @summary Residentialamenity Object Update
     * @request PATCH:/v2/ResidentialAmenity/{item_id}
     * @secure
     * @response `200` `ResidentialAmenity` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updResidentialAmenity: (itemId: number | null, data: ResidentialAmenityIn, params: RequestParams = {}) =>
      this.http.request<ResidentialAmenity, HTTPValidationError>({
        path: `/v2/ResidentialAmenity/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialamenity Object Delete
     *
     * @tags ResidentialAmenity
     * @name DelResidentialAmenity
     * @summary Residentialamenity Object Delete
     * @request DELETE:/v2/ResidentialAmenity/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delResidentialAmenity: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/ResidentialAmenity/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  macrozone = {
    /**
     * @description Macrozone Objects List
     *
     * @tags Macrozone
     * @name GetMacrozoneList
     * @summary Macrozone Objects List
     * @request POST:/v2/Macrozone
     * @secure
     * @response `200` `MacrozoneList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getMacrozoneList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<MacrozoneList, HTTPValidationError>({
        path: `/v2/Macrozone`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Macrozone Names List
     *
     * @tags Macrozone
     * @name GetMacrozoneNamesList
     * @summary Macrozone Names List
     * @request GET:/v2/Macrozone
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getMacrozoneNamesList: (query: GetMacrozoneNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Macrozone`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Macrozone Object Create
     *
     * @tags Macrozone
     * @name NewMacrozone
     * @summary Macrozone Object Create
     * @request PUT:/v2/Macrozone
     * @secure
     * @response `200` `Macrozone` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newMacrozone: (query: NewMacrozoneParams, data: MacrozoneIn, params: RequestParams = {}) =>
      this.http.request<Macrozone, HTTPValidationError>({
        path: `/v2/Macrozone`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Macrozone Object Get
     *
     * @tags Macrozone
     * @name GetMacrozone
     * @summary Macrozone Object Get
     * @request GET:/v2/Macrozone/{item_id}
     * @secure
     * @response `200` `Macrozone` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getMacrozone: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Macrozone, HTTPValidationError>({
        path: `/v2/Macrozone/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Macrozone Object Update
     *
     * @tags Macrozone
     * @name UpdMacrozone
     * @summary Macrozone Object Update
     * @request PATCH:/v2/Macrozone/{item_id}
     * @secure
     * @response `200` `Macrozone` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updMacrozone: (itemId: number | null, data: MacrozoneIn, params: RequestParams = {}) =>
      this.http.request<Macrozone, HTTPValidationError>({
        path: `/v2/Macrozone/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Macrozone Object Delete
     *
     * @tags Macrozone
     * @name DelMacrozone
     * @summary Macrozone Object Delete
     * @request DELETE:/v2/Macrozone/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delMacrozone: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Macrozone/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  unitAmenity = {
    /**
     * @description Unitamenity Objects List
     *
     * @tags UnitAmenity
     * @name GetUnitAmenityList
     * @summary Unitamenity Objects List
     * @request POST:/v2/UnitAmenity
     * @secure
     * @response `200` `UnitAmenityList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitAmenityList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<UnitAmenityList, HTTPValidationError>({
        path: `/v2/UnitAmenity`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitamenity Names List
     *
     * @tags UnitAmenity
     * @name GetUnitAmenityNamesList
     * @summary Unitamenity Names List
     * @request GET:/v2/UnitAmenity
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitAmenityNamesList: (query: GetUnitAmenityNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/UnitAmenity`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitamenity Object Create
     *
     * @tags UnitAmenity
     * @name NewUnitAmenity
     * @summary Unitamenity Object Create
     * @request PUT:/v2/UnitAmenity
     * @secure
     * @response `200` `UnitAmenity` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newUnitAmenity: (query: NewUnitAmenityParams, data: UnitAmenityIn, params: RequestParams = {}) =>
      this.http.request<UnitAmenity, HTTPValidationError>({
        path: `/v2/UnitAmenity`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitamenity Object Get
     *
     * @tags UnitAmenity
     * @name GetUnitAmenity
     * @summary Unitamenity Object Get
     * @request GET:/v2/UnitAmenity/{item_id}
     * @secure
     * @response `200` `UnitAmenity` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitAmenity: (itemId: number, params: RequestParams = {}) =>
      this.http.request<UnitAmenity, HTTPValidationError>({
        path: `/v2/UnitAmenity/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitamenity Object Update
     *
     * @tags UnitAmenity
     * @name UpdUnitAmenity
     * @summary Unitamenity Object Update
     * @request PATCH:/v2/UnitAmenity/{item_id}
     * @secure
     * @response `200` `UnitAmenity` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updUnitAmenity: (itemId: number | null, data: UnitAmenityIn, params: RequestParams = {}) =>
      this.http.request<UnitAmenity, HTTPValidationError>({
        path: `/v2/UnitAmenity/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitamenity Object Delete
     *
     * @tags UnitAmenity
     * @name DelUnitAmenity
     * @summary Unitamenity Object Delete
     * @request DELETE:/v2/UnitAmenity/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delUnitAmenity: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/UnitAmenity/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  address = {
    /**
     * @description Address Objects List
     *
     * @tags Address
     * @name GetAddressList
     * @summary Address Objects List
     * @request POST:/v2/Address
     * @secure
     * @response `200` `AddressList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAddressList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<AddressList, HTTPValidationError>({
        path: `/v2/Address`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Address Names List
     *
     * @tags Address
     * @name GetAddressNamesList
     * @summary Address Names List
     * @request GET:/v2/Address
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAddressNamesList: (query: GetAddressNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Address`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Address Object Create
     *
     * @tags Address
     * @name NewAddress
     * @summary Address Object Create
     * @request PUT:/v2/Address
     * @secure
     * @response `200` `Address` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newAddress: (query: NewAddressParams, data: AddressIn, params: RequestParams = {}) =>
      this.http.request<Address, HTTPValidationError>({
        path: `/v2/Address`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Address Object Get
     *
     * @tags Address
     * @name GetAddress
     * @summary Address Object Get
     * @request GET:/v2/Address/{item_id}
     * @secure
     * @response `200` `Address` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAddress: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Address, HTTPValidationError>({
        path: `/v2/Address/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Address Object Update
     *
     * @tags Address
     * @name UpdAddress
     * @summary Address Object Update
     * @request PATCH:/v2/Address/{item_id}
     * @secure
     * @response `200` `Address` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updAddress: (itemId: number | null, data: AddressIn, params: RequestParams = {}) =>
      this.http.request<Address, HTTPValidationError>({
        path: `/v2/Address/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Address Object Delete
     *
     * @tags Address
     * @name DelAddress
     * @summary Address Object Delete
     * @request DELETE:/v2/Address/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delAddress: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Address/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Locations
     *
     * @tags Address
     * @name GetLocationsGetLocationsPost
     * @summary Get Locations
     * @request POST:/get-locations
     * @secure
     * @response `200` `LocationsResult` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getLocationsGetLocationsPost: (data: GetLocationBody, params: RequestParams = {}) =>
      this.http.request<LocationsResult, HTTPValidationError>({
        path: `/get-locations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  company = {
    /**
     * @description Company Objects List
     *
     * @tags Company
     * @name GetCompanyList
     * @summary Company Objects List
     * @request POST:/v2/Company
     * @secure
     * @response `200` `CompanyList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getCompanyList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<CompanyList, HTTPValidationError>({
        path: `/v2/Company`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Company Names List
     *
     * @tags Company
     * @name GetCompanyNamesList
     * @summary Company Names List
     * @request GET:/v2/Company
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getCompanyNamesList: (query: GetCompanyNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Company`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Company Object Create
     *
     * @tags Company
     * @name NewCompany
     * @summary Company Object Create
     * @request PUT:/v2/Company
     * @secure
     * @response `200` `Company` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newCompany: (query: NewCompanyParams, data: CompanyIn, params: RequestParams = {}) =>
      this.http.request<Company, HTTPValidationError>({
        path: `/v2/Company`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Company Object Get
     *
     * @tags Company
     * @name GetCompany
     * @summary Company Object Get
     * @request GET:/v2/Company/{item_id}
     * @secure
     * @response `200` `Company` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getCompany: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Company, HTTPValidationError>({
        path: `/v2/Company/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Company Object Update
     *
     * @tags Company
     * @name UpdCompany
     * @summary Company Object Update
     * @request PATCH:/v2/Company/{item_id}
     * @secure
     * @response `200` `Company` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updCompany: (itemId: number | null, data: CompanyIn, params: RequestParams = {}) =>
      this.http.request<Company, HTTPValidationError>({
        path: `/v2/Company/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Company Object Delete
     *
     * @tags Company
     * @name DelCompany
     * @summary Company Object Delete
     * @request DELETE:/v2/Company/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delCompany: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Company/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  quiz = {
    /**
     * @description Quiz Objects List
     *
     * @tags Quiz
     * @name GetQuizList
     * @summary Quiz Objects List
     * @request POST:/v2/Quiz
     * @secure
     * @response `200` `QuizList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getQuizList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<QuizList, HTTPValidationError>({
        path: `/v2/Quiz`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Quiz Names List
     *
     * @tags Quiz
     * @name GetQuizNamesList
     * @summary Quiz Names List
     * @request GET:/v2/Quiz
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getQuizNamesList: (query: GetQuizNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Quiz`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Quiz Object Create
     *
     * @tags Quiz
     * @name NewQuiz
     * @summary Quiz Object Create
     * @request PUT:/v2/Quiz
     * @secure
     * @response `200` `Quiz` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newQuiz: (query: NewQuizParams, data: QuizIn, params: RequestParams = {}) =>
      this.http.request<Quiz, HTTPValidationError>({
        path: `/v2/Quiz`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Quiz Object Get
     *
     * @tags Quiz
     * @name GetQuiz
     * @summary Quiz Object Get
     * @request GET:/v2/Quiz/{item_id}
     * @secure
     * @response `200` `Quiz` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getQuiz: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Quiz, HTTPValidationError>({
        path: `/v2/Quiz/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Quiz Object Update
     *
     * @tags Quiz
     * @name UpdQuiz
     * @summary Quiz Object Update
     * @request PATCH:/v2/Quiz/{item_id}
     * @secure
     * @response `200` `Quiz` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updQuiz: (itemId: number | null, data: QuizIn, params: RequestParams = {}) =>
      this.http.request<Quiz, HTTPValidationError>({
        path: `/v2/Quiz/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Quiz Object Delete
     *
     * @tags Quiz
     * @name DelQuiz
     * @summary Quiz Object Delete
     * @request DELETE:/v2/Quiz/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delQuiz: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Quiz/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create Quiz With Collection
     *
     * @tags Quiz
     * @name CreateQuizWithCollectionV2QuizCreatePost
     * @summary Create Quiz With Collection
     * @request POST:/v2/Quiz/create
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    createQuizWithCollectionV2QuizCreatePost: (
      data: CreateQuizWithCollectionV2QuizCreatePostPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Quiz/create`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update Quiz With Collection
     *
     * @tags Quiz
     * @name UpdateQuizWithCollectionV2QuizUpdateQuizIdPut
     * @summary Update Quiz With Collection
     * @request PUT:/v2/Quiz/update/{quiz_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateQuizWithCollectionV2QuizUpdateQuizIdPut: (
      quizId: number,
      data: UpdateQuizWithCollectionV2QuizUpdateQuizIdPutPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Quiz/update/${quizId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete Quiz
     *
     * @tags Quiz
     * @name DeleteQuizV2QuizDeleteQuizIdDelete
     * @summary Delete Quiz
     * @request DELETE:/v2/Quiz/delete/{quiz_id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    deleteQuizV2QuizDeleteQuizIdDelete: (quizId: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Quiz/delete/${quizId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  team = {
    /**
     * @description Team Objects List
     *
     * @tags Team
     * @name GetTeamList
     * @summary Team Objects List
     * @request POST:/v2/Team
     * @secure
     * @response `200` `TeamList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getTeamList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<TeamList, HTTPValidationError>({
        path: `/v2/Team`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Team Names List
     *
     * @tags Team
     * @name GetTeamNamesList
     * @summary Team Names List
     * @request GET:/v2/Team
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getTeamNamesList: (query: GetTeamNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Team`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Team Object Create
     *
     * @tags Team
     * @name NewTeam
     * @summary Team Object Create
     * @request PUT:/v2/Team
     * @secure
     * @response `200` `Team` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newTeam: (query: NewTeamParams, data: TeamIn, params: RequestParams = {}) =>
      this.http.request<Team, HTTPValidationError>({
        path: `/v2/Team`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Team Object Get
     *
     * @tags Team
     * @name GetTeam
     * @summary Team Object Get
     * @request GET:/v2/Team/{item_id}
     * @secure
     * @response `200` `Team` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getTeam: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Team, HTTPValidationError>({
        path: `/v2/Team/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Team Object Update
     *
     * @tags Team
     * @name UpdTeam
     * @summary Team Object Update
     * @request PATCH:/v2/Team/{item_id}
     * @secure
     * @response `200` `Team` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updTeam: (itemId: number | null, data: TeamIn, params: RequestParams = {}) =>
      this.http.request<Team, HTTPValidationError>({
        path: `/v2/Team/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Team Object Delete
     *
     * @tags Team
     * @name DelTeam
     * @summary Team Object Delete
     * @request DELETE:/v2/Team/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delTeam: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Team/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Team
     *
     * @tags Team
     * @name GetTeamV2TeamGetTeamHashGet
     * @summary Get Team
     * @request GET:/v2/Team/get_team/{hash}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getTeamV2TeamGetTeamHashGet: (hash: string, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Team/get_team/${hash}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create Team
     *
     * @tags Team
     * @name CreateTeamV2TeamCreateUserIdPost
     * @summary Create Team
     * @request POST:/v2/Team/create/{user_id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    createTeamV2TeamCreateUserIdPost: (userId: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Team/create/${userId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Add Team Member
     *
     * @tags Team
     * @name AddTeamMemberV2TeamAddMemberTeamIdUserIdPost
     * @summary Add Team Member
     * @request POST:/v2/Team/add-member/{team_id}/{user_id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    addTeamMemberV2TeamAddMemberTeamIdUserIdPost: (userId: number, teamId: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Team/add-member/${teamId}/${userId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Remove User From Team
     *
     * @tags Team
     * @name RemoveUserFromTeamV2TeamRemoveMemberUserIdPost
     * @summary Remove User From Team
     * @request POST:/v2/Team/remove-member/{user_id}
     * @secure
     * @response `200` `(any)[]` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    removeUserFromTeamV2TeamRemoveMemberUserIdPost: (userId: number, params: RequestParams = {}) =>
      this.http.request<any[], HTTPValidationError>({
        path: `/v2/Team/remove-member/${userId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Invite User To Team
     *
     * @tags Team
     * @name InviteUserToTeamV2TeamInviteMemberPost
     * @summary Invite User To Team
     * @request POST:/v2/Team/invite-member
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    inviteUserToTeamV2TeamInviteMemberPost: (data: InviteToTeam, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Team/invite-member`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update Team And Members
     *
     * @tags Team
     * @name UpdateTeamAndMembersV2TeamUpdateTeamPost
     * @summary Update Team And Members
     * @request POST:/v2/Team/update-team
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateTeamAndMembersV2TeamUpdateTeamPost: (data: UpdateTeamDto, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Team/update-team`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Block All Team Users
     *
     * @tags Team
     * @name BlockAllTeamUsersV2TeamBlockTeamHashSlugPost
     * @summary Block All Team Users
     * @request POST:/v2/Team/block-team/{hash_slug}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    blockAllTeamUsersV2TeamBlockTeamHashSlugPost: (hashSlug: string, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Team/block-team/${hashSlug}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  socialPhoto = {
    /**
     * @description Socialphoto Objects List
     *
     * @tags SocialPhoto
     * @name GetSocialPhotoList
     * @summary Socialphoto Objects List
     * @request POST:/v2/SocialPhoto
     * @secure
     * @response `200` `SocialPhotoList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getSocialPhotoList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<SocialPhotoList, HTTPValidationError>({
        path: `/v2/SocialPhoto`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Socialphoto Names List
     *
     * @tags SocialPhoto
     * @name GetSocialPhotoNamesList
     * @summary Socialphoto Names List
     * @request GET:/v2/SocialPhoto
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getSocialPhotoNamesList: (query: GetSocialPhotoNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/SocialPhoto`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Socialphoto Object Create
     *
     * @tags SocialPhoto
     * @name NewSocialPhoto
     * @summary Socialphoto Object Create
     * @request PUT:/v2/SocialPhoto
     * @secure
     * @response `200` `SocialPhoto` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newSocialPhoto: (query: NewSocialPhotoParams, data: SocialPhotoIn, params: RequestParams = {}) =>
      this.http.request<SocialPhoto, HTTPValidationError>({
        path: `/v2/SocialPhoto`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Socialphoto Object Get
     *
     * @tags SocialPhoto
     * @name GetSocialPhoto
     * @summary Socialphoto Object Get
     * @request GET:/v2/SocialPhoto/{item_id}
     * @secure
     * @response `200` `SocialPhoto` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getSocialPhoto: (itemId: number, params: RequestParams = {}) =>
      this.http.request<SocialPhoto, HTTPValidationError>({
        path: `/v2/SocialPhoto/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Socialphoto Object Update
     *
     * @tags SocialPhoto
     * @name UpdSocialPhoto
     * @summary Socialphoto Object Update
     * @request PATCH:/v2/SocialPhoto/{item_id}
     * @secure
     * @response `200` `SocialPhoto` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updSocialPhoto: (itemId: number | null, data: SocialPhotoIn, params: RequestParams = {}) =>
      this.http.request<SocialPhoto, HTTPValidationError>({
        path: `/v2/SocialPhoto/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Socialphoto Object Delete
     *
     * @tags SocialPhoto
     * @name DelSocialPhoto
     * @summary Socialphoto Object Delete
     * @request DELETE:/v2/SocialPhoto/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delSocialPhoto: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/SocialPhoto/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  companyTranslation = {
    /**
     * @description Companytranslation Objects List
     *
     * @tags CompanyTranslation
     * @name GetCompanyTranslationList
     * @summary Companytranslation Objects List
     * @request POST:/v2/CompanyTranslation
     * @secure
     * @response `200` `CompanyTranslationList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getCompanyTranslationList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<CompanyTranslationList, HTTPValidationError>({
        path: `/v2/CompanyTranslation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Companytranslation Names List
     *
     * @tags CompanyTranslation
     * @name GetCompanyTranslationNamesList
     * @summary Companytranslation Names List
     * @request GET:/v2/CompanyTranslation
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getCompanyTranslationNamesList: (query: GetCompanyTranslationNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/CompanyTranslation`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Companytranslation Object Create
     *
     * @tags CompanyTranslation
     * @name NewCompanyTranslation
     * @summary Companytranslation Object Create
     * @request PUT:/v2/CompanyTranslation
     * @secure
     * @response `200` `CompanyTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newCompanyTranslation: (
      query: NewCompanyTranslationParams,
      data: CompanyTranslationIn,
      params: RequestParams = {},
    ) =>
      this.http.request<CompanyTranslation, HTTPValidationError>({
        path: `/v2/CompanyTranslation`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Companytranslation Object Get
     *
     * @tags CompanyTranslation
     * @name GetCompanyTranslation
     * @summary Companytranslation Object Get
     * @request GET:/v2/CompanyTranslation/{item_id}
     * @secure
     * @response `200` `CompanyTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getCompanyTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<CompanyTranslation, HTTPValidationError>({
        path: `/v2/CompanyTranslation/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Companytranslation Object Update
     *
     * @tags CompanyTranslation
     * @name UpdCompanyTranslation
     * @summary Companytranslation Object Update
     * @request PATCH:/v2/CompanyTranslation/{item_id}
     * @secure
     * @response `200` `CompanyTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updCompanyTranslation: (itemId: number | null, data: CompanyTranslationIn, params: RequestParams = {}) =>
      this.http.request<CompanyTranslation, HTTPValidationError>({
        path: `/v2/CompanyTranslation/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Companytranslation Object Delete
     *
     * @tags CompanyTranslation
     * @name DelCompanyTranslation
     * @summary Companytranslation Object Delete
     * @request DELETE:/v2/CompanyTranslation/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delCompanyTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/CompanyTranslation/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  unitPresentation = {
    /**
     * @description Unitpresentation Objects List
     *
     * @tags UnitPresentation
     * @name GetUnitPresentationList
     * @summary Unitpresentation Objects List
     * @request POST:/v2/UnitPresentation
     * @secure
     * @response `200` `UnitPresentationList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitPresentationList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<UnitPresentationList, HTTPValidationError>({
        path: `/v2/UnitPresentation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitpresentation Names List
     *
     * @tags UnitPresentation
     * @name GetUnitPresentationNamesList
     * @summary Unitpresentation Names List
     * @request GET:/v2/UnitPresentation
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitPresentationNamesList: (query: GetUnitPresentationNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/UnitPresentation`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitpresentation Object Create
     *
     * @tags UnitPresentation
     * @name NewUnitPresentation
     * @summary Unitpresentation Object Create
     * @request PUT:/v2/UnitPresentation
     * @secure
     * @response `200` `UnitPresentation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newUnitPresentation: (query: NewUnitPresentationParams, data: UnitPresentationIn, params: RequestParams = {}) =>
      this.http.request<UnitPresentation, HTTPValidationError>({
        path: `/v2/UnitPresentation`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitpresentation Object Get
     *
     * @tags UnitPresentation
     * @name GetUnitPresentation
     * @summary Unitpresentation Object Get
     * @request GET:/v2/UnitPresentation/{item_id}
     * @secure
     * @response `200` `UnitPresentation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitPresentation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<UnitPresentation, HTTPValidationError>({
        path: `/v2/UnitPresentation/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitpresentation Object Update
     *
     * @tags UnitPresentation
     * @name UpdUnitPresentation
     * @summary Unitpresentation Object Update
     * @request PATCH:/v2/UnitPresentation/{item_id}
     * @secure
     * @response `200` `UnitPresentation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updUnitPresentation: (itemId: number | null, data: UnitPresentationIn, params: RequestParams = {}) =>
      this.http.request<UnitPresentation, HTTPValidationError>({
        path: `/v2/UnitPresentation/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitpresentation Object Delete
     *
     * @tags UnitPresentation
     * @name DelUnitPresentation
     * @summary Unitpresentation Object Delete
     * @request DELETE:/v2/UnitPresentation/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delUnitPresentation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/UnitPresentation/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  webinar = {
    /**
     * @description Webinar Objects List
     *
     * @tags Webinar
     * @name GetWebinarList
     * @summary Webinar Objects List
     * @request POST:/v2/Webinar
     * @secure
     * @response `200` `WebinarList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getWebinarList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<WebinarList, HTTPValidationError>({
        path: `/v2/Webinar`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Webinar Names List
     *
     * @tags Webinar
     * @name GetWebinarNamesList
     * @summary Webinar Names List
     * @request GET:/v2/Webinar
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getWebinarNamesList: (query: GetWebinarNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Webinar`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Webinar Object Create
     *
     * @tags Webinar
     * @name NewWebinar
     * @summary Webinar Object Create
     * @request PUT:/v2/Webinar
     * @secure
     * @response `200` `Webinar` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newWebinar: (query: NewWebinarParams, data: WebinarIn, params: RequestParams = {}) =>
      this.http.request<Webinar, HTTPValidationError>({
        path: `/v2/Webinar`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Webinar Object Get
     *
     * @tags Webinar
     * @name GetWebinar
     * @summary Webinar Object Get
     * @request GET:/v2/Webinar/{item_id}
     * @secure
     * @response `200` `Webinar` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getWebinar: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Webinar, HTTPValidationError>({
        path: `/v2/Webinar/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Webinar Object Update
     *
     * @tags Webinar
     * @name UpdWebinar
     * @summary Webinar Object Update
     * @request PATCH:/v2/Webinar/{item_id}
     * @secure
     * @response `200` `Webinar` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updWebinar: (itemId: number | null, data: WebinarIn, params: RequestParams = {}) =>
      this.http.request<Webinar, HTTPValidationError>({
        path: `/v2/Webinar/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Webinar Object Delete
     *
     * @tags Webinar
     * @name DelWebinar
     * @summary Webinar Object Delete
     * @request DELETE:/v2/Webinar/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delWebinar: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Webinar/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  unit = {
    /**
     * @description Unit Objects List
     *
     * @tags Unit
     * @name GetUnitList
     * @summary Unit Objects List
     * @request POST:/v2/Unit
     * @secure
     * @response `200` `UnitList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<UnitList, HTTPValidationError>({
        path: `/v2/Unit`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unit Names List
     *
     * @tags Unit
     * @name GetUnitNamesList
     * @summary Unit Names List
     * @request GET:/v2/Unit
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitNamesList: (query: GetUnitNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Unit`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unit Object Create
     *
     * @tags Unit
     * @name NewUnit
     * @summary Unit Object Create
     * @request PUT:/v2/Unit
     * @secure
     * @response `200` `Unit` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newUnit: (query: NewUnitParams, data: UnitIn, params: RequestParams = {}) =>
      this.http.request<Unit, HTTPValidationError>({
        path: `/v2/Unit`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unit Object Get
     *
     * @tags Unit
     * @name GetUnit
     * @summary Unit Object Get
     * @request GET:/v2/Unit/{item_id}
     * @secure
     * @response `200` `Unit` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnit: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Unit, HTTPValidationError>({
        path: `/v2/Unit/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unit Object Update
     *
     * @tags Unit
     * @name UpdUnit
     * @summary Unit Object Update
     * @request PATCH:/v2/Unit/{item_id}
     * @secure
     * @response `200` `Unit` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updUnit: (itemId: number | null, data: UnitIn, params: RequestParams = {}) =>
      this.http.request<Unit, HTTPValidationError>({
        path: `/v2/Unit/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unit Object Delete
     *
     * @tags Unit
     * @name DelUnit
     * @summary Unit Object Delete
     * @request DELETE:/v2/Unit/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delUnit: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Unit/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  prices = {
    /**
     * @description Prices Objects List
     *
     * @tags Prices
     * @name GetPricesList
     * @summary Prices Objects List
     * @request POST:/v2/Prices
     * @secure
     * @response `200` `PricesList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getPricesList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<PricesList, HTTPValidationError>({
        path: `/v2/Prices`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Prices Names List
     *
     * @tags Prices
     * @name GetPricesNamesList
     * @summary Prices Names List
     * @request GET:/v2/Prices
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getPricesNamesList: (query: GetPricesNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Prices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Prices Object Create
     *
     * @tags Prices
     * @name NewPrices
     * @summary Prices Object Create
     * @request PUT:/v2/Prices
     * @secure
     * @response `200` `Prices` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newPrices: (query: NewPricesParams, data: PricesIn, params: RequestParams = {}) =>
      this.http.request<Prices, HTTPValidationError>({
        path: `/v2/Prices`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Prices Object Get
     *
     * @tags Prices
     * @name GetPrices
     * @summary Prices Object Get
     * @request GET:/v2/Prices/{item_id}
     * @secure
     * @response `200` `Prices` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getPrices: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Prices, HTTPValidationError>({
        path: `/v2/Prices/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Prices Object Update
     *
     * @tags Prices
     * @name UpdPrices
     * @summary Prices Object Update
     * @request PATCH:/v2/Prices/{item_id}
     * @secure
     * @response `200` `Prices` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updPrices: (itemId: number | null, data: PricesIn, params: RequestParams = {}) =>
      this.http.request<Prices, HTTPValidationError>({
        path: `/v2/Prices/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Prices Object Delete
     *
     * @tags Prices
     * @name DelPrices
     * @summary Prices Object Delete
     * @request DELETE:/v2/Prices/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delPrices: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Prices/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Add Prices
     *
     * @tags Prices
     * @name AddPricesV2PricesAddPricesPut
     * @summary Add Prices
     * @request PUT:/v2/Prices/add-prices
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    addPricesV2PricesAddPricesPut: (data: PricesBody, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Prices/add-prices`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Edit Prices
     *
     * @tags Prices
     * @name EditPricesV2PricesEditPricesPut
     * @summary Edit Prices
     * @request PUT:/v2/Prices/edit-prices
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    editPricesV2PricesEditPricesPut: (data: PricesBody, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Prices/edit-prices`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete Prices
     *
     * @tags Prices
     * @name DeletePricesV2PricesDeletePricesPost
     * @summary Delete Prices
     * @request POST:/v2/Prices/delete-prices
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    deletePricesV2PricesDeletePricesPost: (data: DeletePriceBody, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Prices/delete-prices`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send Price Request
     *
     * @tags Prices
     * @name SendPriceRequestPriceRequestPost
     * @summary Send Price Request
     * @request POST:/price-request
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    sendPriceRequestPriceRequestPost: (data: PriceRequest, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/price-request`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  unitTranslation = {
    /**
     * @description Unittranslation Objects List
     *
     * @tags UnitTranslation
     * @name GetUnitTranslationList
     * @summary Unittranslation Objects List
     * @request POST:/v2/UnitTranslation
     * @secure
     * @response `200` `UnitTranslationList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitTranslationList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<UnitTranslationList, HTTPValidationError>({
        path: `/v2/UnitTranslation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unittranslation Names List
     *
     * @tags UnitTranslation
     * @name GetUnitTranslationNamesList
     * @summary Unittranslation Names List
     * @request GET:/v2/UnitTranslation
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitTranslationNamesList: (query: GetUnitTranslationNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/UnitTranslation`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unittranslation Object Create
     *
     * @tags UnitTranslation
     * @name NewUnitTranslation
     * @summary Unittranslation Object Create
     * @request PUT:/v2/UnitTranslation
     * @secure
     * @response `200` `UnitTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newUnitTranslation: (query: NewUnitTranslationParams, data: UnitTranslationIn, params: RequestParams = {}) =>
      this.http.request<UnitTranslation, HTTPValidationError>({
        path: `/v2/UnitTranslation`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unittranslation Object Get
     *
     * @tags UnitTranslation
     * @name GetUnitTranslation
     * @summary Unittranslation Object Get
     * @request GET:/v2/UnitTranslation/{item_id}
     * @secure
     * @response `200` `UnitTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<UnitTranslation, HTTPValidationError>({
        path: `/v2/UnitTranslation/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unittranslation Object Update
     *
     * @tags UnitTranslation
     * @name UpdUnitTranslation
     * @summary Unittranslation Object Update
     * @request PATCH:/v2/UnitTranslation/{item_id}
     * @secure
     * @response `200` `UnitTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updUnitTranslation: (itemId: number | null, data: UnitTranslationIn, params: RequestParams = {}) =>
      this.http.request<UnitTranslation, HTTPValidationError>({
        path: `/v2/UnitTranslation/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unittranslation Object Delete
     *
     * @tags UnitTranslation
     * @name DelUnitTranslation
     * @summary Unittranslation Object Delete
     * @request DELETE:/v2/UnitTranslation/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delUnitTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/UnitTranslation/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  buildingTranslation = {
    /**
     * @description Buildingtranslation Objects List
     *
     * @tags BuildingTranslation
     * @name GetBuildingTranslationList
     * @summary Buildingtranslation Objects List
     * @request POST:/v2/BuildingTranslation
     * @secure
     * @response `200` `BuildingTranslationList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getBuildingTranslationList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<BuildingTranslationList, HTTPValidationError>({
        path: `/v2/BuildingTranslation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Buildingtranslation Names List
     *
     * @tags BuildingTranslation
     * @name GetBuildingTranslationNamesList
     * @summary Buildingtranslation Names List
     * @request GET:/v2/BuildingTranslation
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getBuildingTranslationNamesList: (query: GetBuildingTranslationNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/BuildingTranslation`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Buildingtranslation Object Create
     *
     * @tags BuildingTranslation
     * @name NewBuildingTranslation
     * @summary Buildingtranslation Object Create
     * @request PUT:/v2/BuildingTranslation
     * @secure
     * @response `200` `BuildingTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newBuildingTranslation: (
      query: NewBuildingTranslationParams,
      data: BuildingTranslationIn,
      params: RequestParams = {},
    ) =>
      this.http.request<BuildingTranslation, HTTPValidationError>({
        path: `/v2/BuildingTranslation`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Buildingtranslation Object Get
     *
     * @tags BuildingTranslation
     * @name GetBuildingTranslation
     * @summary Buildingtranslation Object Get
     * @request GET:/v2/BuildingTranslation/{item_id}
     * @secure
     * @response `200` `BuildingTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getBuildingTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<BuildingTranslation, HTTPValidationError>({
        path: `/v2/BuildingTranslation/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Buildingtranslation Object Update
     *
     * @tags BuildingTranslation
     * @name UpdBuildingTranslation
     * @summary Buildingtranslation Object Update
     * @request PATCH:/v2/BuildingTranslation/{item_id}
     * @secure
     * @response `200` `BuildingTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updBuildingTranslation: (itemId: number | null, data: BuildingTranslationIn, params: RequestParams = {}) =>
      this.http.request<BuildingTranslation, HTTPValidationError>({
        path: `/v2/BuildingTranslation/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Buildingtranslation Object Delete
     *
     * @tags BuildingTranslation
     * @name DelBuildingTranslation
     * @summary Buildingtranslation Object Delete
     * @request DELETE:/v2/BuildingTranslation/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delBuildingTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/BuildingTranslation/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  userSessionLog = {
    /**
     * @description Usersessionlog Objects List
     *
     * @tags UserSessionLog
     * @name GetUserSessionLogList
     * @summary Usersessionlog Objects List
     * @request POST:/v2/UserSessionLog
     * @secure
     * @response `200` `UserSessionLogList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUserSessionLogList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<UserSessionLogList, HTTPValidationError>({
        path: `/v2/UserSessionLog`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Usersessionlog Names List
     *
     * @tags UserSessionLog
     * @name GetUserSessionLogNamesList
     * @summary Usersessionlog Names List
     * @request GET:/v2/UserSessionLog
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUserSessionLogNamesList: (query: GetUserSessionLogNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/UserSessionLog`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Usersessionlog Object Create
     *
     * @tags UserSessionLog
     * @name NewUserSessionLog
     * @summary Usersessionlog Object Create
     * @request PUT:/v2/UserSessionLog
     * @secure
     * @response `200` `UserSessionLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newUserSessionLog: (query: NewUserSessionLogParams, data: UserSessionLogIn, params: RequestParams = {}) =>
      this.http.request<UserSessionLog, HTTPValidationError>({
        path: `/v2/UserSessionLog`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Usersessionlog Object Get
     *
     * @tags UserSessionLog
     * @name GetUserSessionLog
     * @summary Usersessionlog Object Get
     * @request GET:/v2/UserSessionLog/{item_id}
     * @secure
     * @response `200` `UserSessionLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUserSessionLog: (itemId: number, params: RequestParams = {}) =>
      this.http.request<UserSessionLog, HTTPValidationError>({
        path: `/v2/UserSessionLog/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Usersessionlog Object Update
     *
     * @tags UserSessionLog
     * @name UpdUserSessionLog
     * @summary Usersessionlog Object Update
     * @request PATCH:/v2/UserSessionLog/{item_id}
     * @secure
     * @response `200` `UserSessionLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updUserSessionLog: (itemId: number | null, data: UserSessionLogIn, params: RequestParams = {}) =>
      this.http.request<UserSessionLog, HTTPValidationError>({
        path: `/v2/UserSessionLog/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Usersessionlog Object Delete
     *
     * @tags UserSessionLog
     * @name DelUserSessionLog
     * @summary Usersessionlog Object Delete
     * @request DELETE:/v2/UserSessionLog/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delUserSessionLog: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/UserSessionLog/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  userActionsLog = {
    /**
     * @description Useractionslog Objects List
     *
     * @tags UserActionsLog
     * @name GetUserActionsLogList
     * @summary Useractionslog Objects List
     * @request POST:/v2/UserActionsLog
     * @secure
     * @response `200` `UserActionsLogList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUserActionsLogList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<UserActionsLogList, HTTPValidationError>({
        path: `/v2/UserActionsLog`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Useractionslog Names List
     *
     * @tags UserActionsLog
     * @name GetUserActionsLogNamesList
     * @summary Useractionslog Names List
     * @request GET:/v2/UserActionsLog
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUserActionsLogNamesList: (query: GetUserActionsLogNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/UserActionsLog`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Useractionslog Object Create
     *
     * @tags UserActionsLog
     * @name NewUserActionsLog
     * @summary Useractionslog Object Create
     * @request PUT:/v2/UserActionsLog
     * @secure
     * @response `200` `UserActionsLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newUserActionsLog: (query: NewUserActionsLogParams, data: UserActionsLogIn, params: RequestParams = {}) =>
      this.http.request<UserActionsLog, HTTPValidationError>({
        path: `/v2/UserActionsLog`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Useractionslog Object Get
     *
     * @tags UserActionsLog
     * @name GetUserActionsLog
     * @summary Useractionslog Object Get
     * @request GET:/v2/UserActionsLog/{item_id}
     * @secure
     * @response `200` `UserActionsLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUserActionsLog: (itemId: number, params: RequestParams = {}) =>
      this.http.request<UserActionsLog, HTTPValidationError>({
        path: `/v2/UserActionsLog/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Useractionslog Object Update
     *
     * @tags UserActionsLog
     * @name UpdUserActionsLog
     * @summary Useractionslog Object Update
     * @request PATCH:/v2/UserActionsLog/{item_id}
     * @secure
     * @response `200` `UserActionsLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updUserActionsLog: (itemId: number | null, data: UserActionsLogIn, params: RequestParams = {}) =>
      this.http.request<UserActionsLog, HTTPValidationError>({
        path: `/v2/UserActionsLog/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Useractionslog Object Delete
     *
     * @tags UserActionsLog
     * @name DelUserActionsLog
     * @summary Useractionslog Object Delete
     * @request DELETE:/v2/UserActionsLog/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delUserActionsLog: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/UserActionsLog/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  residentialTranslation = {
    /**
     * @description Residentialtranslation Objects List
     *
     * @tags ResidentialTranslation
     * @name GetResidentialTranslationList
     * @summary Residentialtranslation Objects List
     * @request POST:/v2/ResidentialTranslation
     * @secure
     * @response `200` `ResidentialTranslationList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialTranslationList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<ResidentialTranslationList, HTTPValidationError>({
        path: `/v2/ResidentialTranslation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialtranslation Names List
     *
     * @tags ResidentialTranslation
     * @name GetResidentialTranslationNamesList
     * @summary Residentialtranslation Names List
     * @request GET:/v2/ResidentialTranslation
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialTranslationNamesList: (query: GetResidentialTranslationNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/ResidentialTranslation`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialtranslation Object Create
     *
     * @tags ResidentialTranslation
     * @name NewResidentialTranslation
     * @summary Residentialtranslation Object Create
     * @request PUT:/v2/ResidentialTranslation
     * @secure
     * @response `200` `ResidentialTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newResidentialTranslation: (
      query: NewResidentialTranslationParams,
      data: ResidentialTranslationIn,
      params: RequestParams = {},
    ) =>
      this.http.request<ResidentialTranslation, HTTPValidationError>({
        path: `/v2/ResidentialTranslation`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialtranslation Object Get
     *
     * @tags ResidentialTranslation
     * @name GetResidentialTranslation
     * @summary Residentialtranslation Object Get
     * @request GET:/v2/ResidentialTranslation/{item_id}
     * @secure
     * @response `200` `ResidentialTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<ResidentialTranslation, HTTPValidationError>({
        path: `/v2/ResidentialTranslation/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialtranslation Object Update
     *
     * @tags ResidentialTranslation
     * @name UpdResidentialTranslation
     * @summary Residentialtranslation Object Update
     * @request PATCH:/v2/ResidentialTranslation/{item_id}
     * @secure
     * @response `200` `ResidentialTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updResidentialTranslation: (itemId: number | null, data: ResidentialTranslationIn, params: RequestParams = {}) =>
      this.http.request<ResidentialTranslation, HTTPValidationError>({
        path: `/v2/ResidentialTranslation/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialtranslation Object Delete
     *
     * @tags ResidentialTranslation
     * @name DelResidentialTranslation
     * @summary Residentialtranslation Object Delete
     * @request DELETE:/v2/ResidentialTranslation/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delResidentialTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/ResidentialTranslation/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  residential = {
    /**
     * @description Residential Objects List
     *
     * @tags Residential
     * @name GetResidentialList
     * @summary Residential Objects List
     * @request POST:/v2/Residential
     * @secure
     * @response `200` `ResidentialList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<ResidentialList, HTTPValidationError>({
        path: `/v2/Residential`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residential Names List
     *
     * @tags Residential
     * @name GetResidentialNamesList
     * @summary Residential Names List
     * @request GET:/v2/Residential
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialNamesList: (query: GetResidentialNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Residential`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residential Object Create
     *
     * @tags Residential
     * @name NewResidential
     * @summary Residential Object Create
     * @request PUT:/v2/Residential
     * @secure
     * @response `200` `Residential` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newResidential: (query: NewResidentialParams, data: ResidentialIn, params: RequestParams = {}) =>
      this.http.request<Residential, HTTPValidationError>({
        path: `/v2/Residential`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residential Object Get
     *
     * @tags Residential
     * @name GetResidential
     * @summary Residential Object Get
     * @request GET:/v2/Residential/{item_id}
     * @secure
     * @response `200` `Residential` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidential: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Residential, HTTPValidationError>({
        path: `/v2/Residential/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residential Object Update
     *
     * @tags Residential
     * @name UpdResidential
     * @summary Residential Object Update
     * @request PATCH:/v2/Residential/{item_id}
     * @secure
     * @response `200` `Residential` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updResidential: (itemId: number | null, data: ResidentialIn, params: RequestParams = {}) =>
      this.http.request<Residential, HTTPValidationError>({
        path: `/v2/Residential/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residential Object Delete
     *
     * @tags Residential
     * @name DelResidential
     * @summary Residential Object Delete
     * @request DELETE:/v2/Residential/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delResidential: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Residential/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Residential By Id
     *
     * @tags Residential
     * @name GetResidentialByIdV2ResidentialGetByIdPublicUidGet
     * @summary Get Residential By Id
     * @request GET:/v2/Residential/get_by_id_public/{uid}
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialByIdV2ResidentialGetByIdPublicUidGet: (uid: any, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Residential/get_by_id_public/${uid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Residential By Hash
     *
     * @tags Residential
     * @name GetResidentialByHashV2ResidentialGetByHashPublicPost
     * @summary Get Residential By Hash
     * @request POST:/v2/Residential/get_by_hash_public
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialByHashV2ResidentialGetByHashPublicPost: (data: GetResBody, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Residential/get_by_hash_public`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Residential By Ids
     *
     * @tags Residential
     * @name GetResidentialByIdsV2ResidentialGetByIdsPublicPost
     * @summary Get Residential By Ids
     * @request POST:/v2/Residential/get_by_ids_public
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialByIdsV2ResidentialGetByIdsPublicPost: (
      data: GetResidentialByIdsV2ResidentialGetByIdsPublicPostPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Residential/get_by_ids_public`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update Residentials Order
     *
     * @tags Residential
     * @name UpdateResidentialsOrderV2ResidentialUpdateOrderPut
     * @summary Update Residentials Order
     * @request PUT:/v2/Residential/update_order
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateResidentialsOrderV2ResidentialUpdateOrderPut: (
      data: UpdateResidentialsOrderDto,
      params: RequestParams = {},
    ) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Residential/update_order`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  template = {
    /**
     * @description Template Objects List
     *
     * @tags Template
     * @name GetTemplateList
     * @summary Template Objects List
     * @request POST:/v2/Template
     * @secure
     * @response `200` `TemplateList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getTemplateList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<TemplateList, HTTPValidationError>({
        path: `/v2/Template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Template Names List
     *
     * @tags Template
     * @name GetTemplateNamesList
     * @summary Template Names List
     * @request GET:/v2/Template
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getTemplateNamesList: (query: GetTemplateNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Template`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Template Object Create
     *
     * @tags Template
     * @name NewTemplate
     * @summary Template Object Create
     * @request PUT:/v2/Template
     * @secure
     * @response `200` `Template` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newTemplate: (query: NewTemplateParams, data: TemplateIn, params: RequestParams = {}) =>
      this.http.request<Template, HTTPValidationError>({
        path: `/v2/Template`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Template Object Get
     *
     * @tags Template
     * @name GetTemplate
     * @summary Template Object Get
     * @request GET:/v2/Template/{item_id}
     * @secure
     * @response `200` `Template` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getTemplate: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Template, HTTPValidationError>({
        path: `/v2/Template/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Template Object Update
     *
     * @tags Template
     * @name UpdTemplate
     * @summary Template Object Update
     * @request PATCH:/v2/Template/{item_id}
     * @secure
     * @response `200` `Template` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updTemplate: (itemId: number | null, data: TemplateIn, params: RequestParams = {}) =>
      this.http.request<Template, HTTPValidationError>({
        path: `/v2/Template/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Template Object Delete
     *
     * @tags Template
     * @name DelTemplate
     * @summary Template Object Delete
     * @request DELETE:/v2/Template/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delTemplate: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Template/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  unitAmenityTranslation = {
    /**
     * @description Unitamenitytranslation Objects List
     *
     * @tags UnitAmenityTranslation
     * @name GetUnitAmenityTranslationList
     * @summary Unitamenitytranslation Objects List
     * @request POST:/v2/UnitAmenityTranslation
     * @secure
     * @response `200` `UnitAmenityTranslationList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitAmenityTranslationList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<UnitAmenityTranslationList, HTTPValidationError>({
        path: `/v2/UnitAmenityTranslation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitamenitytranslation Names List
     *
     * @tags UnitAmenityTranslation
     * @name GetUnitAmenityTranslationNamesList
     * @summary Unitamenitytranslation Names List
     * @request GET:/v2/UnitAmenityTranslation
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitAmenityTranslationNamesList: (query: GetUnitAmenityTranslationNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/UnitAmenityTranslation`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitamenitytranslation Object Create
     *
     * @tags UnitAmenityTranslation
     * @name NewUnitAmenityTranslation
     * @summary Unitamenitytranslation Object Create
     * @request PUT:/v2/UnitAmenityTranslation
     * @secure
     * @response `200` `UnitAmenityTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newUnitAmenityTranslation: (
      query: NewUnitAmenityTranslationParams,
      data: UnitAmenityTranslationIn,
      params: RequestParams = {},
    ) =>
      this.http.request<UnitAmenityTranslation, HTTPValidationError>({
        path: `/v2/UnitAmenityTranslation`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitamenitytranslation Object Get
     *
     * @tags UnitAmenityTranslation
     * @name GetUnitAmenityTranslation
     * @summary Unitamenitytranslation Object Get
     * @request GET:/v2/UnitAmenityTranslation/{item_id}
     * @secure
     * @response `200` `UnitAmenityTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitAmenityTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<UnitAmenityTranslation, HTTPValidationError>({
        path: `/v2/UnitAmenityTranslation/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitamenitytranslation Object Update
     *
     * @tags UnitAmenityTranslation
     * @name UpdUnitAmenityTranslation
     * @summary Unitamenitytranslation Object Update
     * @request PATCH:/v2/UnitAmenityTranslation/{item_id}
     * @secure
     * @response `200` `UnitAmenityTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updUnitAmenityTranslation: (itemId: number | null, data: UnitAmenityTranslationIn, params: RequestParams = {}) =>
      this.http.request<UnitAmenityTranslation, HTTPValidationError>({
        path: `/v2/UnitAmenityTranslation/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unitamenitytranslation Object Delete
     *
     * @tags UnitAmenityTranslation
     * @name DelUnitAmenityTranslation
     * @summary Unitamenitytranslation Object Delete
     * @request DELETE:/v2/UnitAmenityTranslation/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delUnitAmenityTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/UnitAmenityTranslation/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  resAmenityTranslation = {
    /**
     * @description Resamenitytranslation Objects List
     *
     * @tags ResAmenityTranslation
     * @name GetResAmenityTranslationList
     * @summary Resamenitytranslation Objects List
     * @request POST:/v2/ResAmenityTranslation
     * @secure
     * @response `200` `ResAmenityTranslationList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResAmenityTranslationList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<ResAmenityTranslationList, HTTPValidationError>({
        path: `/v2/ResAmenityTranslation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Resamenitytranslation Names List
     *
     * @tags ResAmenityTranslation
     * @name GetResAmenityTranslationNamesList
     * @summary Resamenitytranslation Names List
     * @request GET:/v2/ResAmenityTranslation
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResAmenityTranslationNamesList: (query: GetResAmenityTranslationNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/ResAmenityTranslation`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Resamenitytranslation Object Create
     *
     * @tags ResAmenityTranslation
     * @name NewResAmenityTranslation
     * @summary Resamenitytranslation Object Create
     * @request PUT:/v2/ResAmenityTranslation
     * @secure
     * @response `200` `ResAmenityTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newResAmenityTranslation: (
      query: NewResAmenityTranslationParams,
      data: ResAmenityTranslationIn,
      params: RequestParams = {},
    ) =>
      this.http.request<ResAmenityTranslation, HTTPValidationError>({
        path: `/v2/ResAmenityTranslation`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Resamenitytranslation Object Get
     *
     * @tags ResAmenityTranslation
     * @name GetResAmenityTranslation
     * @summary Resamenitytranslation Object Get
     * @request GET:/v2/ResAmenityTranslation/{item_id}
     * @secure
     * @response `200` `ResAmenityTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResAmenityTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<ResAmenityTranslation, HTTPValidationError>({
        path: `/v2/ResAmenityTranslation/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Resamenitytranslation Object Update
     *
     * @tags ResAmenityTranslation
     * @name UpdResAmenityTranslation
     * @summary Resamenitytranslation Object Update
     * @request PATCH:/v2/ResAmenityTranslation/{item_id}
     * @secure
     * @response `200` `ResAmenityTranslation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updResAmenityTranslation: (itemId: number | null, data: ResAmenityTranslationIn, params: RequestParams = {}) =>
      this.http.request<ResAmenityTranslation, HTTPValidationError>({
        path: `/v2/ResAmenityTranslation/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Resamenitytranslation Object Delete
     *
     * @tags ResAmenityTranslation
     * @name DelResAmenityTranslation
     * @summary Resamenitytranslation Object Delete
     * @request DELETE:/v2/ResAmenityTranslation/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delResAmenityTranslation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/ResAmenityTranslation/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  residentialPresentation = {
    /**
     * @description Residentialpresentation Objects List
     *
     * @tags ResidentialPresentation
     * @name GetResidentialPresentationList
     * @summary Residentialpresentation Objects List
     * @request POST:/v2/ResidentialPresentation
     * @secure
     * @response `200` `ResidentialPresentationList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialPresentationList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<ResidentialPresentationList, HTTPValidationError>({
        path: `/v2/ResidentialPresentation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialpresentation Names List
     *
     * @tags ResidentialPresentation
     * @name GetResidentialPresentationNamesList
     * @summary Residentialpresentation Names List
     * @request GET:/v2/ResidentialPresentation
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialPresentationNamesList: (
      query: GetResidentialPresentationNamesListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/ResidentialPresentation`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialpresentation Object Create
     *
     * @tags ResidentialPresentation
     * @name NewResidentialPresentation
     * @summary Residentialpresentation Object Create
     * @request PUT:/v2/ResidentialPresentation
     * @secure
     * @response `200` `ResidentialPresentation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newResidentialPresentation: (
      query: NewResidentialPresentationParams,
      data: ResidentialPresentationIn,
      params: RequestParams = {},
    ) =>
      this.http.request<ResidentialPresentation, HTTPValidationError>({
        path: `/v2/ResidentialPresentation`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialpresentation Object Get
     *
     * @tags ResidentialPresentation
     * @name GetResidentialPresentation
     * @summary Residentialpresentation Object Get
     * @request GET:/v2/ResidentialPresentation/{item_id}
     * @secure
     * @response `200` `ResidentialPresentation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialPresentation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<ResidentialPresentation, HTTPValidationError>({
        path: `/v2/ResidentialPresentation/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialpresentation Object Update
     *
     * @tags ResidentialPresentation
     * @name UpdResidentialPresentation
     * @summary Residentialpresentation Object Update
     * @request PATCH:/v2/ResidentialPresentation/{item_id}
     * @secure
     * @response `200` `ResidentialPresentation` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updResidentialPresentation: (itemId: number | null, data: ResidentialPresentationIn, params: RequestParams = {}) =>
      this.http.request<ResidentialPresentation, HTTPValidationError>({
        path: `/v2/ResidentialPresentation/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Residentialpresentation Object Delete
     *
     * @tags ResidentialPresentation
     * @name DelResidentialPresentation
     * @summary Residentialpresentation Object Delete
     * @request DELETE:/v2/ResidentialPresentation/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delResidentialPresentation: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/ResidentialPresentation/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  subscribers = {
    /**
     * @description Subscribers Objects List
     *
     * @tags Subscribers
     * @name GetSubscribersList
     * @summary Subscribers Objects List
     * @request POST:/v2/Subscribers
     * @secure
     * @response `200` `SubscribersList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getSubscribersList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<SubscribersList, HTTPValidationError>({
        path: `/v2/Subscribers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Subscribers Names List
     *
     * @tags Subscribers
     * @name GetSubscribersNamesList
     * @summary Subscribers Names List
     * @request GET:/v2/Subscribers
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getSubscribersNamesList: (query: GetSubscribersNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Subscribers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Subscribers Object Create
     *
     * @tags Subscribers
     * @name NewSubscribers
     * @summary Subscribers Object Create
     * @request PUT:/v2/Subscribers
     * @secure
     * @response `200` `Subscribers` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newSubscribers: (query: NewSubscribersParams, data: SubscribersIn, params: RequestParams = {}) =>
      this.http.request<Subscribers, HTTPValidationError>({
        path: `/v2/Subscribers`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Subscribers Object Get
     *
     * @tags Subscribers
     * @name GetSubscribers
     * @summary Subscribers Object Get
     * @request GET:/v2/Subscribers/{item_id}
     * @secure
     * @response `200` `Subscribers` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getSubscribers: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Subscribers, HTTPValidationError>({
        path: `/v2/Subscribers/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Subscribers Object Update
     *
     * @tags Subscribers
     * @name UpdSubscribers
     * @summary Subscribers Object Update
     * @request PATCH:/v2/Subscribers/{item_id}
     * @secure
     * @response `200` `Subscribers` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updSubscribers: (itemId: number | null, data: SubscribersIn, params: RequestParams = {}) =>
      this.http.request<Subscribers, HTTPValidationError>({
        path: `/v2/Subscribers/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Subscribers Object Delete
     *
     * @tags Subscribers
     * @name DelSubscribers
     * @summary Subscribers Object Delete
     * @request DELETE:/v2/Subscribers/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delSubscribers: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Subscribers/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  contact = {
    /**
     * @description Contact Objects List
     *
     * @tags Contact
     * @name GetContactList
     * @summary Contact Objects List
     * @request POST:/v2/Contact
     * @secure
     * @response `200` `ContactList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getContactList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<ContactList, HTTPValidationError>({
        path: `/v2/Contact`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Contact Names List
     *
     * @tags Contact
     * @name GetContactNamesList
     * @summary Contact Names List
     * @request GET:/v2/Contact
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getContactNamesList: (query: GetContactNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Contact`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Contact Object Create
     *
     * @tags Contact
     * @name NewContact
     * @summary Contact Object Create
     * @request PUT:/v2/Contact
     * @secure
     * @response `200` `Contact` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newContact: (query: NewContactParams, data: ContactIn, params: RequestParams = {}) =>
      this.http.request<Contact, HTTPValidationError>({
        path: `/v2/Contact`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Contact Object Get
     *
     * @tags Contact
     * @name GetContact
     * @summary Contact Object Get
     * @request GET:/v2/Contact/{item_id}
     * @secure
     * @response `200` `Contact` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getContact: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Contact, HTTPValidationError>({
        path: `/v2/Contact/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Contact Object Update
     *
     * @tags Contact
     * @name UpdContact
     * @summary Contact Object Update
     * @request PATCH:/v2/Contact/{item_id}
     * @secure
     * @response `200` `Contact` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updContact: (itemId: number | null, data: ContactIn, params: RequestParams = {}) =>
      this.http.request<Contact, HTTPValidationError>({
        path: `/v2/Contact/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Contact Object Delete
     *
     * @tags Contact
     * @name DelContact
     * @summary Contact Object Delete
     * @request DELETE:/v2/Contact/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delContact: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Contact/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Edit Contact
     *
     * @tags Contact
     * @name EditContactV2ContactEditIdPatch
     * @summary Edit Contact
     * @request PATCH:/v2/Contact/edit/{id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    editContactV2ContactEditIdPatch: (
      id: number,
      data: EditContactV2ContactEditIdPatchPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Contact/edit/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  landingForms = {
    /**
     * @description Landingforms Objects List
     *
     * @tags LandingForms
     * @name GetLandingFormsList
     * @summary Landingforms Objects List
     * @request POST:/v2/LandingForms
     * @secure
     * @response `200` `LandingFormsList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getLandingFormsList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<LandingFormsList, HTTPValidationError>({
        path: `/v2/LandingForms`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Landingforms Names List
     *
     * @tags LandingForms
     * @name GetLandingFormsNamesList
     * @summary Landingforms Names List
     * @request GET:/v2/LandingForms
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getLandingFormsNamesList: (query: GetLandingFormsNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/LandingForms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Landingforms Object Create
     *
     * @tags LandingForms
     * @name NewLandingForms
     * @summary Landingforms Object Create
     * @request PUT:/v2/LandingForms
     * @secure
     * @response `200` `LandingForms` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newLandingForms: (query: NewLandingFormsParams, data: LandingFormsIn, params: RequestParams = {}) =>
      this.http.request<LandingForms, HTTPValidationError>({
        path: `/v2/LandingForms`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Landingforms Object Get
     *
     * @tags LandingForms
     * @name GetLandingForms
     * @summary Landingforms Object Get
     * @request GET:/v2/LandingForms/{item_id}
     * @secure
     * @response `200` `LandingForms` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getLandingForms: (itemId: number, params: RequestParams = {}) =>
      this.http.request<LandingForms, HTTPValidationError>({
        path: `/v2/LandingForms/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Landingforms Object Update
     *
     * @tags LandingForms
     * @name UpdLandingForms
     * @summary Landingforms Object Update
     * @request PATCH:/v2/LandingForms/{item_id}
     * @secure
     * @response `200` `LandingForms` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updLandingForms: (itemId: number | null, data: LandingFormsIn, params: RequestParams = {}) =>
      this.http.request<LandingForms, HTTPValidationError>({
        path: `/v2/LandingForms/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Landingforms Object Delete
     *
     * @tags LandingForms
     * @name DelLandingForms
     * @summary Landingforms Object Delete
     * @request DELETE:/v2/LandingForms/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delLandingForms: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/LandingForms/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  user = {
    /**
     * @description User Objects List
     *
     * @tags User
     * @name GetUserList
     * @summary User Objects List
     * @request POST:/v2/User
     * @secure
     * @response `200` `UserList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUserList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<UserList, HTTPValidationError>({
        path: `/v2/User`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description User Names List
     *
     * @tags User
     * @name GetUserNamesList
     * @summary User Names List
     * @request GET:/v2/User
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUserNamesList: (query: GetUserNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/User`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description User Object Create
     *
     * @tags User
     * @name NewUser
     * @summary User Object Create
     * @request PUT:/v2/User
     * @secure
     * @response `200` `User` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newUser: (query: NewUserParams, data: UserIn, params: RequestParams = {}) =>
      this.http.request<User, HTTPValidationError>({
        path: `/v2/User`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description User Object Get
     *
     * @tags User
     * @name GetUser
     * @summary User Object Get
     * @request GET:/v2/User/{item_id}
     * @secure
     * @response `200` `User` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUser: (itemId: number, params: RequestParams = {}) =>
      this.http.request<User, HTTPValidationError>({
        path: `/v2/User/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description User Object Update
     *
     * @tags User
     * @name UpdUser
     * @summary User Object Update
     * @request PATCH:/v2/User/{item_id}
     * @secure
     * @response `200` `User` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updUser: (itemId: number | null, data: UserIn, params: RequestParams = {}) =>
      this.http.request<User, HTTPValidationError>({
        path: `/v2/User/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description User Object Delete
     *
     * @tags User
     * @name DelUser
     * @summary User Object Delete
     * @request DELETE:/v2/User/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delUser: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/User/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update User
     *
     * @tags User
     * @name UpdateUserEditUserUidPatch
     * @summary Update User
     * @request PATCH:/edit-user/{uid}
     * @secure
     * @response `200` `TortoiseContribPydanticCreatorAuthUserLeaf` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateUserEditUserUidPatch: (uid: number, data: UpdateUserBody, params: RequestParams = {}) =>
      this.http.request<TortoiseContribPydanticCreatorAuthUserLeaf, HTTPValidationError>({
        path: `/edit-user/${uid}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update Active User
     *
     * @tags User
     * @name UpdateActiveUserEditActiveUserUidPatch
     * @summary Update Active User
     * @request PATCH:/edit-active-user/{uid}
     * @secure
     * @response `200` `Token` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateActiveUserEditActiveUserUidPatch: (uid: number, data: UpdateUserBody, params: RequestParams = {}) =>
      this.http.request<Token, HTTPValidationError>({
        path: `/edit-active-user/${uid}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update User Photos
     *
     * @tags User
     * @name UpdateUserPhotosUserPhotoUploadTypeUidPost
     * @summary Update User Photos
     * @request POST:/User/photo_upload/{type}/{uid}
     * @response `200` `TortoiseContribPydanticCreatorAuthUserLeaf` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateUserPhotosUserPhotoUploadTypeUidPost: (
      uid: number,
      type: UserPhotoType,
      data: BodyUpdateUserPhotosUserPhotoUploadTypeUidPost,
      params: RequestParams = {},
    ) =>
      this.http.request<TortoiseContribPydanticCreatorAuthUserLeaf, HTTPValidationError>({
        path: `/User/photo_upload/${type}/${uid}`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get User Statuses
     *
     * @tags User
     * @name GetUserStatusesUserGetStatusesGet
     * @summary Get User Statuses
     * @request GET:/User/getStatuses
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUserStatusesUserGetStatusesGet: (query: GetUserStatusesUserGetStatusesGetParams, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/User/getStatuses`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get User By Slug
     *
     * @tags User
     * @name GetUserBySlugUserGetUserSlugGet
     * @summary Get User By Slug
     * @request GET:/User/get_user/{slug}
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUserBySlugUserGetUserSlugGet: (slug: string, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/User/get_user/${slug}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete User
     *
     * @tags User
     * @name DeleteUserUserDeleteUidDelete
     * @summary Delete User
     * @request DELETE:/User/delete/{uid}
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    deleteUserUserDeleteUidDelete: (uid: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/User/delete/${uid}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @description Is Slug Taken
     *
     * @tags User
     * @name IsSlugTakenUserCheckSlugSlugGet
     * @summary Is Slug Taken
     * @request GET:/User/check-slug/{slug}
     * @secure
     * @response `200` `boolean` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    isSlugTakenUserCheckSlugSlugGet: (slug: string, params: RequestParams = {}) =>
      this.http.request<boolean, HTTPValidationError>({
        path: `/User/check-slug/${slug}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create Default User Data
     *
     * @tags User
     * @name CreateDefaultUserDataUserCreateDefaultUserDataUidPost
     * @summary Create Default User Data
     * @request POST:/User/create_default_user_data/{uid}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    createDefaultUserDataUserCreateDefaultUserDataUidPost: (uid: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/User/create_default_user_data/${uid}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Mark Webinar As Watched
     *
     * @tags User
     * @name MarkWebinarAsWatchedUserWatchWebinarPost
     * @summary Mark Webinar As Watched
     * @request POST:/User/watch-webinar
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    markWebinarAsWatchedUserWatchWebinarPost: (data: WatchWebinarDto, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/User/watch-webinar`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unmark Webinar As Watched
     *
     * @tags User
     * @name UnmarkWebinarAsWatchedUserUnwatchWebinarPost
     * @summary Unmark Webinar As Watched
     * @request POST:/User/unwatch-webinar
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    unmarkWebinarAsWatchedUserUnwatchWebinarPost: (data: WatchWebinarDto, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/User/unwatch-webinar`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Set Personal Manager
     *
     * @tags User
     * @name SetPersonalManagerUserSetManagerPost
     * @summary Set Personal Manager
     * @request POST:/User/set-manager
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    setPersonalManagerUserSetManagerPost: (data: SetPersonalManagerDto, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/User/set-manager`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Change Default Personal Manager
     *
     * @tags User
     * @name ChangeDefaultPersonalManagerUserChangeDefaultManagerPost
     * @summary Change Default Personal Manager
     * @request POST:/User/change-default-manager
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    changeDefaultPersonalManagerUserChangeDefaultManagerPost: (
      data: ChangePersonalManagerDto,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/User/change-default-manager`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Default Manager
     *
     * @tags User
     * @name GetDefaultManagerUserGetDefaultManagerGet
     * @summary Get Default Manager
     * @request GET:/User/get-default-manager
     * @secure
     * @response `200` `any` Successful Response
     */
    getDefaultManagerUserGetDefaultManagerGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/User/get-default-manager`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  webinarTranslations = {
    /**
     * @description Webinartranslations Objects List
     *
     * @tags WebinarTranslations
     * @name GetWebinarTranslationsList
     * @summary Webinartranslations Objects List
     * @request POST:/v2/WebinarTranslations
     * @secure
     * @response `200` `WebinarTranslationsList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getWebinarTranslationsList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<WebinarTranslationsList, HTTPValidationError>({
        path: `/v2/WebinarTranslations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Webinartranslations Names List
     *
     * @tags WebinarTranslations
     * @name GetWebinarTranslationsNamesList
     * @summary Webinartranslations Names List
     * @request GET:/v2/WebinarTranslations
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getWebinarTranslationsNamesList: (query: GetWebinarTranslationsNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/WebinarTranslations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Webinartranslations Object Create
     *
     * @tags WebinarTranslations
     * @name NewWebinarTranslations
     * @summary Webinartranslations Object Create
     * @request PUT:/v2/WebinarTranslations
     * @secure
     * @response `200` `WebinarTranslations` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newWebinarTranslations: (
      query: NewWebinarTranslationsParams,
      data: WebinarTranslationsIn,
      params: RequestParams = {},
    ) =>
      this.http.request<WebinarTranslations, HTTPValidationError>({
        path: `/v2/WebinarTranslations`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Webinartranslations Object Get
     *
     * @tags WebinarTranslations
     * @name GetWebinarTranslations
     * @summary Webinartranslations Object Get
     * @request GET:/v2/WebinarTranslations/{item_id}
     * @secure
     * @response `200` `WebinarTranslations` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getWebinarTranslations: (itemId: number, params: RequestParams = {}) =>
      this.http.request<WebinarTranslations, HTTPValidationError>({
        path: `/v2/WebinarTranslations/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Webinartranslations Object Update
     *
     * @tags WebinarTranslations
     * @name UpdWebinarTranslations
     * @summary Webinartranslations Object Update
     * @request PATCH:/v2/WebinarTranslations/{item_id}
     * @secure
     * @response `200` `WebinarTranslations` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updWebinarTranslations: (itemId: number | null, data: WebinarTranslationsIn, params: RequestParams = {}) =>
      this.http.request<WebinarTranslations, HTTPValidationError>({
        path: `/v2/WebinarTranslations/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Webinartranslations Object Delete
     *
     * @tags WebinarTranslations
     * @name DelWebinarTranslations
     * @summary Webinartranslations Object Delete
     * @request DELETE:/v2/WebinarTranslations/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delWebinarTranslations: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/WebinarTranslations/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  promotion = {
    /**
     * @description Promotion Objects List
     *
     * @tags Promotion
     * @name GetPromotionList
     * @summary Promotion Objects List
     * @request POST:/v2/Promotion
     * @secure
     * @response `200` `PromotionList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getPromotionList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<PromotionList, HTTPValidationError>({
        path: `/v2/Promotion`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Promotion Names List
     *
     * @tags Promotion
     * @name GetPromotionNamesList
     * @summary Promotion Names List
     * @request GET:/v2/Promotion
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getPromotionNamesList: (query: GetPromotionNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Promotion`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Promotion Object Create
     *
     * @tags Promotion
     * @name NewPromotion
     * @summary Promotion Object Create
     * @request PUT:/v2/Promotion
     * @secure
     * @response `200` `Promotion` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newPromotion: (query: NewPromotionParams, data: PromotionIn, params: RequestParams = {}) =>
      this.http.request<Promotion, HTTPValidationError>({
        path: `/v2/Promotion`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Promotion Object Get
     *
     * @tags Promotion
     * @name GetPromotion
     * @summary Promotion Object Get
     * @request GET:/v2/Promotion/{item_id}
     * @secure
     * @response `200` `Promotion` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getPromotion: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Promotion, HTTPValidationError>({
        path: `/v2/Promotion/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Promotion Object Update
     *
     * @tags Promotion
     * @name UpdPromotion
     * @summary Promotion Object Update
     * @request PATCH:/v2/Promotion/{item_id}
     * @secure
     * @response `200` `Promotion` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updPromotion: (itemId: number | null, data: PromotionIn, params: RequestParams = {}) =>
      this.http.request<Promotion, HTTPValidationError>({
        path: `/v2/Promotion/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Promotion Object Delete
     *
     * @tags Promotion
     * @name DelPromotion
     * @summary Promotion Object Delete
     * @request DELETE:/v2/Promotion/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delPromotion: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Promotion/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Active Promotions
     *
     * @tags Promotion
     * @name GetActivePromotionsV2PromotionGetActivePost
     * @summary Get Active Promotions
     * @request POST:/v2/Promotion/get-active
     * @secure
     * @response `200` `any` Successful Response
     */
    getActivePromotionsV2PromotionGetActivePost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/v2/Promotion/get-active`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete Promotion
     *
     * @tags Promotion
     * @name DeletePromotionV2PromotionIdWithDependenciesDelete
     * @summary Delete Promotion
     * @request DELETE:/v2/Promotion/{id}/with-dependencies
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    deletePromotionV2PromotionIdWithDependenciesDelete: (id: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/Promotion/${id}/with-dependencies`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  building = {
    /**
     * @description Building Objects List
     *
     * @tags Building
     * @name GetBuildingList
     * @summary Building Objects List
     * @request POST:/v2/Building
     * @secure
     * @response `200` `BuildingList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getBuildingList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<BuildingList, HTTPValidationError>({
        path: `/v2/Building`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Building Names List
     *
     * @tags Building
     * @name GetBuildingNamesList
     * @summary Building Names List
     * @request GET:/v2/Building
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getBuildingNamesList: (query: GetBuildingNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Building`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Building Object Create
     *
     * @tags Building
     * @name NewBuilding
     * @summary Building Object Create
     * @request PUT:/v2/Building
     * @secure
     * @response `200` `Building` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newBuilding: (query: NewBuildingParams, data: BuildingIn, params: RequestParams = {}) =>
      this.http.request<Building, HTTPValidationError>({
        path: `/v2/Building`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Building Object Get
     *
     * @tags Building
     * @name GetBuilding
     * @summary Building Object Get
     * @request GET:/v2/Building/{item_id}
     * @secure
     * @response `200` `Building` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getBuilding: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Building, HTTPValidationError>({
        path: `/v2/Building/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Building Object Update
     *
     * @tags Building
     * @name UpdBuilding
     * @summary Building Object Update
     * @request PATCH:/v2/Building/{item_id}
     * @secure
     * @response `200` `Building` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updBuilding: (itemId: number | null, data: BuildingIn, params: RequestParams = {}) =>
      this.http.request<Building, HTTPValidationError>({
        path: `/v2/Building/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Building Object Delete
     *
     * @tags Building
     * @name DelBuilding
     * @summary Building Object Delete
     * @request DELETE:/v2/Building/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delBuilding: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Building/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  emailsLog = {
    /**
     * @description Emailslog Objects List
     *
     * @tags EmailsLog
     * @name GetEmailsLogList
     * @summary Emailslog Objects List
     * @request POST:/v2/EmailsLog
     * @secure
     * @response `200` `EmailsLogList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getEmailsLogList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<EmailsLogList, HTTPValidationError>({
        path: `/v2/EmailsLog`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Emailslog Names List
     *
     * @tags EmailsLog
     * @name GetEmailsLogNamesList
     * @summary Emailslog Names List
     * @request GET:/v2/EmailsLog
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getEmailsLogNamesList: (query: GetEmailsLogNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/EmailsLog`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Emailslog Object Create
     *
     * @tags EmailsLog
     * @name NewEmailsLog
     * @summary Emailslog Object Create
     * @request PUT:/v2/EmailsLog
     * @secure
     * @response `200` `EmailsLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newEmailsLog: (query: NewEmailsLogParams, data: EmailsLogIn, params: RequestParams = {}) =>
      this.http.request<EmailsLog, HTTPValidationError>({
        path: `/v2/EmailsLog`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Emailslog Object Get
     *
     * @tags EmailsLog
     * @name GetEmailsLog
     * @summary Emailslog Object Get
     * @request GET:/v2/EmailsLog/{item_id}
     * @secure
     * @response `200` `EmailsLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getEmailsLog: (itemId: number, params: RequestParams = {}) =>
      this.http.request<EmailsLog, HTTPValidationError>({
        path: `/v2/EmailsLog/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Emailslog Object Update
     *
     * @tags EmailsLog
     * @name UpdEmailsLog
     * @summary Emailslog Object Update
     * @request PATCH:/v2/EmailsLog/{item_id}
     * @secure
     * @response `200` `EmailsLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updEmailsLog: (itemId: number | null, data: EmailsLogIn, params: RequestParams = {}) =>
      this.http.request<EmailsLog, HTTPValidationError>({
        path: `/v2/EmailsLog/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Emailslog Object Delete
     *
     * @tags EmailsLog
     * @name DelEmailsLog
     * @summary Emailslog Object Delete
     * @request DELETE:/v2/EmailsLog/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delEmailsLog: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/EmailsLog/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  order = {
    /**
     * @description Order Objects List
     *
     * @tags Order
     * @name GetOrderList
     * @summary Order Objects List
     * @request POST:/v2/Order
     * @secure
     * @response `200` `OrderList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getOrderList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<OrderList, HTTPValidationError>({
        path: `/v2/Order`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Order Names List
     *
     * @tags Order
     * @name GetOrderNamesList
     * @summary Order Names List
     * @request GET:/v2/Order
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getOrderNamesList: (query: GetOrderNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Order`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Order Object Create
     *
     * @tags Order
     * @name NewOrder
     * @summary Order Object Create
     * @request PUT:/v2/Order
     * @secure
     * @response `200` `Order` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newOrder: (query: NewOrderParams, data: OrderIn, params: RequestParams = {}) =>
      this.http.request<Order, HTTPValidationError>({
        path: `/v2/Order`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Order Object Get
     *
     * @tags Order
     * @name GetOrder
     * @summary Order Object Get
     * @request GET:/v2/Order/{item_id}
     * @secure
     * @response `200` `Order` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getOrder: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Order, HTTPValidationError>({
        path: `/v2/Order/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Order Object Update
     *
     * @tags Order
     * @name UpdOrder
     * @summary Order Object Update
     * @request PATCH:/v2/Order/{item_id}
     * @secure
     * @response `200` `Order` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updOrder: (itemId: number | null, data: OrderIn, params: RequestParams = {}) =>
      this.http.request<Order, HTTPValidationError>({
        path: `/v2/Order/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Order Object Delete
     *
     * @tags Order
     * @name DelOrder
     * @summary Order Object Delete
     * @request DELETE:/v2/Order/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delOrder: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Order/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Clients
     *
     * @tags Order
     * @name GetClientsV2ClientsPost
     * @summary Get Clients
     * @request POST:/v2/Clients
     * @secure
     * @response `200` `ContactList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getClientsV2ClientsPost: (data: GetClientsV2ClientsPostPayload, params: RequestParams = {}) =>
      this.http.request<ContactList, HTTPValidationError>({
        path: `/v2/Clients`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  notificationLog = {
    /**
     * @description Notificationlog Objects List
     *
     * @tags NotificationLog
     * @name GetNotificationLogList
     * @summary Notificationlog Objects List
     * @request POST:/v2/NotificationLog
     * @secure
     * @response `200` `NotificationLogList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getNotificationLogList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<NotificationLogList, HTTPValidationError>({
        path: `/v2/NotificationLog`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Notificationlog Names List
     *
     * @tags NotificationLog
     * @name GetNotificationLogNamesList
     * @summary Notificationlog Names List
     * @request GET:/v2/NotificationLog
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getNotificationLogNamesList: (query: GetNotificationLogNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/NotificationLog`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Notificationlog Object Create
     *
     * @tags NotificationLog
     * @name NewNotificationLog
     * @summary Notificationlog Object Create
     * @request PUT:/v2/NotificationLog
     * @secure
     * @response `200` `NotificationLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newNotificationLog: (query: NewNotificationLogParams, data: NotificationLogIn, params: RequestParams = {}) =>
      this.http.request<NotificationLog, HTTPValidationError>({
        path: `/v2/NotificationLog`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Notificationlog Object Get
     *
     * @tags NotificationLog
     * @name GetNotificationLog
     * @summary Notificationlog Object Get
     * @request GET:/v2/NotificationLog/{item_id}
     * @secure
     * @response `200` `NotificationLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getNotificationLog: (itemId: number, params: RequestParams = {}) =>
      this.http.request<NotificationLog, HTTPValidationError>({
        path: `/v2/NotificationLog/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Notificationlog Object Update
     *
     * @tags NotificationLog
     * @name UpdNotificationLog
     * @summary Notificationlog Object Update
     * @request PATCH:/v2/NotificationLog/{item_id}
     * @secure
     * @response `200` `NotificationLog` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updNotificationLog: (itemId: number | null, data: NotificationLogIn, params: RequestParams = {}) =>
      this.http.request<NotificationLog, HTTPValidationError>({
        path: `/v2/NotificationLog/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Notificationlog Object Delete
     *
     * @tags NotificationLog
     * @name DelNotificationLog
     * @summary Notificationlog Object Delete
     * @request DELETE:/v2/NotificationLog/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delNotificationLog: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/NotificationLog/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Read Notifications
     *
     * @tags NotificationLog
     * @name ReadNotificationsV2NotificationLogReadNotificationsPost
     * @summary Read Notifications
     * @request POST:/v2/NotificationLog/read_notifications
     * @secure
     * @response `200` `Record<string,(number | string)>` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    readNotificationsV2NotificationLogReadNotificationsPost: (data: ReadNotificationsDto, params: RequestParams = {}) =>
      this.http.request<Record<string, number | string>, HTTPValidationError>({
        path: `/v2/NotificationLog/read_notifications`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create Public Notifications
     *
     * @tags NotificationLog
     * @name CreatePublicNotificationsV2NotificationLogPublicPut
     * @summary Create Public Notifications
     * @request PUT:/v2/NotificationLog/public
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    createPublicNotificationsV2NotificationLogPublicPut: (
      data: CreatePublicNotificationsV2NotificationLogPublicPutPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/NotificationLog/public`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create Ld Notification
     *
     * @tags NotificationLog
     * @name CreateLdNotificationV2NotificationLogPublicLdPut
     * @summary Create Ld Notification
     * @request PUT:/v2/NotificationLog/public/ld
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    createLdNotificationV2NotificationLogPublicLdPut: (
      data: CreateLdNotificationV2NotificationLogPublicLdPutPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/NotificationLog/public/ld`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Edit Notification
     *
     * @tags NotificationLog
     * @name EditNotificationV2NotificationLogEditIdPatch
     * @summary Edit Notification
     * @request PATCH:/v2/NotificationLog/edit/{id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    editNotificationV2NotificationLogEditIdPatch: (
      id: number,
      data: EditNotificationV2NotificationLogEditIdPatchPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/NotificationLog/edit/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  landingData = {
    /**
     * @description Landingdata Objects List
     *
     * @tags LandingData
     * @name GetLandingDataList
     * @summary Landingdata Objects List
     * @request POST:/v2/LandingData
     * @secure
     * @response `200` `LandingDataList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getLandingDataList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<LandingDataList, HTTPValidationError>({
        path: `/v2/LandingData`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Landingdata Names List
     *
     * @tags LandingData
     * @name GetLandingDataNamesList
     * @summary Landingdata Names List
     * @request GET:/v2/LandingData
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getLandingDataNamesList: (query: GetLandingDataNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/LandingData`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Landingdata Object Create
     *
     * @tags LandingData
     * @name NewLandingData
     * @summary Landingdata Object Create
     * @request PUT:/v2/LandingData
     * @secure
     * @response `200` `LandingData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newLandingData: (query: NewLandingDataParams, data: LandingDataIn, params: RequestParams = {}) =>
      this.http.request<LandingData, HTTPValidationError>({
        path: `/v2/LandingData`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Landingdata Object Get
     *
     * @tags LandingData
     * @name GetLandingData
     * @summary Landingdata Object Get
     * @request GET:/v2/LandingData/{item_id}
     * @secure
     * @response `200` `LandingData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getLandingData: (itemId: number, params: RequestParams = {}) =>
      this.http.request<LandingData, HTTPValidationError>({
        path: `/v2/LandingData/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Landingdata Object Update
     *
     * @tags LandingData
     * @name UpdLandingData
     * @summary Landingdata Object Update
     * @request PATCH:/v2/LandingData/{item_id}
     * @secure
     * @response `200` `LandingData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updLandingData: (itemId: number | null, data: LandingDataIn, params: RequestParams = {}) =>
      this.http.request<LandingData, HTTPValidationError>({
        path: `/v2/LandingData/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Landingdata Object Delete
     *
     * @tags LandingData
     * @name DelLandingData
     * @summary Landingdata Object Delete
     * @request DELETE:/v2/LandingData/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delLandingData: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/LandingData/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Landing Data By Slug
     *
     * @tags LandingData
     * @name GetLandingDataBySlugV2LandingDataGetBySlugSlugGet
     * @summary Get Landing Data By Slug
     * @request GET:/v2/LandingData/get_by_slug/{slug}
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getLandingDataBySlugV2LandingDataGetBySlugSlugGet: (slug: string, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/LandingData/get_by_slug/${slug}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Set Default Landing Data
     *
     * @tags LandingData
     * @name SetDefaultLandingDataV2LandingDataSetLandingDataUidPost
     * @summary Set Default Landing Data
     * @request POST:/v2/LandingData/set_landing_data/{uid}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    setDefaultLandingDataV2LandingDataSetLandingDataUidPost: (uid: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/LandingData/set_landing_data/${uid}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Edit Landing Data
     *
     * @tags LandingData
     * @name EditLandingDataV2LandingDataEditIdPatch
     * @summary Edit Landing Data
     * @request PATCH:/v2/LandingData/edit/{id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    editLandingDataV2LandingDataEditIdPatch: (
      id: number,
      data: EditLandingDataV2LandingDataEditIdPatchPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/LandingData/edit/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Ld Views
     *
     * @tags LandingData
     * @name GetLdViewsV2LandingDataViewsUserIdPost
     * @summary Get Ld Views
     * @request POST:/v2/LandingData/views/{user_id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getLdViewsV2LandingDataViewsUserIdPost: (userId: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/LandingData/views/${userId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Publish Ld
     *
     * @tags LandingData
     * @name PublishLdV2LandingDataPublishIdPost
     * @summary Publish Ld
     * @request POST:/v2/LandingData/publish/{id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    publishLdV2LandingDataPublishIdPost: (
      id: number,
      data: PublishLdV2LandingDataPublishIdPostPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/LandingData/publish/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  offer = {
    /**
     * @description Offer Objects List
     *
     * @tags Offer
     * @name GetOfferList
     * @summary Offer Objects List
     * @request POST:/v2/Offer
     * @secure
     * @response `200` `OfferList` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getOfferList: (data: ListArgs, params: RequestParams = {}) =>
      this.http.request<OfferList, HTTPValidationError>({
        path: `/v2/Offer`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Offer Names List
     *
     * @tags Offer
     * @name GetOfferNamesList
     * @summary Offer Names List
     * @request GET:/v2/Offer
     * @secure
     * @response `200` `Names` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getOfferNamesList: (query: GetOfferNamesListParams, params: RequestParams = {}) =>
      this.http.request<Names, HTTPValidationError>({
        path: `/v2/Offer`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Offer Object Create
     *
     * @tags Offer
     * @name NewOffer
     * @summary Offer Object Create
     * @request PUT:/v2/Offer
     * @secure
     * @response `200` `Offer` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    newOffer: (query: NewOfferParams, data: OfferIn, params: RequestParams = {}) =>
      this.http.request<Offer, HTTPValidationError>({
        path: `/v2/Offer`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Offer Object Get
     *
     * @tags Offer
     * @name GetOffer
     * @summary Offer Object Get
     * @request GET:/v2/Offer/{item_id}
     * @secure
     * @response `200` `Offer` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getOffer: (itemId: number, params: RequestParams = {}) =>
      this.http.request<Offer, HTTPValidationError>({
        path: `/v2/Offer/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Offer Object Update
     *
     * @tags Offer
     * @name UpdOffer
     * @summary Offer Object Update
     * @request PATCH:/v2/Offer/{item_id}
     * @secure
     * @response `200` `Offer` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updOffer: (itemId: number | null, data: OfferIn, params: RequestParams = {}) =>
      this.http.request<Offer, HTTPValidationError>({
        path: `/v2/Offer/${itemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Offer Object Delete
     *
     * @tags Offer
     * @name DelOffer
     * @summary Offer Object Delete
     * @request DELETE:/v2/Offer/{item_id}
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    delOffer: (itemId: number, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Offer/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Offers
     *
     * @tags Offer
     * @name GetOffersGetOffersGet
     * @summary Get Offers
     * @request GET:/get_offers
     * @response `200` `OfferList` Successful Response
     */
    getOffersGetOffersGet: (params: RequestParams = {}) =>
      this.http.request<OfferList, any>({
        path: `/get_offers`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  googleApi = {
    /**
     * @description Get Addr Opts
     *
     * @tags google-api
     * @name GetAddrOptsGapiAddrOptsGet
     * @summary Get Addr Opts
     * @request GET:/gapi/addr-opts
     * @secure
     * @response `200` `AddressSuggestions` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAddrOptsGapiAddrOptsGet: (query: GetAddrOptsGapiAddrOptsGetParams, params: RequestParams = {}) =>
      this.http.request<AddressSuggestions, HTTPValidationError>({
        path: `/gapi/addr-opts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Addr
     *
     * @tags google-api
     * @name GetAddrGapiAddrGidGet
     * @summary Get Addr
     * @request GET:/gapi/addr/{gid}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAddrGapiAddrGidGet: (gid: string, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/gapi/addr/${gid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  photoModule = {
    /**
     * @description Photos Upload
     *
     * @tags photo-module
     * @name PhotosUploadPhotoPost
     * @summary Photos Upload
     * @request POST:/photo
     * @secure
     * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    photosUploadPhotoPost: (
      query: PhotosUploadPhotoPostParams,
      data: BodyPhotosUploadPhotoPost,
      params: RequestParams = {},
    ) =>
      this.http.request<TortoiseContribPydanticCreatorModelsPhotoLeaf, HTTPValidationError>({
        path: `/photo`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Photos Sort
     *
     * @tags photo-module
     * @name PhotosSortPhotoSortPost
     * @summary Photos Sort
     * @request POST:/photo/sort/
     * @secure
     * @response `200` `boolean` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    photosSortPhotoSortPost: (data: PhotosSortPhotoSortPostPayload, params: RequestParams = {}) =>
      this.http.request<boolean, HTTPValidationError>({
        path: `/photo/sort/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Social Photos Sort
     *
     * @tags photo-module
     * @name SocialPhotosSortPhotoSocialSortPost
     * @summary Social Photos Sort
     * @request POST:/photo/social/sort/
     * @secure
     * @response `200` `boolean` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    socialPhotosSortPhotoSocialSortPost: (
      data: SocialPhotosSortPhotoSocialSortPostPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<boolean, HTTPValidationError>({
        path: `/photo/social/sort/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Photo Upd
     *
     * @tags photo-module
     * @name PhotoUpdPhotoItemIdPost
     * @summary Photo Upd
     * @request POST:/photo/{item_id}
     * @secure
     * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    photoUpdPhotoItemIdPost: ({ itemId, ...query }: PhotoUpdPhotoItemIdPostParams, params: RequestParams = {}) =>
      this.http.request<TortoiseContribPydanticCreatorModelsPhotoLeaf, HTTPValidationError>({
        path: `/photo/${itemId}`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Photo Get
     *
     * @tags photo-module
     * @name PhotoGetPhotoItemIdGet
     * @summary Photo Get
     * @request GET:/photo/{item_id}
     * @secure
     * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    photoGetPhotoItemIdGet: (itemId: number, params: RequestParams = {}) =>
      this.http.request<TortoiseContribPydanticCreatorModelsPhotoLeaf, HTTPValidationError>({
        path: `/photo/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Photo Del
     *
     * @tags photo-module
     * @name PhotoDelPhotoItemIdDelete
     * @summary Photo Del
     * @request DELETE:/photo/{item_id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    photoDelPhotoItemIdDelete: (itemId: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/photo/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Photo Edit Polygon
     *
     * @tags photo-module
     * @name PhotoEditPolygonPhotoItemIdPolygonPatch
     * @summary Photo Edit Polygon
     * @request PATCH:/photo/{item_id}/polygon
     * @secure
     * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    photoEditPolygonPhotoItemIdPolygonPatch: (
      itemId: number,
      data: PhotoEditPolygonPhotoItemIdPolygonPatchPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<TortoiseContribPydanticCreatorModelsPhotoLeaf, HTTPValidationError>({
        path: `/photo/${itemId}/polygon`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Social Photo Upd
     *
     * @tags photo-module
     * @name SocialPhotoUpdPhotoSocialItemIdPost
     * @summary Social Photo Upd
     * @request POST:/photo/social/{item_id}
     * @secure
     * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    socialPhotoUpdPhotoSocialItemIdPost: (
      { itemId, ...query }: SocialPhotoUpdPhotoSocialItemIdPostParams,
      params: RequestParams = {},
    ) =>
      this.http.request<TortoiseContribPydanticCreatorModelsPhotoLeaf, HTTPValidationError>({
        path: `/photo/social/${itemId}`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Social Photo Get
     *
     * @tags photo-module
     * @name SocialPhotoGetPhotoSocialItemIdGet
     * @summary Social Photo Get
     * @request GET:/photo/social/{item_id}
     * @secure
     * @response `200` `TortoiseContribPydanticCreatorModelsPhotoLeaf` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    socialPhotoGetPhotoSocialItemIdGet: (itemId: number, params: RequestParams = {}) =>
      this.http.request<TortoiseContribPydanticCreatorModelsPhotoLeaf, HTTPValidationError>({
        path: `/photo/social/${itemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Social Photo Del
     *
     * @tags photo-module
     * @name SocialPhotoDelPhotoSocialItemIdDelete
     * @summary Social Photo Del
     * @request DELETE:/photo/social/{item_id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    socialPhotoDelPhotoSocialItemIdDelete: (itemId: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/photo/social/${itemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete Photos
     *
     * @tags photo-module
     * @name DeletePhotosPhotoAllPhotosDeleteDelete
     * @summary Delete Photos
     * @request DELETE:/photo/all_photos/delete
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    deletePhotosPhotoAllPhotosDeleteDelete: (data: DeletePhotosDto, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/photo/all_photos/delete`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Bytes
     *
     * @tags photo-module
     * @name GetBytesPhotoBytesItemIdGet
     * @summary Get Bytes
     * @request GET:/photo/bytes/{item_id}
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getBytesPhotoBytesItemIdGet: (itemId: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/photo/bytes/${itemId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Social Get Bytes
     *
     * @tags photo-module
     * @name SocialGetBytesPhotoSocialBytesItemIdGet
     * @summary Social Get Bytes
     * @request GET:/photo/social/bytes/{item_id}
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    socialGetBytesPhotoSocialBytesItemIdGet: (itemId: number, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/photo/social/bytes/${itemId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Order File Upload
     *
     * @tags photo-module
     * @name OrderFileUploadPhotoOrderOidPhotoUploadPost
     * @summary Order File Upload
     * @request POST:/photo/Order/{oid}/photo_upload
     * @response `200` `string` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    orderFileUploadPhotoOrderOidPhotoUploadPost: (
      oid: number,
      data: BodyOrderFileUploadPhotoOrderOidPhotoUploadPost,
      params: RequestParams = {},
    ) =>
      this.http.request<string, HTTPValidationError>({
        path: `/photo/Order/${oid}/photo_upload`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Add Amenity Photo
     *
     * @tags photo-module
     * @name AddAmenityPhotoPhotoAmenityOidPost
     * @summary Add Amenity Photo
     * @request POST:/photo/Amenity/{oid}
     * @response `200` `string` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    addAmenityPhotoPhotoAmenityOidPost: (
      oid: number,
      data: BodyAddAmenityPhotoPhotoAmenityOidPost,
      params: RequestParams = {},
    ) =>
      this.http.request<string, HTTPValidationError>({
        path: `/photo/Amenity/${oid}`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Webinar Photo Update
     *
     * @tags photo-module
     * @name WebinarPhotoUpdatePhotoWebinarIdPost
     * @summary Webinar Photo Update
     * @request POST:/photo/Webinar/{id}
     * @response `200` `string` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    webinarPhotoUpdatePhotoWebinarIdPost: (
      id: number,
      data: BodyWebinarPhotoUpdatePhotoWebinarIdPost,
      params: RequestParams = {},
    ) =>
      this.http.request<string, HTTPValidationError>({
        path: `/photo/Webinar/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Promotion Photo Update
     *
     * @tags photo-module
     * @name PromotionPhotoUpdatePhotoPromotionIdPost
     * @summary Promotion Photo Update
     * @request POST:/photo/Promotion/{id}
     * @secure
     * @response `200` `string` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    promotionPhotoUpdatePhotoPromotionIdPost: (
      id: number,
      data: BodyPromotionPhotoUpdatePhotoPromotionIdPost,
      params: RequestParams = {},
    ) =>
      this.http.request<string, HTTPValidationError>({
        path: `/photo/Promotion/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  }
  presentation = {
    /**
     * @description Get Unit Presentation
     *
     * @tags presentation
     * @name GetUnitPresentationPresentationUnitPost
     * @summary Get Unit Presentation
     * @request POST:/presentation/unit
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitPresentationPresentationUnitPost: (data: UnitPresentBody, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/presentation/unit`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update Units Order
     *
     * @tags presentation
     * @name UpdateUnitsOrderPresentationUnitUpdateOrderPut
     * @summary Update Units Order
     * @request PUT:/presentation/unit/update_order
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateUnitsOrderPresentationUnitUpdateOrderPut: (data: UpdateUnitsOrderDto, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/presentation/unit/update_order`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update Agent Comment
     *
     * @tags presentation
     * @name UpdateAgentCommentPresentationUnitUpdateAgentCommentPut
     * @summary Update Agent Comment
     * @request PUT:/presentation/unit/update_agent_comment
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateAgentCommentPresentationUnitUpdateAgentCommentPut: (data: AddAgentCommentDto, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/presentation/unit/update_agent_comment`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update Client Likes
     *
     * @tags presentation
     * @name UpdateClientLikesPresentationUnitUpdateLikesPut
     * @summary Update Client Likes
     * @request PUT:/presentation/unit/update_likes
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateClientLikesPresentationUnitUpdateLikesPut: (data: LikeDto, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/presentation/unit/update_likes`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get All Units
     *
     * @tags presentation
     * @name GetAllUnitsPresentationAllUnitsPost
     * @summary Get All Units
     * @request POST:/presentation/all_units
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAllUnitsPresentationAllUnitsPost: (
      data: GetAllUnitsPresentationAllUnitsPostPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<object, HTTPValidationError>({
        path: `/presentation/all_units`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Res Presentation
     *
     * @tags presentation
     * @name GetResPresentationPresentationResidentialPost
     * @summary Get Res Presentation
     * @request POST:/presentation/residential
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResPresentationPresentationResidentialPost: (data: ResPresentBody, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/presentation/residential`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Residential Pres
     *
     * @tags presentation
     * @name GetResidentialPresPresentationGetResidentialsPost
     * @summary Get Residential Pres
     * @request POST:/presentation/get_residentials
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getResidentialPresPresentationGetResidentialsPost: (
      data: GetResidentialPresPresentationGetResidentialsPostPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<object, HTTPValidationError>({
        path: `/presentation/get_residentials`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Unit Pres
     *
     * @tags presentation
     * @name GetUnitPresPresentationGetUnitsPost
     * @summary Get Unit Pres
     * @request POST:/presentation/get_units
     * @secure
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getUnitPresPresentationGetUnitsPost: (
      data: GetUnitPresPresentationGetUnitsPostPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<object, HTTPValidationError>({
        path: `/presentation/get_units`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  translations = {
    /**
     * @description Add Translation
     *
     * @tags Translations
     * @name AddTranslationTranslationAddPost
     * @summary Add Translation
     * @request POST:/translation/add
     * @secure
     * @response `200` `string` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    addTranslationTranslationAddPost: (data: TranslationBody, params: RequestParams = {}) =>
      this.http.request<string, HTTPValidationError>({
        path: `/translation/add`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Edit Translation
     *
     * @tags Translations
     * @name EditTranslationTranslationEditPatch
     * @summary Edit Translation
     * @request PATCH:/translation/edit
     * @secure
     * @response `200` `string` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    editTranslationTranslationEditPatch: (data: TranslationBody, params: RequestParams = {}) =>
      this.http.request<string, HTTPValidationError>({
        path: `/translation/edit`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  platformServiceFee = {
    /**
     * @description Get Platform Service Fee
     *
     * @tags Platform Service Fee
     * @name GetPlatformServiceFeeV2GetPlatformServiceFeeGet
     * @summary Get Platform Service Fee
     * @request GET:/v2/get_platform_service_fee
     * @secure
     * @response `200` `(FeeResponse | ErrorResponse)` Successful Response
     */
    getPlatformServiceFeeV2GetPlatformServiceFeeGet: (params: RequestParams = {}) =>
      this.http.request<FeeResponse | ErrorResponse, any>({
        path: `/v2/get_platform_service_fee`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update Service Fee
     *
     * @tags Platform Service Fee
     * @name UpdateServiceFeeV2UpdateServiceFeeNewFeePost
     * @summary Update Service Fee
     * @request POST:/v2/update_service_fee/{new_fee}
     * @secure
     * @response `200` `(UpdateFeeResponse | ErrorResponse)` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateServiceFeeV2UpdateServiceFeeNewFeePost: (newFee: number, params: RequestParams = {}) =>
      this.http.request<UpdateFeeResponse | ErrorResponse, HTTPValidationError>({
        path: `/v2/update_service_fee/${newFee}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create Service Fee File
     *
     * @tags Platform Service Fee
     * @name CreateServiceFeeFileV2CreateServiceFeePost
     * @summary Create Service Fee File
     * @request POST:/v2/create_service_fee
     * @secure
     * @response `200` `any` Successful Response
     */
    createServiceFeeFileV2CreateServiceFeePost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/v2/create_service_fee`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  utils = {
    /**
     * @description Fill Unique Units Hash
     *
     * @tags Utils
     * @name FillUniqueUnitsHashGenUnitsHashPost
     * @summary Fill Unique Units Hash
     * @request POST:/gen-units-hash
     * @secure
     * @response `200` `any` Successful Response
     */
    fillUniqueUnitsHashGenUnitsHashPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/gen-units-hash`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fill Unique Residential Hash
     *
     * @tags Utils
     * @name FillUniqueResidentialHashGenResidentialHashPost
     * @summary Fill Unique Residential Hash
     * @request POST:/gen-residential-hash
     * @secure
     * @response `200` `any` Successful Response
     */
    fillUniqueResidentialHashGenResidentialHashPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/gen-residential-hash`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fill Unique User Hash
     *
     * @tags Utils
     * @name FillUniqueUserHashGenUserHashPost
     * @summary Fill Unique User Hash
     * @request POST:/gen-user-hash
     * @secure
     * @response `200` `any` Successful Response
     */
    fillUniqueUserHashGenUserHashPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/gen-user-hash`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Statistics Data
     *
     * @tags Utils
     * @name GetStatisticsDataGetDashboardPost
     * @summary Get Statistics Data
     * @request POST:/get-dashboard
     * @secure
     * @response `200` `MetricsResponse` Successful Response
     */
    getStatisticsDataGetDashboardPost: (params: RequestParams = {}) =>
      this.http.request<MetricsResponse, any>({
        path: `/get-dashboard`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Generate Missing Social Photos
     *
     * @tags Utils
     * @name GenerateMissingSocialPhotosFixSocialPost
     * @summary Generate Missing Social Photos
     * @request POST:/fix-social
     * @secure
     * @response `200` `any` Successful Response
     */
    generateMissingSocialPhotosFixSocialPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/fix-social`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create Landing Data For All Users
     *
     * @tags Utils
     * @name CreateLandingDataForAllUsersFillLandingDataPost
     * @summary Create Landing Data For All Users
     * @request POST:/fill-landing-data
     * @secure
     * @response `200` `any` Successful Response
     */
    createLandingDataForAllUsersFillLandingDataPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/fill-landing-data`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Upd User Statuses Sendpulse
     *
     * @tags Utils
     * @name UpdUserStatusesSendpulseUpdSpStatusesPost
     * @summary Upd User Statuses Sendpulse
     * @request POST:/upd-sp-statuses
     * @secure
     * @response `200` `any` Successful Response
     */
    updUserStatusesSendpulseUpdSpStatusesPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/upd-sp-statuses`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Deal
     *
     * @tags Utils
     * @name GetDealGetDealIdPost
     * @summary Get Deal
     * @request POST:/get_deal/{id}
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getDealGetDealIdPost: (id: any, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/get_deal/${id}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @description Check Deal
     *
     * @tags Utils
     * @name CheckDealCheckDealEmailPost
     * @summary Check Deal
     * @request POST:/check_deal/{email}
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    checkDealCheckDealEmailPost: (email: any, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/check_deal/${email}`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Attrs
     *
     * @tags Utils
     * @name GetAttrsGetAttrsPost
     * @summary Get Attrs
     * @request POST:/get_attrs
     * @response `200` `any` Successful Response
     */
    getAttrsGetAttrsPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/get_attrs`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update Users Deals Id
     *
     * @tags Utils
     * @name UpdateUsersDealsIdUpdateUsersDealsIdPost
     * @summary Update Users Deals Id
     * @request POST:/update_users_deals_id
     * @response `200` `any` Successful Response
     */
    updateUsersDealsIdUpdateUsersDealsIdPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/update_users_deals_id`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @description Sync Deal Responsibles
     *
     * @tags Utils
     * @name SyncDealResponsiblesUpdateManagersCrmPost
     * @summary Sync Deal Responsibles
     * @request POST:/update-managers-crm
     * @response `200` `any` Successful Response
     */
    syncDealResponsiblesUpdateManagersCrmPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/update-managers-crm`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  }
  forms = {
    /**
     * @description Send Feedback Form
     *
     * @tags Forms
     * @name SendFeedbackFormV2FormsFeedbackPost
     * @summary Send Feedback Form
     * @request POST:/v2/forms/feedback
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    sendFeedbackFormV2FormsFeedbackPost: (data: FeedbackForm, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/forms/feedback`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send Support Form
     *
     * @tags Forms
     * @name SendSupportFormV2FormsSupportPost
     * @summary Send Support Form
     * @request POST:/v2/forms/support
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    sendSupportFormV2FormsSupportPost: (data: SupportForm, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/forms/support`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send Ld Form
     *
     * @tags Forms
     * @name SendLdFormV2FormsLandingFormPost
     * @summary Send Ld Form
     * @request POST:/v2/forms/landing-form
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    sendLdFormV2FormsLandingFormPost: (data: LandingFormsDto, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/forms/landing-form`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send Personal Offer Form
     *
     * @tags Forms
     * @name SendPersonalOfferFormV2FormsPersonalOfferPost
     * @summary Send Personal Offer Form
     * @request POST:/v2/forms/personal-offer
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    sendPersonalOfferFormV2FormsPersonalOfferPost: (data: PersonalOffer, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/forms/personal-offer`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send Add Client Notification
     *
     * @tags Forms
     * @name SendAddClientNotificationV2FormsClientAddedPost
     * @summary Send Add Client Notification
     * @request POST:/v2/forms/client-added
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    sendAddClientNotificationV2FormsClientAddedPost: (data: AddClientAction, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/forms/client-added`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send Register Client Notification
     *
     * @tags Forms
     * @name SendRegisterClientNotificationV2FormsClientRegisteredPost
     * @summary Send Register Client Notification
     * @request POST:/v2/forms/client-registered
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    sendRegisterClientNotificationV2FormsClientRegisteredPost: (
      data: RegisterClientAction,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/forms/client-registered`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send Create Quiz Notification
     *
     * @tags Forms
     * @name SendCreateQuizNotificationV2FormsQuizCreatedPost
     * @summary Send Create Quiz Notification
     * @request POST:/v2/forms/quiz-created
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    sendCreateQuizNotificationV2FormsQuizCreatedPost: (data: CreateQuizAction, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/forms/quiz-created`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  userSessions = {
    /**
     * @description Update User Session Log
     *
     * @tags User Sessions
     * @name UpdateUserSessionLogAddUserSessionPost
     * @summary Update User Session Log
     * @request POST:/add_user_session
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateUserSessionLogAddUserSessionPost: (data: UserSessionLogDto, params: RequestParams = {}) =>
      this.http.request<any, HTTPValidationError>({
        path: `/add_user_session`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Count Online Users
     *
     * @tags User Sessions
     * @name CountOnlineUsersGetOnlineGet
     * @summary Count Online Users
     * @request GET:/get_online
     * @response `200` `any` Successful Response
     */
    countOnlineUsersGetOnlineGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/get_online`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Count Logins Last 24H
     *
     * @tags User Sessions
     * @name CountLoginsLast24HGetLastLoginsGet
     * @summary Count Logins Last 24H
     * @request GET:/get_last_logins
     * @response `200` `any` Successful Response
     */
    countLoginsLast24HGetLastLoginsGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/get_last_logins`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  landingForm = {
    /**
     * @description Landing Forms Reed Notification
     *
     * @tags LandingForm
     * @name LandingFormsReedNotificationV2LandingFormsReadIdPost
     * @summary Landing Forms Reed Notification
     * @request POST:/v2/LandingForms/read/{id}
     * @secure
     * @response `200` `any` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    landingFormsReedNotificationV2LandingFormsReadIdPost: (
      id: number,
      data: LandingFormsReedNotificationV2LandingFormsReadIdPostPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/v2/LandingForms/read/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  webhook = {
    /**
     * @description Webhook Signup Success
     *
     * @tags Webhook
     * @name WebhookSignupSuccessV2WebhookSignupSuccessPost
     * @summary Webhook Signup Success
     * @request POST:/v2/Webhook/signup-success
     * @response `200` `object` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    webhookSignupSuccessV2WebhookSignupSuccessPost: (data: SignupSuccessBody, params: RequestParams = {}) =>
      this.http.request<object, HTTPValidationError>({
        path: `/v2/Webhook/signup-success`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
}
